import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import { trackIntercomEvent } from "utils/intercomUtils";
import { trackHaddockPlanningShiftCreated } from "utils/posthogTracking";
import { connect } from "react-redux";
import moment from "moment";
// import { errorFormating } from "utils/utils";
import {
	FormGroup,
	FormControl,
	Dropdown,
	ButtonGroup,
	Button,
	Nav,
	Tab,
	OverlayTrigger,
	Tooltip,
} from "react-bootstrap";
import {
	FiCalendar,
	FiEdit2,
	FiMoreHorizontal,
	FiSettings,
	FiUpload,
	FiX,
	FiLock,
	FiFilter,
	FiUsers,
	FiTrash2,
	FiMapPin,
} from "react-icons/fi";
import { FaRegFilePdf, FaRegFileExcel } from "react-icons/fa6";
import { PiSmileySadBold, PiGridFourFill } from "react-icons/pi";
import { AiOutlineFunction } from "react-icons/ai";
import { BiSortAlt2 } from "react-icons/bi";
import { FaRegCopy } from "react-icons/fa";
import {
	HiClock,
	HiOutlineArrowUpOnSquare,
	HiOutlineArrowsPointingIn,
	HiOutlineArrowsPointingOut,
	HiOutlineCheck,
	HiOutlineChevronLeft,
	HiOutlineChevronRight,
	HiOutlineClock,
	HiOutlineEllipsisHorizontal,
	HiOutlineInformationCircle,
	HiOutlineLockClosed,
	HiOutlineLockOpen,
	HiOutlineMagnifyingGlass,
	HiOutlinePlus,
	HiOutlineSquare2Stack,
} from "react-icons/hi2";
import { FaMagic } from "react-icons/fa";
import Autosuggest from "react-autosuggest";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import ElapsedTimer, { parseStartMoment } from "components/Timer/ElapsedTimer";

import { showModal, hideModal, updateModalLoading } from "actions/modalActions";
import { registerUndoAndShowToast, clearUndoScope } from "actions/undoHistoryActions";
import {
	disablePlanToastStack,
	enablePlanToastStack,
} from "utils/toast/planToastStack";
import Layout from "components/Layout";
import DelayedMount from "components/DelayedMount";
import Loading from "components/Loading";
import PlanShiftEditModal from "components/Plans/PlanShiftEditModal";
import PlanShiftExchangeModal from "components/Plans/PlanShiftExchangeModal";
import EmployeeOrderModal from "components/Employees/EmployeeOrderModal";
import StaffingLevelEditModal from "components/Plans/StaffingLevelEditModal";
import TemporaryGroupEmployeesModal from "components/Plans/TemporaryGroupEmployeesModal";
import StaffingLevelCatalogModal, { STAFFING_LEVEL_MODAL_STYLE } from "components/StaffingLevels/StaffingLevelEditModal";
import PlanViewEditModal from "components/PlanViews/PlanViewEditModal";
import { translatePlanViewName } from "components/PlanViews/planViewColumns";
import PlanTable from "components/Plans/PlanTable";
import PlanStaffingLevels from "components/Plans/PlanStaffingLevels";
import PlanStaffingLevelsFractional from "components/Plans/PlanStaffingLevelsFractional";
import {
	getEffectiveNeeded,
	getStaffingAssignmentIntervals,
	isFractionalStaffingAssignment,
} from "components/Plans/planStaffingNeedsUtils";
import FractionalNeedsLimitCard from "components/Plans/staffing/FractionalNeedsLimitCard";
import PlanStaffingHourlyImproved from "components/Plans/PlanStaffingHourlyImproved";
import PlanStaffingHourlyPlanned from "components/Plans/PlanStaffingHourlyPlanned";
import PlanCounters from "components/Plans/PlanCounters";
import PlanMagicModal from "components/Plans/PlanMagicModal";
import PlanMagicModalV2 from "components/Plans/PlanMagicModalV2";
import PlanMagicPrerequisitesModal from "components/Plans/PlanMagicPrerequisitesModal";
import PlanMissingContractModal from "components/Plans/PlanMissingContractModal";
import PlanUserMissingContractModal from "components/Plans/PlanUserMissingContractModal";
import GroupPublished from "components/Groups/GroupPublishedModal";
import GroupStaffingLevelsEdit from "components/Groups/GroupStaffingLevelEditModal";
import GroupEditDrawer from "components/Groups/GroupEditDrawer";
import EmployeeFunctionEdit from "components/Employees/EmployeeFunctionEditModal";
import EmployeeContractEdit from "components/Employees/EmployeeContractEditModal";
import PlanOpenerModal from "components/Plans/PlanOpenerModal";
import PlanHourlyOpenerModal from "components/Plans/PlanHourlyOpenerModal";
import PlanCopyModal from "components/Plans/PlanCopyModal";
import PlanExport2PDFModal from "components/Plans/PlanExport2PDFModal";
import ShiftEditModal from "components/Shifts/ShiftEditModal";
import EmployeeEditModal from "components/Employees/EmployeeEditModal";
import FunctionEdit from "components/Functions/FunctionEditModal";
import UbicationEdit from "components/Ubications/UbicationEditModal";
import ShiftPatternEditModal from "components/ShiftPatterns/ShiftPatternEditModal";
import FloatingBar from "components/FloatingBar";
import PlanEmployeesMultiSelect from "components/PlanEmployeesMultiSelect/PlanEmployeesMultiSelect";
import PlanFunctionsMultiSelect from "components/PlanFunctionsMultiSelect/PlanFunctionsMultiSelect";
import AbsenceEditModal from "components/Absences/AbsenceEditModal";

import { StaffingContextMenu } from "components/Plans/PlanMenus";
import {
	isAdmin,
	isSupervisor,
	hasSubscriptionFeature,
	canEditShiftPatterns,
} from "utils/utils";
import * as plansActions from "actions/plansActions";
import * as groupsActions from "actions/groupsActions";
import * as shiftsActions from "actions/shiftsActions";
import * as rulesActions from "actions/rulesActions";
import * as functionsActions from "actions/functionsActions";
import * as timesActions from "actions/timesActions";
import * as employeesActions from "actions/employeesActions";
import * as ubicationsActions from "actions/ubicationsActions";
import * as calendarsActions from "actions/calendarsActions";
import {
	plansService,
	plansSocketService,
	employeesService,
	groupsService,
	accountsService,
	appService,
	iPlanService,
	staffingLevelsService,
	workflowsService,
} from "services";
import {
	shiftType,
	shiftTypeQuery,
	normalizeShiftType,
} from "services/shiftsService";
import {
	buildWorkflowAbsenceByAssignmentId,
	fetchApprovedWorkflowsForPlanPeriod,
	getPlanningAbsenceQueryRange,
	getWorkflowEmployeeId,
	logSelectedWorkflowAbsenceDiagnostics,
	logWorkflowAbsenceMatchDiagnostics,
	normalizeWorkflowForEdit,
	planReopenLog,
} from "utils/planWorkflowAbsences";
import {
	alignAccountAssignmentsToPlan,
	sortPlanAssignmentsByEmployeeIds,
} from "utils/planAssignmentsOrder";
import {
	isDaySelected,
	nextCheckedFromDayClick,
	setAssignmentDayChecked,
	setDaySelected,
	resolvePasteDaySelection,
} from "utils/planDaySelection";
import {
	isContractNotFoundPlanError,
	resolveEmployeesWithoutContractForDays,
} from "utils/planEmployeeContract";
import { buildMultigroupPlanSections } from "utils/multigroupPlanGrouping";
import { isHaddockEnvironment } from "utils/documentUtils";
import { normalizeEmployeeIds } from "utils/normalizeEmployeeIds";
import { showSuccessToast } from "utils/toast/showUndoableSuccessToast";
import { planGroupScope } from "utils/undo/scopeKeys";
import {
	buildPlanBulkDeleteInverse,
	buildCreateInverse,
	buildReplaceDefaultShiftInverse,
	buildPlanDeleteInverseFromCell,
	buildPlanMoveInverse,
	buildPlanPasteInverse,
	buildPlanBulkUpdateInverse,
	buildPlanResizeInverse,
	buildPlanSetFunctionsInverse,
	buildPlanSetUbicationsInverse,
	collectDefaultShiftRestoreBodies,
	collectAssignmentFieldSnapshots,
	collectUbicationPasteUpdates,
	collectSuccessfulPastePlans,
	collectSuccessfulPastePlansFromChunks,
	extractCreatedPlanId,
	extractCreatedPlanIdsFromChunkedPaste,
	extractCreatedPlanIdsFromResponses,
	fillMissingPastedAssignmentIds,
	findPlanAssignmentId,
	buildPlanRestoreBody,
	normalizePlanDay,
} from "utils/undo/planUndoHelpers";
import {
	restorePlanAssignment,
	unlockDefaultRestIfPresent,
} from "utils/undo/executeInverseRequests";
import { registerUndoRefreshHandler } from "utils/undo/undoRefreshRegistry";
import ResizablePanels from "components/ResizablePanels";
import Modal from "components/Modal";
import SimpleModal from "components/Modal/SimpleModal";
import UpgradeModal from "components/Modal/UpgradeModal";
import {
	PLAN_GRID_VIEWS,
	showsStaffingUnderPlan,
	supportsPlanAssignmentsPagination,
} from "components/Plans";

/** Tope del panel de cobertura: min(alto tabla, ratio del contenedor). */
const HOURS_NEEDS_MAX_CONTAINER_RATIO = 0.5;
const HOURS_NEEDS_VERTICAL_STORAGE_KEY = "plan_hours_vertical_size_v4";
const HOURS_NEEDS_RESIZER_PX = 10;

/** Paginación encubierta de assignments (vista Funciones). Ver docs/PLAN_LOAD_PAGINATION.md */
const PLAN_ASSIGNMENTS_PAGE_SIZE_FIRST = 20;
const PLAN_ASSIGNMENTS_PAGE_SIZE_NEXT = 50;
const PLAN_ASSIGNMENTS_PAGINATION_THRESHOLD = 40;
const PLAN_ASSIGNMENTS_SKELETON_CAP = 15;
import {
	applyOptimisticHourlyResizeToPlanAssignments,
	applyHourlyShiftDelta,
	prepareIntervalsForUpdate,
	resizeNeedsColumnExpand,
	resizeNeedsColumnExpandOnDays,
	splitAssignmentIntervalsByDay,
	getIntervalsAbsDurationMinutes,
	linkTouchingAssignmentsAcrossDays,
	collectAssignmentPaintDays,
	dropRestWhenShiftPaintsHour,
	addDaysYmd,
	hasPartialDayIntervals,
} from "components/Plans/hourlyShiftResize";
import { getContrastColor } from "utils/utils";
import { withTranslation } from "react-i18next";
import {
	convertFromUTC,
	convertToUTC,
	fixStartEndIntervals,
	parseClockMinutes,
} from "utils/datetime";
import ScheduleParser from "utils/parserIntelligentResponse";
import PlanIntelligentModal from "components/Plans/PlanIntelligentModal";
import SwitchView from "components/Plans/SwitchView";
import ChartsFrame from "components/Plans/ChartsFrame";
import ChartsEmptyState from "components/Plans/ChartsEmptyState";

var scrollPlanLeft = 0;
var scrollPlanTop = 0;

const getPlanAssignmentIntervals = (shiftAssignment) => {
	if (!shiftAssignment) return [];
	if (shiftAssignment.time_intervals_span?.length) {
		return shiftAssignment.time_intervals_span;
	}
	if (shiftAssignment.time_intervals?.length) {
		return shiftAssignment.time_intervals;
	}
	return shiftAssignment.shift?.time_intervals || [];
};

const isMagicAvailabilityInterval = (interval) => {
	const name = interval?.time_type?.name;
	if (name === "Disponibilidad" || name === "Availability") return true;
	return interval?.time_type?.work_time === false;
};

class Plan extends Component {
	constructor(props) {
		super(props);

		this._cachedEmployeeContracts = new Map();
		this.closeModal = this.closeModal.bind(this);
		this.openExportValoresCuentasModal =
			this.openExportValoresCuentasModal.bind(this);
		this.openExportPlanificacionModal =
			this.openExportPlanificacionModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.openNewMagicPlan = this.openNewMagicPlan.bind(this);
		this.openEmployeesOrderModal = this.openEmployeesOrderModal.bind(this);
		this.handleEmployeeOrderSaved = this.handleEmployeeOrderSaved.bind(this);
		this.openPlanOpener = this.openPlanOpener.bind(this);
		this.openPlanCopy = this.openPlanCopy.bind(this);
		this.openPlanExport2PDF = this.openPlanExport2PDF.bind(this);
		this.openNewShiftModal = this.openNewShiftModal.bind(this);
		this.openNewEmployeeModal = this.openNewEmployeeModal.bind(this);
		this.openNewFunctionModal = this.openNewFunctionModal.bind(this);
		this.openNewUbicationModal = this.openNewUbicationModal.bind(this);
		this.openNewShiftPatternModal = this.openNewShiftPatternModal.bind(this);
		this.openChangePublishedModal = this.openChangePublishedModal.bind(this);

		this.getAllAssignments = this.getAllAssignments.bind(this);
		this.handleEmployeeDrawerClose = this.handleEmployeeDrawerClose.bind(this);
		this.updateEmployeeIdsAndGetAllAssignments =
			this.updateEmployeeIdsAndGetAllAssignments.bind(this);
		this.getPlanAssignments = this.getPlanAssignments.bind(this);
		this.getAccountAssignments = this.getAccountAssignments.bind(this);
		this.getStaffingLevelAssignments =
			this.getStaffingLevelAssignments.bind(this);
		this.changeMonthHeader = this.changeMonthHeader.bind(this);
		this.handleDaySelection = this.handleDaySelection.bind(this);
		this.handleColumnSelection = this.handleColumnSelection.bind(this);
		this.handleRowSelection = this.handleRowSelection.bind(this);
		this.selectSingleDay = this.selectSingleDay.bind(this);
		this.handleNeedSelection = this.handleNeedSelection.bind(this);
		this.handleDayMenuClick = this.handleDayMenuClick.bind(this);
		this.handleShiftMenuClick = this.handleShiftMenuClick.bind(this);
		this.handleEditShift = this.handleEditShift.bind(this);
		this.handleRemoveShift = this.handleRemoveShift.bind(this);
		this.handleCopyShift = this.handleCopyShift.bind(this);
		this.handleMoveShift = this.handleMoveShift.bind(this);
		this.handleCopyPasteShift = this.handleCopyPasteShift.bind(this);
		this.handleReassignShiftInShiftsView =
			this.handleReassignShiftInShiftsView.bind(this);
		this.handleStaffingMenuClick = this.handleStaffingMenuClick.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.updatePlanScroll = this.updatePlanScroll.bind(this);
		this.openNewStaffingLevelModal = this.openNewStaffingLevelModal.bind(this);
		this.openEditStaffingLevelModal =
			this.openEditStaffingLevelModal.bind(this);
		this.updateStateAndReload = this.updateStateAndReload.bind(this);
		this.getShifts = this.getShifts.bind(this);
		this.syncRowHeights = this.syncRowHeights.bind(this);
		this.updateCounterScrollSpacer = this.updateCounterScrollSpacer.bind(this);
		this.updateNeedsCounterSpacer = this.updateNeedsCounterSpacer.bind(this);
		this.openNewPlanviewModal = this.openNewPlanviewModal.bind(this);

		this.refScrollPlan = React.createRef();
		this.refScrollCounter = React.createRef();
		this.refScrollNeeds = React.createRef();
		this.refResizablePanels = React.createRef();
		this.refHoursVerticalPanels = React.createRef();
		this.staffingHeaderRef = null;
		this.isPlanButtonActionRunning = false;
		this._sidebarDropInProgress = false;
		this._isSidebarDragging = false;
		this._sidebarDragShiftId = null;
		this._replacedDefaultRestsByCell = new Map();
		// Sync scroll: el evento `scroll` del navegador llega deferido (tras paint),
		// así que enlazamos wheel nativo (mismo frame) + corrección por scroll/rAF.
		this._scrollSyncLock = false;
		this._scrollLeader = "plan";
		this._scrollSyncRaf = null;
		this._scrollSyncUntil = 0;
		this._boundScrollPlan = null;
		this._boundScrollNeeds = null;
		this._boundScrollCounter = null;
		this._employeeGroupOrderIds = null;

		const group_id = parseInt(this.props.match.params.group);
		const groups_supervised = this.props.user.groups_supervised;
		const isSupervisorWithSuperpowers =
			isSupervisor() &&
			groups_supervised.length > 0 &&
			groups_supervised.some(
				(gs) => gs.id === parseInt(group_id) && !gs.read_only
			);
		const isSupervisorReadOnly =
			isSupervisor() &&
			groups_supervised.length > 0 &&
			groups_supervised.some(
				(gs) => gs.id === parseInt(group_id) && gs.read_only
			);
		const hasPrivileges = isSupervisorWithSuperpowers || isAdmin();

		const isSupervisorWithEditEmployees =
			isSupervisor() &&
			groups_supervised.length > 0 &&
			groups_supervised.some(
				(gs) => gs.id === parseInt(group_id) && gs.edit_employees
			);
		const isSupervisorWithEditShifts =
			isSupervisor() &&
			groups_supervised.length > 0 &&
			groups_supervised.some(
				(gs) => gs.id === parseInt(group_id) && gs.edit_shifts
			);

		const canEditShifts = isSupervisorWithEditShifts || isAdmin();
		const canEditEmployees = isSupervisorWithEditEmployees || isAdmin();

		const start = this.props.match.params.start;
		const end = this.props.match.params.end;
		const isLongPeriod = this._getIsLongPeriod(start, end);

		this.state = {
			loading: true, // first loading
			isLocked: false,
			isPlanKO: false,
			hasPrivileges,
			isSupervisorReadOnly,
			canEditShifts,
			canEditEmployees,
			canCreateFunctions: isAdmin(),
			canCreateUbications: isAdmin(),
			canCreateStaffingLevels: isAdmin(),
			canCreateShiftPatterns: canEditShiftPatterns(this.props.user),
			search_shift: "",
			search_staffing_shift: "",
			selected_employee_ids: [],
			selected_function_ids: [],
			search_ubication: "",
			update_employee_ids: [],
			plan_view_id: -1,
			ubication_id: -1,
			ubication_staffing_id: -1,
			function_staffing_id: -1,
			name: "", // staffing level name (filter)
			group_id,
			start,
			end,
			isLongPeriod,
			shift_list: props.shifts || [],
			ubication_list: props.select_ubications || [], // ubication list drag & drop
			select_ubications: props.select_ubications || [], // ubication option list
			copied_shift: "",
			day_selection: [],
			day_selection_copy: [],
			day_selection_dashed: [],
			needs_selection: [],
			plan_assignments: [],
			childGroupMemberships: {},
			collapsedGroupIds: {},
			plan_no_results: false,
			plan_load_complete: false,
			plan_pending_skeleton_count: 0,
			accounts_loading: true,
			plan_loading: true,
			staffing_loading: hasPrivileges ? true : false, // solo carga para admin/super
			staffing_hourly_loading: true,
			staffing_level_hourly_assignments: [],
			isExtendedView: false,
			needs_suggestions: [],
			staffing_level_assignments: [],
			staffing_level_current_assignments: [],
			no_contract: false,
			planIntelligentStatus: null,
			/** Solo UI: inicio del cronómetro de “Planificando con IA…”. No usar `planIntelligentStatus.start` del API (a veces es inicio del periodo planificado, hace días). */
			planIntelligentTimerStart: null,
			planBtnState: "",
			planViewMode: "grid",
			assigmentsData: [],
			graphicsLoading: false,
			working_hours_list: [],
			first_hour: "00:00",
			last_hour: "23:59",
			search_shift_type_id: "Trabajo,Automático",
			plan_option_functions: [],
			plan_option_ubications: [],
			new_plan: true,
			magicModalOpen: false,
			magicPrerequisitesMissing: [],
			magicPlanFlowActive: false,
			magicPlanFunctionsSnapshot: [],
			magicPlanUnresolvedFunctionIds: [],
			magicEmployeeDrawer: null,
			missingContractPromptEntries: [],
			userMissingContractModalOpen: false,
			highlightAvailabilityPalette: false,
			isSidebarDragging: false,
			showUpgradeModal: false,
			upgradeFeature: "",
			counterScrollSpacerHeight: 0,
			needsCounterSpacerWidth: 0,
			// Tope del panel de cobertura = min(alto tabla, 50% contenedor)
			hoursNeedsMaxHeightPx: 0,
			// No mostrar resizer/cobertura hasta tener staffing horario listo
			hoursNeedsRevealed: false,
			// true en F5/open; false al cambiar a Horas para 1.er paint ligero + velo
			hoursLayoutReady: true,
			// true en F5/open; false al switch → 1.er paint solo velo (sin grilla horas)
			hoursPlanMounted: true,
			groupDrawerOpen: false,
			groupDrawerTab: "info",
			groupDrawerOpenCreateNeed: false,
			approvedWorkflowAbsences: [],
			workflowAbsenceByAssignmentId: {},
			workflowAbsenceReopenSubmit: false,
			// plan_grid_view: PLAN_GRID_VIEWS.grid
		};
	}

	async componentDidMount() {
		enablePlanToastStack();
		const { group_id, start, end, hasPrivileges, isLongPeriod } = this.state;
		const { user } = this.props;

		// Resincronizar alturas/spacer al cambiar el tamaño de la ventana o el
		// zoom del navegador (evita que el plan haga scroll y los contadores no).
		window.addEventListener("resize", this.handleWindowResize);
		registerUndoRefreshHandler("plan_assignment", this._planUndoRefresh);

		// No redirigir por preset aquí: el usuario puede entrar con fechas explícitas
		// (p. ej. desde Recientes). El preset solo afecta al picker al abrir planificación.

		const storedGridView = localStorage.getItem("plan_grid_view");
		const storedMaxPlan = localStorage.getItem("max_plan");

		try {
			plansSocketService.connect({ group_id, hasPrivileges, user, start, end });
		} catch (error) {
			console.error("Error connecting to WebSocket:", error);
		}

		// El watcher centralizado en plansSocketService combina WS + polling
		// REST (vía Web Worker, no se throttea en background) + tab-visible +
		// reconnect, con deduplicación. Hace un check inicial inmediato, así
		// que también cubre el caso "el usuario recargó la página con un
		// plan ya en PROCESSING/FINISHED/ERROR".
		plansSocketService.subscribeToIntelligentPlanning(
			group_id,
			this.handleIntelligentPlanningMessage
		);

		// Call to getPlanIntelligentStatus to log the response
		plansService
			.getPlanIntelligentStatus(group_id)
			.then((response) => {
				if (response && response.result_plans) {
				}
				// Store the response in state
				this.setState(
					{
						planIntelligentStatus: response[0],
						planBtnState: response[0] ? response[0].state : "",
					},
					() => {
						if (response[0] && response[0].state === "ERROR") {
							this.props.showModal(
								{
									open: true,
									title: this.props.t("plan.intelligentPlan.errorExecuting"),
									style: { width: "400px" },
									message: (() => {
										try {
											if (
												response[0].response &&
												typeof response[0].response === "string"
											) {
												const errorObj = JSON.parse(response[0].response);
												return (
													errorObj.error ||
													this.props.t("plan.intelligentPlan.errorUnknown")
												);
											}
											return this.props.t("plan.intelligentPlan.errorUnknown");
										} catch (e) {
											console.error("Error al parsear el mensaje de error:", e);
											return this.props.t("plan.intelligentPlan.errorUnknown");
										}
									})(),
									closeModal: async () => {
										const response = await plansService.discardIntelligent(
											this.state.planIntelligentStatus.id
										);
										if (response.ok) {
											plansSocketService.unsubscribeIntelligentPlanning();
											this.setState(
												{
													planBtnState: "",
													planIntelligentStatus: null,
												},
												() => {
													plansSocketService.subscribeToIntelligentPlanning(
														this.state.group_id,
														this.handleIntelligentPlanningMessage
													);
												}
											);
											this.closeModal();
										} else {
											this.openAlertModal(
												this.props.t("plan.intelligentPlan.errorDiscarding")
											);
										}
									},
								},
								"alert"
							);
						}
					}
				);
			})
			.catch((error) => {
				throw error;
			});

		let group;
		try {
			[group] = await Promise.all([
				groupsService.getByIdForPlanning(group_id),
				this.props.getDefaultPlanView(),
				this.props.getWorkingHours(),
				this.getUbications(),
				this.props.getDefaultShift(),
				this.props.getShiftTypes(),
				this.props.getSelectableStaffingLevels(),
				this.props.getSelectableFunctions(),
				this.props.getSelectableEmployees({ group_id, page_size: 2000 }),
				this.getShifts(),
				this.props.getPlanViews(),
				this.props.getPlanViewScopes(),
				this.props.getSelectableTimeTypes(),
				this.props.getAttendanceShifts(),
				this.props.getPlanDays(group_id, start, end),
			]);
		} catch (error) {
			console.error("Error loading plan data:", error);
			this.setState({
				loading: false,
				error: error.message || this.props.t("plan.errorLoadingData"),
			});
			return;
		}

		this.setShowMax(storedMaxPlan);
		var plan_grid_view = parseInt(storedGridView) || PLAN_GRID_VIEWS.grid;
		// corrección de grid view para periodos largos
		if (isLongPeriod && plan_grid_view === PLAN_GRID_VIEWS.hours) {
			plan_grid_view = PLAN_GRID_VIEWS.default;
		}

		this.setState({
			plan_view_id: this.props.plan_view_default.id || -1,
			group,
			select_ubications: this.props.select_ubications,
			plan_grid_view,
			isExtendedView:
				plan_grid_view === PLAN_GRID_VIEWS.ubication_grouped ||
				plan_grid_view === PLAN_GRID_VIEWS.shifts,
		});
		if (hasPrivileges) {
			this.props.getGroupStaffingLevels(group_id);
		}
		if (group?.is_multigroup) {
			this.loadChildGroupMemberships(group);
		}

		planReopenLog("Plan.js montado (planificación escritorio ≥768px)", {
			group_id,
			start,
			end,
			plan_grid_view,
		});

		// asignments
		try {
			await this.loadEmployeeGroupOrder(group_id);
			await this.getPlanCalculations();
		} catch (error) {
			console.error("Error getting plan calculations:", error);
			this.setState({
				loading: false,
				error: error.message || this.props.t("plan.errorLoadingCalculations"),
			});
			return;
		}
	}

	updateGroup = (group) => {
		this.setState({
			group,
		});
		this._clearPlanUndoScope();
	};

	reloadPlan = async ({
		group_id = this.state.group_id,
		start = this.state.start,
		end = this.state.end,
	} = {}) => {
		const { hasPrivileges } = this.state;
		const user = this.props.user;

		// disconnect() borra watcher de IA + listeners; connect() sólo registra topics de colaboración.
		plansSocketService.disconnect();
		plansSocketService.connect({ group_id, hasPrivileges, user, start, end });
		plansSocketService.subscribeToIntelligentPlanning(
			group_id,
			this.handleIntelligentPlanningMessage
		);

		// El orden del grupo debe estar cargado antes de getPlanCalculations →
		// getAllAssignments → getPlanAssignments; si van en paralelo se pierde
		// la ordenación al cambiar de semana o de grupo.
		await this.loadEmployeeGroupOrder(group_id);
		const membershipGroup = this.state.group;
		await Promise.all([
			this.props.getPlanDays(group_id, start, end),
			this.getPlanCalculations(),
			membershipGroup?.is_multigroup
				? this.loadChildGroupMemberships(membershipGroup)
				: Promise.resolve(),
		]);
	};

	componentWillUnmount() {
		disablePlanToastStack();
		registerUndoRefreshHandler("plan_assignment", null);
		this._abortPlanAssignmentsLoad();
		// El watcher centralizado del servicio se detiene al hacer disconnect.
		plansSocketService.disconnect();
		window.removeEventListener("resize", this.handleWindowResize);
		clearTimeout(this._resizeSyncTimer);
		this.detachScrollSyncListeners();
		if (this._scrollSyncRaf != null) {
			cancelAnimationFrame(this._scrollSyncRaf);
			this._scrollSyncRaf = null;
		}
		if (this._needsSpacerObserver) {
			this._needsSpacerObserver.disconnect();
			this._needsSpacerObserver = null;
			this._needsSpacerObservedPlan = null;
			this._needsSpacerObservedNeeds = null;
		}
		if (this._needsTableHeightObserver) {
			this._needsTableHeightObserver.disconnect();
			this._needsTableHeightObserver = null;
			this._needsTableObserved = null;
		}
		if (this._hoursNeedsRevealRaf != null) {
			cancelAnimationFrame(this._hoursNeedsRevealRaf);
			this._hoursNeedsRevealRaf = null;
		}
		if (this._hoursLayoutReadyRaf != null) {
			cancelAnimationFrame(this._hoursLayoutReadyRaf);
			this._hoursLayoutReadyRaf = null;
		}
		if (this._hoursEnterTimer != null) {
			clearTimeout(this._hoursEnterTimer);
			this._hoursEnterTimer = null;
		}
		clearTimeout(this._rowHeightSyncTimer);
		if (this._rowHeightSyncRaf != null) {
			cancelAnimationFrame(this._rowHeightSyncRaf);
			this._rowHeightSyncRaf = null;
		}
		if (this._hourlyCountersRefreshIdleId != null) {
			if (typeof window.cancelIdleCallback === "function") {
				window.cancelIdleCallback(this._hourlyCountersRefreshIdleId);
			}
			this._hourlyCountersRefreshIdleId = null;
		}
		clearTimeout(this._hourlyCountersRefreshTimer);
		clearTimeout(this._availabilityHighlightTimer);
		clearTimeout(this._magicEmployeeRefreshTimer);
		clearTimeout(this._planEmployeeContractRefreshTimer);
	}

	componentDidUpdate(prevProps, prevState) {
		// Los contenedores de scroll se re-montan al cambiar vista/loading;
		// re-enlaza listeners nativos si los refs cambiaron.
		this.ensureScrollSyncListeners();

		if (
			this.state.magicPlanFlowActive &&
			(prevProps.group_staffing_levels !== this.props.group_staffing_levels ||
				prevState.plan_assignments !== this.state.plan_assignments ||
				prevState.staffing_level_assignments !==
					this.state.staffing_level_assignments)
		) {
			this.syncMagicPlanPrerequisites();
		}

		const isHours = this.state.plan_grid_view === PLAN_GRID_VIEWS.hours;
		const wasHours = prevState.plan_grid_view === PLAN_GRID_VIEWS.hours;

		// Al salir de Horas, resetear revelado/layout para el próximo open.
		if (wasHours && !isHours) {
			if (this._hoursLayoutReadyRaf != null) {
				cancelAnimationFrame(this._hoursLayoutReadyRaf);
				this._hoursLayoutReadyRaf = null;
			}
			if (this._hoursEnterTimer != null) {
				clearTimeout(this._hoursEnterTimer);
				this._hoursEnterTimer = null;
			}
			if (
				this.state.hoursNeedsRevealed ||
				this.state.hoursNeedsMaxHeightPx ||
				this.state.hoursLayoutReady ||
				this.state.hoursPlanMounted
			) {
				this.setState({
					hoursNeedsRevealed: false,
					hoursNeedsMaxHeightPx: 0,
					hoursLayoutReady: false,
					hoursPlanMounted: false,
				});
			}
			// Tras reconstruir la rejilla horaria en Horas, refrescar necesidades
			// de turno para la vista Funciones (evita counters desalineados al 1.er paint).
			if (
				showsStaffingUnderPlan(this.state.plan_grid_view) &&
				this._isPlanLoadComplete()
			) {
				this.getStaffingLevelAssignments();
			}
			return;
		}

		if (
			showsStaffingUnderPlan(this.state.plan_grid_view) &&
			this._isPlanLoadComplete() &&
			prevProps.staffing_level_assignments !==
				this.props.staffing_level_assignments
		) {
			this.getFilteredStaffingLevelAssignments();
		}

		// Carga nueva del plan (cambio de periodo/grupo): volver a ocultar
		// cobertura hasta que el staffing horario termine.
		if (isHours && !prevState.loading && this.state.loading) {
			if (
				this.state.hoursNeedsRevealed ||
				this.state.hoursNeedsMaxHeightPx
			) {
				this.setState({
					hoursNeedsRevealed: false,
					hoursNeedsMaxHeightPx: 0,
				});
			}
			return;
		}

		if (!isHours) return;

		// Datos listos pero panel aún oculto: medir tabla (montada en modo
		// measure) y revelar resizer+cobertura con la altura ya capada.
		if (
			!this.state.hoursNeedsRevealed &&
			this.state.hoursPlanMounted &&
			this.state.hoursLayoutReady &&
			!this.state.loading &&
			!this.state.staffing_hourly_loading
		) {
			this.tryRevealHoursNeedsPanel();
			return;
		}

		if (!this.state.hoursNeedsRevealed) return;

		const staffingChanged =
			prevProps.staffing_level_hourly_assignments !==
			this.props.staffing_level_hourly_assignments;
		const justRevealed =
			!prevState.hoursNeedsRevealed && this.state.hoursNeedsRevealed;
		if (justRevealed || staffingChanged) {
			this.updateNeedsCounterSpacer();
			if (justRevealed) {
				this._schedulePlanRowHeightSync();
			}
		}
	}

	/**
	 * Tras staffing listo: mide la tabla en el panel oculto y revela el split
	 * vertical con altura = min(tabla, 50% contenedor). Así no hay flash del
	 * resizer ni de un panel al 32%.
	 */
	tryRevealHoursNeedsPanel = () => {
		if (this.state.hoursNeedsRevealed) return;
		if (!this.state.hoursPlanMounted || !this.state.hoursLayoutReady) return;
		if (this.state.staffing_hourly_loading || this.state.loading) return;

		const needsEl = this.refScrollNeeds.current;
		if (!needsEl) {
			if (!this._hoursNeedsRevealRaf) {
				this._hoursNeedsRevealRaf = requestAnimationFrame(() => {
					this._hoursNeedsRevealRaf = null;
					this.tryRevealHoursNeedsPanel();
				});
			}
			return;
		}

		const table =
			needsEl.querySelector("#tableNeedsImproved") ||
			needsEl.querySelector("#tablePlannedOnly") ||
			needsEl.querySelector("#tableNeeds") ||
			needsEl.querySelector("table");
		if (!table) {
			if (!this._hoursNeedsRevealRaf) {
				this._hoursNeedsRevealRaf = requestAnimationFrame(() => {
					this._hoursNeedsRevealRaf = null;
					this.tryRevealHoursNeedsPanel();
				});
			}
			return;
		}

		const tableH = Math.ceil(table.scrollHeight);
		if (!tableH || tableH < 40) return;

		const cappedH = this.capHoursNeedsHeightPx(tableH);
		if (!cappedH) return;

		this.setState(
			{
				hoursNeedsRevealed: true,
				hoursNeedsMaxHeightPx: cappedH,
			},
			() => {
				requestAnimationFrame(() => {
					this.fitHoursNeedsPanelToTableHeight(cappedH);
					this.updateNeedsCounterSpacer();
					this._schedulePlanRowHeightSync();
				});
			}
		);
	};

	// Único punto de entrada de cambios de estado de la IA.
	// Lo invoca el watcher de plansSocketService combinando WS + polling REST
	// (vía Web Worker, no se throttea en background) + tab-visible + reconnect,
	// con deduplicación interna. El consumidor solo se ocupa de la UI.
	handleIntelligentPlanningMessage = (data) => {
		if (!data) return;

		const previous = this.state.planIntelligentStatus;
		const merged = { ...data };
		// El cronómetro no debe tomar `merged.start` mientras ya tenemos un inicio en cliente
		// (el API puede mandar el inicio del periodo planificado y disparar miles de minutos).
		// Tras F5, `planIntelligentTimerStart` es null: ahí sí usamos `merged.start` si parece
		// razonable para el job en curso (ISO reciente); si no, o es incoherente, usamos ahora.

		let nextTimerStart = this.state.planIntelligentTimerStart;
		if (merged.state === "FINISHED" || merged.state === "ERROR") {
			nextTimerStart = null;
		} else if (merged.state === "PROCESSING" && nextTimerStart == null) {
			const parsed = parseStartMoment(merged.start);
			const now = moment();
			// Usar `start` del API siempre que sea una fecha válida en el pasado.
			// Planificaciones IA pueden durar varios días; el tope de 48 h hacía
			// que el cronómetro se reiniciara al recargar la página.
			if (parsed && parsed.isValid() && !parsed.isAfter(now)) {
				nextTimerStart = parsed;
			} else {
				nextTimerStart = now;
			}
		}

		const previousState = previous?.state;
		const nextBtnState =
			data.state === "FINISHED"
				? "FINISHED"
				: data.state === "PROCESSING"
					? "PROCESSING"
					: data.state === "ERROR"
						? ""
						: "";

		this.setState(
			{
				planIntelligentStatus: merged,
				planBtnState: nextBtnState,
				planIntelligentTimerStart: nextTimerStart,
			},
			() => {
				if (merged.state === "FINISHED") {
					// Solo lanzamos el toast cuando es una transición real
					// (PROCESSING → FINISHED). Al recargar la página con un
					// FINISHED previo no queremos un toast fantasma.
					if (previousState === "PROCESSING") {
						this._clearPlanUndoScope();
						toastr.success(
							"Planificación con IA",
							"Planificación con IA finalizada con éxito",
							{ progressBar: true, timeOut: 3000 }
						);
						trackIntercomEvent("ai_schedule_planning_completed", {
							group_id: this.state.group_id,
							plan_id: merged.id,
						});
					}
				} else if (merged.state === "ERROR") {
					// El modal de error sí lo mostramos siempre que llegue
					// ERROR (incluso al cargar la página): el usuario tiene
					// que descartar el plan fallido para poder lanzar otro.
					trackIntercomEvent("ai_schedule_planning_failed", {
						group_id: this.state.group_id,
						plan_id: merged.id,
					});
					this.props.showModal(
						{
							open: true,
							title: "Error al ejecutar planificación inteligente",
							style: { width: "400px" },
							message: (() => {
								try {
									if (merged && typeof merged.response === "string") {
										const errorObj = JSON.parse(merged.response);
										return (
											errorObj.error || "Error desconocido en la planificación"
										);
									}
									return "Error desconocido en la planificación";
								} catch (e) {
									console.error("Error al parsear el mensaje de error:", e);
									return "Error desconocido en la planificación";
								}
							})(),
							closeModal: async () => {
								const response = await plansService.discardIntelligent(
									this.state.planIntelligentStatus.id
								);
								if (response.ok) {
									plansSocketService.unsubscribeIntelligentPlanning();
									this.setState(
										{
											planBtnState: "",
											planIntelligentStatus: null,
											planIntelligentTimerStart: null,
										},
										() => {
											plansSocketService.subscribeToIntelligentPlanning(
												this.state.group_id,
												this.handleIntelligentPlanningMessage
											);
										}
									);
									this.closeModal();
								} else {
									this.openAlertModal("Error al descartar planificación");
								}
							},
						},
						"alert"
					);
				}
				// PROCESSING: el watcher mantiene polling activo hasta
				// llegar a FINISHED/ERROR. Solo hace falta reflejar el
				// estado en la UI (ya hecho arriba).
			}
		);
	};

	syncRowHeights = () => {
		// Solo filas del plan principal y de la tabla de contadores: ignorar tablas
		// anidadas (necesidades horarias, staffing, etc.) que viven en el mismo scroll.
		const planRows = this.refScrollPlan.current?.querySelectorAll(
			"#tablePlan tbody tr"
		);
		const counterRows = this.refScrollCounter.current?.querySelectorAll(
			"#tableCounters tbody tr"
		);

		if (!planRows?.length || !counterRows?.length) {
			this.syncPlanHeaderHeights();
			return;
		}

		const isDisplayedRow = (row) =>
			window.getComputedStyle(row).display !== "none";

		// 1) Reset: quita cualquier altura inline previa (no tocar filas plegadas)
		Array.from(planRows).forEach((row) => {
			if (isDisplayedRow(row)) row.style.height = "";
		});
		Array.from(counterRows).forEach((row) => {
			if (isDisplayedRow(row)) row.style.height = "";
		});

		this.syncPlanHeaderHeights();

		if (planRows.length !== counterRows.length) {
			return;
		}

		// 2) Mide y sincroniza (misma cantidad de filas empleado ↔ contador).
		// Usar getBoundingClientRect (subpíxeles) + ceil: offsetHeight trunca y
		// en planes grandes (~0.4px/fila) el desfase acumulado desplaza turnos vs
		// contadores al bajar (p. ej. ~120px en 336 filas del plan 1617).
		const rowCount = planRows.length;
		for (let i = 0; i < rowCount; i++) {
			if (!isDisplayedRow(planRows[i]) || !isDisplayedRow(counterRows[i])) {
				continue;
			}
			const planHeight = planRows[i].getBoundingClientRect().height;
			const counterHeight = counterRows[i].getBoundingClientRect().height;
			const maxHeight = Math.ceil(Math.max(planHeight, counterHeight));

			planRows[i].style.height = `${maxHeight}px`;
			counterRows[i].style.height = `${maxHeight}px`;
		}

		// 3) TOTAL MULTIGRUPO vive en tfoot (plan + contadores): igualar altura
		// con la misma lógica, para que no quede más baja que los subtotales.
		const planFooterRows = this.refScrollPlan.current?.querySelectorAll(
			"#tablePlan tfoot tr"
		);
		const counterFooterRows = this.refScrollCounter.current?.querySelectorAll(
			"#tableCounters tfoot tr"
		);
		if (planFooterRows?.length && counterFooterRows?.length) {
			const footerCount = Math.min(
				planFooterRows.length,
				counterFooterRows.length
			);
			for (let i = 0; i < footerCount; i++) {
				planFooterRows[i].style.height = "";
				counterFooterRows[i].style.height = "";
				const maxHeight = Math.ceil(
					Math.max(
						planFooterRows[i].getBoundingClientRect().height,
						counterFooterRows[i].getBoundingClientRect().height
					)
				);
				planFooterRows[i].style.height = `${maxHeight}px`;
				counterFooterRows[i].style.height = `${maxHeight}px`;
			}
		}

		this.updateCounterScrollSpacer();
	};

	syncPlanHeaderHeights = () => {
		const planEl = this.refScrollPlan.current;
		const counterEl = this.refScrollCounter.current;
		const planHeaderRow = planEl?.querySelector("#tablePlan thead tr");
		const counterThead = counterEl?.querySelector("#tableCounters thead");
		const counterToolbarRow = counterEl?.querySelector(
			"#tableCounters thead tr.counter-toolbar-row"
		);
		const shiftFilters = planEl
			?.closest(".full-plan-container")
			?.querySelector(".pattern-filter .heading-filters");

		if (planHeaderRow) {
			planHeaderRow.style.height = "";
			planHeaderRow.querySelectorAll("th").forEach((th) => {
				th.style.height = "";
				th.style.minHeight = "";
			});
		}
		if (shiftFilters) shiftFilters.style.minHeight = "";

		const planHeaderH = planHeaderRow
			? planHeaderRow.getBoundingClientRect().height
			: 0;
		const counterTheadH = counterThead
			? counterThead.getBoundingClientRect().height
			: 0;
		const filtersH = shiftFilters
			? shiftFilters.getBoundingClientRect().height
			: 0;
		const maxHeaderHeight = Math.ceil(
			Math.max(planHeaderH, counterTheadH, filtersH)
		);

		if (!maxHeaderHeight) return;

		if (planHeaderRow) {
			planHeaderRow.style.height = `${maxHeaderHeight}px`;
			planHeaderRow.querySelectorAll("th").forEach((th) => {
				th.style.height = `${maxHeaderHeight}px`;
				th.style.minHeight = `${maxHeaderHeight}px`;
			});
		}
		if (shiftFilters) {
			shiftFilters.style.minHeight = `${maxHeaderHeight}px`;
		}

		if (counterToolbarRow && counterEl) {
			counterEl.style.setProperty(
				"--counter-toolbar-row-height",
				`${Math.ceil(counterToolbarRow.getBoundingClientRect().height)}px`
			);
		}

		const fullPlan = planEl?.closest(".full-plan-container");
		if (fullPlan) {
			fullPlan.style.setProperty(
				"--plan-double-header-height",
				`${maxHeaderHeight}px`
			);
		}
	};

	_capturePlanScrollFromDom = () => {
		const planEl = this.refScrollPlan.current;
		if (!planEl) return;

		scrollPlanLeft = planEl.scrollLeft;
		scrollPlanTop = planEl.scrollTop;
	};

	_isPlanScrollNearBottom = (planEl, thresholdPx = 2) => {
		if (!planEl) return false;
		const maxTop = Math.max(0, planEl.scrollHeight - planEl.clientHeight);
		return planEl.scrollTop >= maxTop - thresholdPx;
	};

	_restoreLinkedVerticalScroll = (preferBottom = false) => {
		const planEl = this.refScrollPlan.current;
		const counterEl = this.refScrollCounter.current;
		if (!planEl) return;

		const planMax = this._getScrollMax(planEl, "top");
		const counterMax = counterEl
			? this._getScrollMax(counterEl, "top")
			: planMax;
		const nextTop = preferBottom
			? Math.min(planMax, counterMax)
			: Math.min(scrollPlanTop, planMax);

		this._scrollSyncLock = true;
		planEl.scrollTop = nextTop;
		if (counterEl) {
			counterEl.scrollTop = nextTop;
		}
		this._scrollSyncLock = false;

		scrollPlanTop = nextTop;
	};

	updateCounterScrollSpacer = () => {
		requestAnimationFrame(() => {
			const planEl = this.refScrollPlan.current;
			const counterEl = this.refScrollCounter.current;
			if (!planEl || !counterEl) return;

			this._capturePlanScrollFromDom();
			const wasAtBottom = this._isPlanScrollNearBottom(planEl);

			const currentSpacerEl = counterEl.querySelector(".counter-scroll-spacer");
			const currentSpacerHeight = currentSpacerEl?.offsetHeight || 0;
			const counterContentScrollHeight =
				counterEl.scrollHeight - currentSpacerHeight;
			const planMaxScroll = planEl.scrollHeight - planEl.clientHeight;
			const targetCounterScrollHeight =
				planMaxScroll + counterEl.clientHeight;
			const nextSpacer = Math.max(
				0,
				Math.round(targetCounterScrollHeight - counterContentScrollHeight)
			);

			const currentSpacer = this.state.counterScrollSpacerHeight || 0;
			if (Math.abs(nextSpacer - currentSpacer) > 1) {
				this.setState({ counterScrollSpacerHeight: nextSpacer }, () => {
					requestAnimationFrame(() => {
						this._restoreLinkedVerticalScroll(wasAtBottom);
					});
				});
			}
		});
	};

	/**
	 * Compensa el ancho del panel de contadores (+ resizer) en la tabla de
	 * cobertura, para que las columnas alineen con el plan al scrollear al final.
	 * La cobertura ocupa todo el ancho; el plan solo el fragmento izquierdo.
	 */
	updateNeedsCounterSpacer = () => {
		requestAnimationFrame(() => {
			const planEl = this.refScrollPlan.current;
			const needsEl = this.refScrollNeeds.current;
			if (!planEl || !needsEl) return;

			const nextSpacer = Math.max(
				0,
				Math.round(needsEl.clientWidth - planEl.clientWidth)
			);
			const currentSpacer = this.state.needsCounterSpacerWidth || 0;
			if (Math.abs(nextSpacer - currentSpacer) > 1) {
				this.setState({ needsCounterSpacerWidth: nextSpacer });
			}

			this.ensureNeedsSpacerObserver();
			this.syncHoursNeedsMaxHeight();
		});
	};

	/**
	 * Tope del panel de cobertura: min(alto intrínseco de la tabla, 50% del
	 * contenedor vertical). Se puede achicar; no crecer dejando hueco ni
	 * comerse más de la mitad del layout.
	 */
	syncHoursNeedsMaxHeight = () => {
		if (this.state.plan_grid_view !== PLAN_GRID_VIEWS.hours) return;
		if (!this.state.hoursNeedsRevealed) return;

		const needsEl = this.refScrollNeeds.current;
		if (!needsEl) return;

		const table =
			needsEl.querySelector("#tableNeedsImproved") ||
			needsEl.querySelector("#tablePlannedOnly") ||
			needsEl.querySelector("#tableNeeds") ||
			needsEl.querySelector("table");
		if (!table) return;

		this.ensureNeedsTableHeightObserver(table);

		const tableH = Math.ceil(table.scrollHeight);
		if (!tableH || tableH < 40) return;

		const cappedH = this.capHoursNeedsHeightPx(tableH);
		if (!cappedH) return;

		const prevH = this.state.hoursNeedsMaxHeightPx || 0;
		if (Math.abs(cappedH - prevH) <= 1) {
			return;
		}

		const isFirstMeasure = prevH <= 0;
		this.setState({ hoursNeedsMaxHeightPx: cappedH }, () => {
			if (isFirstMeasure) {
				this.fitHoursNeedsPanelToTableHeight(cappedH);
			}
		});
	};

	/**
	 * min(alto tabla, 50% del espacio repartible del split vertical).
	 */
	capHoursNeedsHeightPx = (tableH) => {
		if (!tableH || tableH < 40) return 0;

		const panels = this.refHoursVerticalPanels.current;
		let containerH = 0;
		if (panels && typeof panels.getCurrentComponentSize === "function") {
			containerH = panels.getCurrentComponentSize();
		}
		if (containerH <= 0) {
			const layout = document.querySelector(".hours-layout-vertical");
			containerH = layout ? layout.clientHeight : 0;
		}

		const available = Math.max(0, containerH - HOURS_NEEDS_RESIZER_PX);
		if (available <= 0) return tableH;

		const halfCap = Math.floor(available * HOURS_NEEDS_MAX_CONTAINER_RATIO);
		return Math.max(80, Math.min(tableH, halfCap));
	};

	/**
	 * Sin tamaño guardado por el usuario, ancla el panel inferior al tope
	 * (tabla completa o 50% del contenedor).
	 */
	fitHoursNeedsPanelToTableHeight = (maxH) => {
		const stored = localStorage.getItem(HOURS_NEEDS_VERTICAL_STORAGE_KEY);
		if (stored) return;

		const panels = this.refHoursVerticalPanels.current;
		if (!panels || typeof panels.getCurrentComponentSize !== "function") {
			return;
		}

		const targetH = maxH || this.state.hoursNeedsMaxHeightPx;
		const containerH = panels.getCurrentComponentSize();
		const available = Math.max(0, containerH - HOURS_NEEDS_RESIZER_PX);
		if (available <= 0 || !targetH) return;

		const bottomPct = Math.min(100, (targetH / available) * 100);
		const next = panels.clampPanelsSize([100 - bottomPct, bottomPct]);
		panels.forceResize(next);
	};

	ensureNeedsTableHeightObserver = (table) => {
		if (typeof ResizeObserver === "undefined" || !table) return;

		if (!this._needsTableHeightObserver) {
			this._needsTableHeightObserver = new ResizeObserver(() => {
				this.syncHoursNeedsMaxHeight();
			});
		}

		if (this._needsTableObserved !== table) {
			if (this._needsTableObserved) {
				this._needsTableHeightObserver.unobserve(this._needsTableObserved);
			}
			this._needsTableHeightObserver.observe(table);
			this._needsTableObserved = table;
		}
	};

	ensureNeedsSpacerObserver = () => {
		if (typeof ResizeObserver === "undefined") return;

		const planEl = this.refScrollPlan.current;
		const needsEl = this.refScrollNeeds.current;
		if (!planEl || !needsEl) return;

		if (!this._needsSpacerObserver) {
			this._needsSpacerObserver = new ResizeObserver(() => {
				this.updateNeedsCounterSpacer();
			});
		}

		if (this._needsSpacerObservedPlan !== planEl) {
			if (this._needsSpacerObservedPlan) {
				this._needsSpacerObserver.unobserve(this._needsSpacerObservedPlan);
			}
			this._needsSpacerObserver.observe(planEl);
			this._needsSpacerObservedPlan = planEl;
		}

		if (this._needsSpacerObservedNeeds !== needsEl) {
			if (this._needsSpacerObservedNeeds) {
				this._needsSpacerObserver.unobserve(this._needsSpacerObservedNeeds);
			}
			this._needsSpacerObserver.observe(needsEl);
			this._needsSpacerObservedNeeds = needsEl;
		}
	};

	// El zoom del navegador y los cambios de tamaño de ventana alteran las
	// alturas visibles de los contenedores, por lo que hay que resincronizar
	// las alturas de fila y el spacer del contador (debounced).
	handleWindowResize = () => {
		clearTimeout(this._resizeSyncTimer);
		this._resizeSyncTimer = setTimeout(() => {
			this._schedulePlanRowHeightSync();
			this.updateNeedsCounterSpacer();
			this.syncHoursNeedsMaxHeight();
		}, 150);
	};

	_getIsLongPeriod = (start, end) => {
		const startDate = moment(start);
		const endDate = moment(end);
		const duration = endDate.diff(startDate, "days");
		const isLongPeriod = duration > 7; // Define a long period as more than 7 day
		return isLongPeriod;
	};

	_getWorkingHoursList(first_hour, last_hour) {
		const firstMinutes = parseClockMinutes(first_hour) ?? 0;
		const lastMinutes = parseClockMinutes(last_hour) ?? 0;
		const start = Math.floor(firstMinutes / 60) % 24;
		let end = Math.floor(lastMinutes / 60) % 24;
		const end_minutes = lastMinutes % 60;

		// Si hay minutos en el tiempo de finalización > 0, suma una hora más
		if (end_minutes > 0) {
			end += 1;
		}

		// Ajustar para turnos que terminan al día siguiente
		let length = end - start;
		if (length <= 0) {
			length += 24; // Asume un ciclo completo de 24 horas si el turno termina al día siguiente
		}

		const working_hours_list = new Array(length)
			.fill()
			.map((d, i) => (i + start) % 24);
		return working_hours_list;
	}

	_realignPlanHoursToWorkingList(prevHours, workingList) {
		if (!workingList?.length) {
			return prevHours || [];
		}

		const byHour = new Map(
			(prevHours || []).map((hourCell) => [Number(hourCell.hour), hourCell])
		);

		return workingList.map((hourNum) => {
			const existing = byHour.get(hourNum);
			if (existing) {
				return existing;
			}

			const H = String(hourNum).padStart(2, "0");
			const localHourStr = `${H}:00`;
			return {
				hour: hourNum,
				hour_utc: convertToUTC(localHourStr),
				count: 0,
				hour_assignments: [],
				pinta: false,
				halfHourInfo: [],
			};
		});
	}

	/**
	 * Fin del intervalo en el reloj del día calendario (24:00 = medianoche; 24:15 = 00:15 del día siguiente).
	 */
	_resolveIntervalDayViewEnd(interval, localStart, localEnd) {
		if (interval?.render_end_day) {
			return interval.render_end_day;
		}

		const ls = parseClockMinutes(localStart);
		const le = parseClockMinutes(localEnd);
		if (ls === null || le === null) return localEnd;

		// 24h degenerado (start===end, p. ej. 00:00-00:00): ocupa el día hasta medianoche.
		if (ls === le) {
			return "24:00";
		}

		if (localEnd === "00:00" && localStart !== "00:00") {
			return "24:00";
		}

		if (le < ls) {
			return `24:${String(le % 60).padStart(2, "0")}`;
		}

		return localEnd;
	}

	_getAssignmentPaintIntervals(assignment) {
		if (assignment?.time_intervals_overnight?.length) {
			return assignment.time_intervals_overnight;
		}
		if (assignment?.time_intervals_for_day?.length) {
			return assignment.time_intervals_for_day;
		}
		if (assignment?.time_intervals_from_shift) {
			return assignment.shift?.time_intervals || [];
		}
		return assignment?.time_intervals || [];
	}

	/**
	 * Minutos desde medianoche de un tiempo day-view, admitiendo `24:mm`.
	 * Reemplaza a la versión con moment en los bucles de rejilla: solo se
	 * comparan y restan instantes del mismo día, así que basta con enteros.
	 */
	_dayViewMinutes(dayViewTime, blockStartTime) {
		if (typeof dayViewTime === "string" && dayViewTime.startsWith("24:")) {
			const extraMinutes = parseInt(dayViewTime.split(":")[1], 10) || 0;
			const blockStart = parseClockMinutes(blockStartTime);
			if (blockStart === null) return 24 * 60 + extraMinutes;
			// Equivale a blockStart + (24 - blockHour) * 60 + extra.
			return 24 * 60 + (blockStart % 60) + extraMinutes;
		}
		return parseClockMinutes(dayViewTime);
	}

	/**
	 * Minutos tras medianoche (00:00–00:59) que siguen perteneciendo al día calendario actual.
	 */
	_getPostMidnightMinutes(localStart, localEnd, interval) {
		if (
			parseClockMinutes(localStart) === null ||
			parseClockMinutes(localEnd) === null
		) {
			return 0;
		}

		const dayViewEnd = this._resolveIntervalDayViewEnd(
			interval,
			localStart,
			localEnd
		);
		if (!dayViewEnd.startsWith("24:")) return 0;

		const mins = parseInt(dayViewEnd.split(":")[1], 10);
		return Number.isFinite(mins) && mins > 0 ? mins : 0;
	}

	_planHasPostMidnightExtension(planAssignments) {
		if (!planAssignments?.length) return false;

		let found = false;
		planAssignments.forEach((assignment) => {
			assignment.plans?.forEach((plan) => {
				plan.assignments?.forEach((shiftAssignment) => {
					const raw = shiftAssignment.time_intervals_from_shift
						? shiftAssignment.shift?.time_intervals
						: shiftAssignment.time_intervals;
					(raw || []).forEach((interval) => {
						if (!interval?.start || !interval?.end) return;
						const start = convertFromUTC(interval.start);
						const end = convertFromUTC(interval.end);
						if (this._getPostMidnightMinutes(start, end, interval) > 0) {
							found = true;
						}
					});
				});
			});
		});
		return found;
	}

	/**
	 * Hora de fin para pedir necesidades de madrugada a la API (p. ej. turno hasta 01:45 → "01:59").
	 */
	_getPostMidnightStaffingEndHour(planAssignments) {
		let maxMinutes = 0;

		(planAssignments || []).forEach((assignment) => {
			assignment.plans?.forEach((plan) => {
				(
					plan.plan_assignments_with_overnight ||
					plan.assignments ||
					[]
				).forEach((shiftAssignment) => {
					const rawIntervals = this._getAssignmentPaintIntervals(shiftAssignment);

					(rawIntervals || []).forEach((interval) => {
						if (!interval?.start || !interval?.end) return;
						const start = convertFromUTC(interval.start);
						const end = convertFromUTC(interval.end);
						const ls = parseClockMinutes(start);
						const le = parseClockMinutes(end);

						if (shiftAssignment.time_intervals_overnight?.length) {
							if (ls !== null && le !== null && le > ls) {
								const mins = le - ls;
								if (mins > maxMinutes) maxMinutes = mins;
							}
							return;
						}

						const mins = this._getPostMidnightMinutes(start, end, interval);
						if (mins > maxMinutes) maxMinutes = mins;
					});
				});
			});
		});

		if (maxMinutes <= 0) return null;

		const endHour = Math.min(23, Math.ceil(maxMinutes / 60));
		return `${String(endHour).padStart(2, "0")}:59`;
	}

	/**
	 * Horas de rejilla por día calendario (puede incluir 0h separado del bloque matinal si hay madrugada).
	 */
	_computePerDayWorkingHoursMap(
		planAssignments,
		planDays,
		globalFallbackList,
		staffingLevelHourlyAssignments = null
	) {
		const dayOrder = (planDays || []).map((d) => d.day);
		const neededByDay = {};

		(planAssignments || []).forEach((pa) => {
			pa.plans?.forEach((plan) => {
				if (!neededByDay[plan.day]) neededByDay[plan.day] = new Set();

				(
					plan.plan_assignments_with_overnight ||
					plan.assignments ||
					[]
				).forEach((shiftAssignment) => {
					const rawIntervals = this._getAssignmentPaintIntervals(shiftAssignment);

					if (!rawIntervals?.length) return;

					fixStartEndIntervals(rawIntervals).forEach((interval) => {
						if (!interval?.start || !interval?.end) return;
						const start = convertFromUTC(interval.start);
						const end = convertFromUTC(interval.end);
						this._addShiftIntervalHoursToNeededSet(
							neededByDay[plan.day],
							start,
							end
						);
					});
				});
			});
		});

		this._mergeStaffingNeedsIntoNeededByDay(
			neededByDay,
			staffingLevelHourlyAssignments
		);

		const result = {};
		const visualGapHoursByDay = {};
		dayOrder.forEach((day) => {
			const needed = neededByDay[day] || new Set();

			if (needed.size === 0) {
				result[day] = globalFallbackList ? [...globalFallbackList] : [];
				visualGapHoursByDay[day] = [];
				return;
			}

			const beforeFill = new Set(needed);
			this._fillEarlyMorningGapInNeededSet(needed);
			visualGapHoursByDay[day] = [...needed]
				.filter((h) => !beforeFill.has(h))
				.sort((a, b) => a - b);

			const range = this._minimalArcRangeFromHourSet(needed);
			let list = this._getWorkingHoursList(range.first_hour, range.last_hour);

			result[day] = this._normalizeDayWorkingHoursList(list, needed.has(0));
		});

		return { dayHoursMap: result, visualGapHoursByDay };
	}

	_unionWorkingHoursLists(lists) {
		const set = new Set();
		(lists || []).forEach((list) => {
			(list || []).forEach((h) => set.add(h));
		});
		return [...set].sort((a, b) => a - b);
	}

	/**
	 * Si hay madrugada (columna 0h) y un bloque diurno separado, rellena las horas
	 * intermedias para que la rejilla no salte de 0h/1h al primer turno del día.
	 * No aplica si el mismo día ya tiene turnos nocturnos (>=18h): el arco envuelve por la tarde.
	 */
	_fillEarlyMorningGapInNeededSet(needed) {
		if (!needed?.size || !needed.has(0)) return needed;

		const sorted = [...needed].sort((a, b) => a - b);
		if (sorted.some((h) => h >= 18)) return needed;

		const groups = [];
		let group = [sorted[0]];
		for (let i = 1; i < sorted.length; i++) {
			if (sorted[i] === sorted[i - 1] + 1) {
				group.push(sorted[i]);
			} else {
				groups.push(group);
				group = [sorted[i]];
			}
		}
		groups.push(group);

		if (groups.length < 2 || groups[0][0] !== 0) return needed;

		const earlyMax = groups[0][groups[0].length - 1];
		const nextMin = groups[1][0];

		for (let h = earlyMax + 1; h < nextMin; h++) {
			needed.add(h);
		}

		return needed;
	}

	/**
	 * Coloca 0h al inicio del día si hay madrugada; elimina el 0 final por wrap (10..23,0).
	 */
	_normalizeDayWorkingHoursList(hoursList, needsHourZero = false) {
		if (!hoursList?.length) return hoursList || [];

		let list = [...hoursList];

		if (list[0] > 0 && list[list.length - 1] === 0) {
			list = list.slice(0, -1);
		}

		if (needsHourZero || list.includes(0)) {
			list = [0, ...list.filter((h) => h !== 0).sort((a, b) => a - b)];
		}

		return list;
	}

	/**
	 * Marca las horas locales (0–23) cubiertas por un intervalo ya convertido a HH:mm local.
	 */
	_addShiftIntervalHoursToNeededSet(needed, startTime, endTime) {
		const ls = parseClockMinutes(startTime);
		const le = parseClockMinutes(endTime);
		if (ls === null || le === null) return;

		const startHour = Math.floor(ls / 60);
		const endHour = Math.floor(le / 60);
		const endMinutes = le % 60;
		const adjustedEndHour = endMinutes > 0 ? endHour + 1 : endHour;

		const crossesMidnight = le < ls || (le === 0 && ls !== 0);

		if (ls === le) {
			const startHour = Math.floor(ls / 60) % 24;
			for (let h = startHour; h < 24; h++) {
				needed.add(h);
			}
			return;
		}

		if (crossesMidnight) {
			for (let h = startHour; h <= 23; h++) {
				needed.add(h);
			}
		} else {
			const endExclusive = Math.min(adjustedEndHour, 24);
			for (let h = startHour; h < endExclusive && h < 24; h++) {
				needed.add(h);
			}
		}
	}

	/**
	 * Recorre todas las asignaciones y devuelve el conjunto de horas locales necesarias en la rejilla.
	 * Evita combinar solo min/max lineal (rompe turnos 22→02 junto con turnos por la mañana).
	 */
	_collectNeededHoursFromAssignments(planAssignments) {
		const needed = new Set();

		if (!planAssignments || !Array.isArray(planAssignments)) {
			return needed;
		}

		planAssignments.forEach((assignment) => {
			assignment.plans?.forEach((plan) => {
				plan.assignments?.forEach((shiftAssignment) => {
					const timeIntervalsRaw = shiftAssignment.time_intervals_from_shift
						? shiftAssignment.shift?.time_intervals
						: shiftAssignment.time_intervals;

					if (!timeIntervalsRaw?.length) return;

					const intervals = fixStartEndIntervals(timeIntervalsRaw);

					intervals.forEach((interval) => {
						if (!interval.start || !interval.end) return;

						const startTime = convertFromUTC(interval.start);
						const endTime = convertFromUTC(interval.end);

						this._addShiftIntervalHoursToNeededSet(needed, startTime, endTime);
					});
				});
			});
		});

		return needed;
	}

	_mergeNeedsStaffingIntoHourSet(set, staffingLevelHourlyAssignments) {
		if (!staffingLevelHourlyAssignments?.length) return;

		staffingLevelHourlyAssignments.forEach((assignment) => {
			(assignment.counters || []).forEach((day) => {
				(day.hours || []).forEach((hourEntry) => {
					const needCount = Number(hourEntry.needed) || 0;
					if (needCount <= 0 || !hourEntry.hour) return;

					const local = convertFromUTC(hourEntry.hour);
					if (!local) return;

					const m = moment(local, "HH:mm");
					if (!m.isValid()) return;

					set.add(m.hour());
				});
			});
		});
	}

	/**
	 * Añade al mapa por día las horas con necesidad horaria (staffing_level_hourly_assignments).
	 * Sin esto, plan.working_hours_list puede terminar con el último turno (p. ej. 20h) aunque
	 * existan necesidades a las 21:00–21:30, y la tabla de cobertura no pinta esas columnas.
	 */
	_mergeStaffingNeedsIntoNeededByDay(
		neededByDay,
		staffingLevelHourlyAssignments
	) {
		if (!staffingLevelHourlyAssignments?.length) return;

		staffingLevelHourlyAssignments.forEach((assignment) => {
			(assignment.counters || []).forEach((day) => {
				const dayKey = day.day;
				if (!neededByDay[dayKey]) neededByDay[dayKey] = new Set();

				(day.hours || []).forEach((hourEntry) => {
					const needCount = Number(hourEntry.needed) || 0;
					if (needCount <= 0 || !hourEntry.hour) return;

					const local = convertFromUTC(hourEntry.hour);
					if (!local) return;

					const m = moment(local, "HH:mm");
					if (!m.isValid()) return;

					neededByDay[dayKey].add(m.hour());
				});
			});
		});
	}

	_mergeClockRangeIntoHourSet(set, firstHM, lastHM) {
		if (!firstHM || !lastHM) return;

		const sm = moment(firstHM, "HH:mm");
		const em = moment(lastHM, "HH:mm");
		if (!sm.isValid() || !em.isValid()) return;

		let startH = sm.hour();
		let endH = em.hour();
		if (em.minute() > 0 || em.second() > 0) {
			endH += 1;
		}

		if (endH <= startH) {
			for (let h = startH; h < 24; h++) {
				set.add(h);
			}
			for (let h = 0; h < endH; h++) {
				set.add(h);
			}
		} else {
			const limit = Math.min(endH, 24);
			for (let h = startH; h < limit; h++) {
				set.add(h);
			}
		}
	}

	/**
	 * Menor arco continuo en el reloj de 24h que cubre todas las horas requeridas (rellena huecos intermedios).
	 */
	_minimalArcRangeFromHourSet(needed) {
		const sorted = [...needed].sort((a, b) => a - b);
		const k = sorted.length;

		if (k === 0) {
			return { first_hour: "00:00", last_hour: "23:59" };
		}
		if (k === 24) {
			return { first_hour: "00:00", last_hour: "23:59" };
		}

		let maxGap = -1;
		let gapAfterIndex = 0;

		for (let i = 0; i < k - 1; i++) {
			const gap = sorted[i + 1] - sorted[i] - 1;
			if (gap > maxGap) {
				maxGap = gap;
				gapAfterIndex = i;
			}
		}

		const wrapGap = sorted[0] + 24 - sorted[k - 1] - 1;
		if (wrapGap > maxGap) {
			gapAfterIndex = k - 1;
		}

		const arcStart = sorted[(gapAfterIndex + 1) % k];
		const arcEnd = sorted[gapAfterIndex];

		return {
			first_hour: `${String(arcStart).padStart(2, "0")}:00`,
			last_hour: `${String(arcEnd).padStart(2, "0")}:59`,
		};
	}

	/**
	 * Calcula el rango de horas real basándose en TODOS los turnos (incluyendo work_time=false)
	 * @param {Array} planAssignments - Array de asignaciones del plan
	 * @returns {Object} - Objeto con first_hour y last_hour calculados
	 */
	_calculateRealWorkingHoursRange(planAssignments) {
		const needed = this._collectNeededHoursFromAssignments(
			planAssignments || []
		);
		if (needed.size === 0) {
			return {
				first_hour: "00:00",
				last_hour: "23:59",
			};
		}
		return this._minimalArcRangeFromHourSet(needed);
	}

	/**
	 * Calcula el rango de horas (first_hour/last_hour) a partir de las necesidades
	 * (staffing_level_hourly_assignments). Solo se consideran entradas con needed > 0.
	 * Cada entrada (ej. "09:15:00Z") cubre un bloque de 15 minutos dentro de su hora,
	 * por lo que para la hora de fin sumamos 1 hora (la siguiente en punto) para
	 * garantizar que esa hora aparezca en el working_hours_list.
	 *
	 * @param {Array} staffingLevelHourlyAssignments
	 * @returns {Object} { first_hour, last_hour, hasNeeds }
	 */
	_calculateNeedsHoursRange(staffingLevelHourlyAssignments) {
		if (
			!staffingLevelHourlyAssignments ||
			staffingLevelHourlyAssignments.length === 0
		) {
			return { first_hour: "23:59", last_hour: "00:00", hasNeeds: false };
		}

		let minHour = 24;
		let maxHour = -1;
		let hasNeeds = false;

		staffingLevelHourlyAssignments.forEach((assignment) => {
			(assignment.counters || []).forEach((day) => {
				(day.hours || []).forEach((hourEntry) => {
					const needed = Number(hourEntry.needed) || 0;
					if (needed <= 0) return;
					if (!hourEntry.hour) return;

					const local = convertFromUTC(hourEntry.hour);
					if (!local) return;

					const m = moment(local, "HH:mm");
					if (!m.isValid()) return;

					const startHour = m.hour();

					hasNeeds = true;
					minHour = Math.min(minHour, startHour);
					maxHour = Math.max(maxHour, startHour + 1);
				});
			});
		});

		if (!hasNeeds) {
			return { first_hour: "23:59", last_hour: "00:00", hasNeeds: false };
		}

		const first_hour = `${minHour.toString().padStart(2, "0")}:00`;
		const last_hour = `${Math.min(maxHour, 23).toString().padStart(2, "0")}:59`;

		return { first_hour, last_hour, hasNeeds: true };
	}

	/**
	 * Verifica si hay turnos activos en un rango de horas específico
	 * @param {Array} planAssignments - Array de asignaciones del plan
	 * @param {string} startHour - Hora de inicio del rango (formato "HH:mm")
	 * @param {string} endHour - Hora de fin del rango (formato "HH:mm")
	 * @returns {boolean} - true si hay turnos activos en el rango
	 */
	_hasActiveShiftsInHourRange(planAssignments, startHour, endHour) {
		if (!planAssignments || planAssignments.length === 0) {
			return false;
		}

		const startMoment = moment(startHour, "HH:mm");
		const endMoment = moment(endHour, "HH:mm");

		// Si el rango cruza la medianoche, ajustar
		if (endMoment.isBefore(startMoment)) {
			endMoment.add(1, "day");
		}

		for (const assignment of planAssignments) {
			if (!assignment.plans) continue;

			for (const plan of assignment.plans) {
				if (!plan.active) continue;

				// Verificar en la estructura de assignments tradicional
				if (plan.assignments) {
					for (const shift of plan.assignments) {
						if (!shift.time_intervals) continue;

						const intervals = shift.time_intervals_from_shift
							? shift.shift.time_intervals
							: shift.time_intervals;

						if (!intervals || intervals.length === 0) continue;

						// Solo considerar turnos de trabajo, no descansos
						const shiftType = shift.shift?.type || "Unknown";
						if (shiftType === "Descanso") {
							continue; // Saltar turnos de descanso
						}

						for (const interval of intervals) {
							const intervalStart = moment(
								convertFromUTC(interval.start),
								"HH:mm"
							);
							const intervalEnd = moment(convertFromUTC(interval.end), "HH:mm");

							// Si el intervalo cruza la medianoche, ajustar
							if (intervalEnd.isBefore(intervalStart)) {
								intervalEnd.add(1, "day");
							}

							// Verificar si el intervalo se solapa con el rango
							if (
								intervalStart.isBefore(endMoment) &&
								intervalEnd.isAfter(startMoment)
							) {
								return true; // Hay un turno activo en el rango
							}
						}
					}
				}

				// Verificar en la estructura de hours (para vista de horas)
				if (plan.hours) {
					for (const hour of plan.hours) {
						if (!hour.hour_assignments) continue;

						for (const hourAssignment of hour.hour_assignments) {
							if (!hourAssignment.assignment) continue;

							const shift = hourAssignment.assignment;
							if (!shift.time_intervals) continue;

							const intervals = shift.time_intervals_from_shift
								? shift.shift.time_intervals
								: shift.time_intervals;

							if (!intervals || intervals.length === 0) continue;

							// Solo considerar turnos de trabajo, no descansos
							const shiftType = shift.shift?.type || "Unknown";
							if (shiftType === "Descanso") {
								continue; // Saltar turnos de descanso
							}

							for (const interval of intervals) {
								const intervalStart = moment(
									convertFromUTC(interval.start),
									"HH:mm"
								);
								const intervalEnd = moment(
									convertFromUTC(interval.end),
									"HH:mm"
								);

								// Si el intervalo cruza la medianoche, ajustar
								if (intervalEnd.isBefore(intervalStart)) {
									intervalEnd.add(1, "day");
								}

								// Verificar si el intervalo se solapa con el rango
								if (
									intervalStart.isBefore(endMoment) &&
									intervalEnd.isAfter(startMoment)
								) {
									return true; // Hay un turno activo en el rango
								}
							}
						}
					}
				}
			}
		}

		return false; // No hay turnos activos en el rango
	}

	async getPlanCalculations() {
		const { group_id, start, end, plan_view_id, selected_employee_ids } =
			this.state;

		try {
			const response = await plansService.getPlanCalculations({
				group_id,
				start,
				end,
				plan_view_id,
				...this._getFunctionFilterForApi(),
				employee_ids: selected_employee_ids,
			});

			const plan_state = response.state ? response.state : "CLOSED";
			const isLocked = plan_state === "OPEN";
			const isPlanKO = plan_state === "ERROR";

			if (plan_state === "CLOSED") {
				await this.getAllAssignments();
			} else if (plan_state === "ERROR") {
				this.setState({
					loading: false,
					error: this.props.t("plan.errorCalculatingTitle"),
				});
				this.openAlertModal(
					this.props.t("plan.errorCalculatingMsg"),
					this.props.t("plan.errorLoadingDataTitle")
				);
			} else {
				setTimeout(() => this.getPlanCalculations(), 2000);
			}

			this.setState({
				isLocked,
				isPlanKO,
			});
		} catch (error) {
			console.error("Error in getPlanCalculations:", error);
			this.setState({
				loading: false,
				error: error.message || this.props.t("plan.errorObtainingCalculations"),
			});
		}
	}

	// get data
	handleEmployeeDrawerClose = (hasDataChanges = false) => {
		if (hasDataChanges) {
			this.getAllAssignments();
		}
	};

	_supportsPlanAssignmentsPagination(
		view = this.state.plan_grid_view
	) {
		return supportsPlanAssignmentsPagination(view);
	}

	_shouldPaginatePlanAssignments() {
		return (
			this._supportsPlanAssignmentsPagination() &&
			(this.props.select_employees?.length || 0) >
				PLAN_ASSIGNMENTS_PAGINATION_THRESHOLD
		);
	}

	/**
	 * Evita el empty de necesidades (p. ej. “solo 7 días”) a mitad de tabla
	 * durante la carga paginada — bug María/Malgorzata.
	 */
	_shouldDeferStaffingUnderPlan() {
		if (!showsStaffingUnderPlan(this.state.plan_grid_view)) {
			return false;
		}
		if (this._isPlanLoadComplete()) {
			return false;
		}
		return (
			(this.props.select_employees?.length || 0) >
			PLAN_ASSIGNMENTS_PAGINATION_THRESHOLD
		);
	}

	/** Durante paginación, saltar rejilla horaria salvo en vista Horas. */
	_shouldSkipHoursGridOnPaginatedFetch(trackPagination) {
		return (
			trackPagination &&
			this.state.plan_grid_view !== PLAN_GRID_VIEWS.hours
		);
	}

	/**
	 * Tras paginar en Funciones/Simple/…, plans[].hours no se construye (skipHoursGrid).
	 * Entrar en vista Horas sin rebuild → crash en getHourlyPlanRowContentList (.map).
	 */
	_planHoursGridMissing() {
		if (this._hoursGridSkipped) return true;
		const assignments = this.state.plan_assignments || [];
		if (!assignments.length) return false;
		const sample = assignments[0]?.plans?.[0];
		return sample != null && !Array.isArray(sample.hours);
	}

	/**
	 * Construye plans[].hours sobre assignments ya en memoria (sin red).
	 * Usado al entrar en Horas tras skipHoursGrid con carga completa.
	 * Batches + yield para no congelar el main thread (~336 emp. × días × horas).
	 */
	async _rebuildPlanHoursGridLocally() {
		const source = this.state.plan_assignments || [];
		if (!source.length) {
			this._hoursGridSkipped = false;
			return { ok: true, loadedCount: 0 };
		}

		const batchSize = PLAN_ASSIGNMENTS_PAGE_SIZE_NEXT;
		let accumulated = [];

		for (let i = 0; i < source.length; i += batchSize) {
			if (this.state.plan_grid_view !== PLAN_GRID_VIEWS.hours) {
				return { ok: false, aborted: true };
			}

			const batch = source.slice(i, i + batchSize);
			const isFirst = i === 0;

			// Reutiliza getPlanAssignments (overnight + hours) con datos en memoria.
			const result = await this.getPlanAssignments(undefined, {
				append: !isFirst,
				baseAssignments: accumulated,
				trackPagination: false,
				prefetchedResponse: {
					ok: true,
					data: batch,
				},
			});

			if (!result?.ok) {
				return result || { ok: false };
			}

			accumulated = result.assignments || accumulated;
			await this._yieldToBrowser();
		}

		this._hoursGridSkipped = false;
		return {
			ok: true,
			loadedCount: accumulated.length,
			assignments: accumulated,
		};
	}

	_abortPlanAssignmentsLoad() {
		if (this._planAssignmentsAbortController) {
			this._planAssignmentsAbortController.abort();
			this._planAssignmentsAbortController = null;
		}
	}

	/**
	 * Si una carga paginada abortada/stale era la activa, limpia overlays de loading
	 * (evita accounts_loading atascado y panel de contadores bloqueado).
	 */
	_releaseStalePaginatedLoad(loadId) {
		if (loadId !== this._planAssignmentsLoadId) return;
		if (
			this._planAssignmentsAbortController &&
			!this._planAssignmentsAbortController.signal.aborted
		) {
			return;
		}
		this.setState({
			accounts_loading: false,
			plan_loading: false,
			loading: false,
			staffing_loading: false,
		});
	}

	_getPlanPendingSkeletonCount(loadedCount, totalCount) {
		if (!totalCount || loadedCount >= totalCount) return 0;
		return Math.min(
			PLAN_ASSIGNMENTS_SKELETON_CAP,
			totalCount - loadedCount
		);
	}

	/**
	 * Total esperado para skeletons.
	 * Prioridad: total de API (sticky) > selectables solo como fallback inicial.
	 * No usar Math.max(selectables): si hay más selectables que filas de plan,
	 * los skeletons nunca llegan a 0 hasta loadComplete y la tabla “miente”.
	 */
	_resolvePlanAssignmentsTotalItems(apiTotal = 0) {
		if (apiTotal > 0) {
			this._planAssignmentsTotalItems = apiTotal;
			return apiTotal;
		}
		if (this._planAssignmentsTotalItems > 0) {
			return this._planAssignmentsTotalItems;
		}
		const selectableTotal = this.props.select_employees?.length || 0;
		if (selectableTotal > 0) {
			this._planAssignmentsTotalItems = selectableTotal;
			return selectableTotal;
		}
		return 0;
	}

	_isPlanLoadComplete() {
		return this.state.plan_load_complete !== false;
	}

	_schedulePlanScrollSync() {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.updatePlanScroll();
				this.ensureScrollSyncListeners();
			});
		});
	}

	/**
	 * Sincroniza alturas plan ↔ contadores tras layout estable (doble rAF + retry).
	 * Necesario al entrar en Horas: el ancho del panel y el split vertical cambian
	 * después del primer paint y dejan filas desfasadas si solo medimos una vez.
	 */
	_schedulePlanRowHeightSync = () => {
		clearTimeout(this._rowHeightSyncTimer);
		if (this._rowHeightSyncRaf != null) {
			cancelAnimationFrame(this._rowHeightSyncRaf);
		}
		this._rowHeightSyncRaf = requestAnimationFrame(() => {
			this._rowHeightSyncRaf = requestAnimationFrame(() => {
				this._rowHeightSyncRaf = null;
				this.syncRowHeights();
				this.updateCounterScrollSpacer();
				this._rowHeightSyncTimer = setTimeout(() => {
					this.syncRowHeights();
					this.updateCounterScrollSpacer();
				}, 150);
			});
		});
	};

	/**
	 * Refresca contadores del panel lateral tras editar turnos en Horas (resize optimista
	 * o expand). Solo cuentas por defecto; staffing opcional. Debounced en idle para no
	 * congelar planes grandes ni duplicar fetches en resizes seguidos.
	 */
	_scheduleCountersRefreshAfterHourlyEdit = (options = {}) => {
		const { includeStaffing = false, idleTimeout = 2000 } = options;

		if (this._hourlyCountersRefreshIdleId != null) {
			if (typeof window.cancelIdleCallback === "function") {
				window.cancelIdleCallback(this._hourlyCountersRefreshIdleId);
			}
			this._hourlyCountersRefreshIdleId = null;
		}
		clearTimeout(this._hourlyCountersRefreshTimer);

		const run = () => {
			this._hourlyCountersRefreshIdleId = null;
			this._hourlyCountersRefreshTimer = null;
			const tasks = [this.getAccountAssignments()];
			if (includeStaffing) {
				tasks.push(this.getStaffingLevelAssignments());
			}
			Promise.all(tasks).then(() => {
				this._schedulePlanRowHeightSync();
			});
		};

		if (typeof window.requestIdleCallback === "function") {
			this._hourlyCountersRefreshIdleId = window.requestIdleCallback(run, {
				timeout: idleTimeout,
			});
		} else {
			this._hourlyCountersRefreshTimer = window.setTimeout(
				run,
				Math.min(idleTimeout, 4000)
			);
		}
	};

	/** Cede el main thread para que scroll/input no se congelen entre chunks. */
	_yieldToBrowser() {
		return new Promise((resolve) => {
			const finish = () => {
				if (typeof window.requestIdleCallback === "function") {
					window.requestIdleCallback(() => resolve(), { timeout: 64 });
				} else {
					setTimeout(resolve, 0);
				}
			};
			if (typeof window.requestAnimationFrame === "function") {
				window.requestAnimationFrame(() => finish());
			} else {
				finish();
			}
		});
	}

	async getAllAssignments(employeeIdsOverride) {
		this._cachedEmployeeContracts = new Map();
		const update_employee_ids =
			employeeIdsOverride ?? this.state.update_employee_ids;
		const isPartial =
			Array.isArray(update_employee_ids) && update_employee_ids.length > 0;

		// Durante la carga paginada, encolar refrescos parciales (sockets) y aplicar al final.
		if (isPartial && !this._isPlanLoadComplete()) {
			const pending = new Set(this._pendingEmployeeIdsDuringLoad || []);
			update_employee_ids.forEach((id) => pending.add(id));
			this._pendingEmployeeIdsDuringLoad = [...pending];
			return;
		}

		// Carga inicial paginada en vistas soportadas (Fase A+B) con grupos grandes.
		if (!isPartial && this._shouldPaginatePlanAssignments()) {
			await this._getAllAssignmentsPaginated();
			return;
		}

		// Si había una carga paginada en vuelo (cambio de vista/rango), cancelarla.
		if (!isPartial) {
			this._abortPlanAssignmentsLoad();
		}

		const promises = [
			this.getPlanAssignments(employeeIdsOverride),
		];

		await Promise.all(promises);

		const postLoadPromises = [
			this.getAccountAssignments(),
			this.getStaffingLevelAssignments(),
		];

		// Ejecutar sólo si grid_view es "hours"
		if (this.state.plan_grid_view === PLAN_GRID_VIEWS.hours) {
			postLoadPromises.push(this.getStaffingLevelHourlyAssignments());
		}

		await Promise.all(postLoadPromises);

		this.setState({
			plan_load_complete: true,
			plan_pending_skeleton_count: 0,
		});

		// Doble rAF: tras layout real de tablas/spacers, sin esperar idle (hasta 2.5s)
		// que dejaba el sync de scroll desfasado en la primera interacción.
		this._schedulePlanScrollSync();
	}

	/** Prefetch solo red para solapar fetch N+1 con el yield tras pintar N. */
	_prefetchPlanAssignmentsPage({ page, page_size, signal }) {
		const {
			group_id,
			start,
			end,
			selected_employee_ids,
			update_employee_ids,
		} = this.state;
		return plansService.getPlanAssignments({
			group_id,
			start,
			end,
			employee_ids: selected_employee_ids,
			update_employee_ids,
			page,
			page_size,
			signal,
		});
	}

	/**
	 * Paginación encubierta (vistas Fase A+B+C: Funciones / Simple / Ubicaciones /
	 * Horas / Turnos / Ubic. agrupadas, >40 empleados):
	 * 1) page_size=20 → pintar ya + skeletons
	 * 2) páginas page_size=50: paint por página (como v1.1) + prefetch red durante yield
	 * 3) contadores/staffing solo al terminar (+ staffing hourly si vista Horas)
	 *
	 * Nota: batch de 2 páginas (~100 emp./setState) empeoró tirones — no usar.
	 * Vista Horas: no salta rejilla; hours solo para empleados del chunk (append).
	 */
	async _getAllAssignmentsPaginated() {
		this._abortPlanAssignmentsLoad();
		const controller = new AbortController();
		this._planAssignmentsAbortController = controller;
		const loadId = (this._planAssignmentsLoadId || 0) + 1;
		this._planAssignmentsLoadId = loadId;
		const { signal } = controller;

		const isStale = () =>
			signal.aborted || loadId !== this._planAssignmentsLoadId;

		// Skeletons desde el inicio (selectables), para no parecer tabla truncada
		// mientras llega el primer chunk o si alguna página no trae total_items.
		this._planAssignmentsTotalItems = 0;
		const expectedTotal = this._resolvePlanAssignmentsTotalItems(0);

		this.setState({
			plan_load_complete: false,
			plan_pending_skeleton_count:
				this._getPlanPendingSkeletonCount(0, expectedTotal),
			accounts_loading: true,
			staffing_loading: this.state.hasPrivileges ? true : false,
		});

		try {
			const first = await this.getPlanAssignments(undefined, {
				page: 0,
				page_size: PLAN_ASSIGNMENTS_PAGE_SIZE_FIRST,
				append: false,
				signal,
				trackPagination: true,
			});

			if (isStale() || !first?.ok) {
				this._releaseStalePaginatedLoad(loadId);
				return;
			}

			let loadedCount = first.loadedCount;
			let accumulated = first.assignments || [];
			const totalItems = this._resolvePlanAssignmentsTotalItems(
				first.totalItems || 0
			);

			if (
				totalItems > 0
					? loadedCount < totalItems
					: first.pageSize >= PLAN_ASSIGNMENTS_PAGE_SIZE_FIRST
			) {
				// Reinicia con page_size=50 desde page=0; el merge deduplica los 20 ya pintados.
				let page = 0;
				let prefetchPromise = this._prefetchPlanAssignmentsPage({
					page: 0,
					page_size: PLAN_ASSIGNMENTS_PAGE_SIZE_NEXT,
					signal,
				});

				while (totalItems > 0 ? loadedCount < totalItems : true) {
					if (isStale()) {
						this._releaseStalePaginatedLoad(loadId);
						return;
					}

					// Esperar red primero (skeletons visibles); yield justo antes del CPU.
					let prefetchedResponse;
					try {
						prefetchedResponse = await prefetchPromise;
					} catch (error) {
						if (error?.name === "AbortError" || signal.aborted) {
							this._releaseStalePaginatedLoad(loadId);
							return;
						}
						throw error;
					}

					if (isStale()) {
						this._releaseStalePaginatedLoad(loadId);
						return;
					}

					await this._yieldToBrowser();
					if (isStale()) {
						this._releaseStalePaginatedLoad(loadId);
						return;
					}

					const result = await this.getPlanAssignments(undefined, {
						page,
						page_size: PLAN_ASSIGNMENTS_PAGE_SIZE_NEXT,
						append: true,
						signal,
						trackPagination: true,
						baseAssignments: accumulated,
						prefetchedResponse,
					});

					if (isStale() || !result?.ok) {
						this._releaseStalePaginatedLoad(loadId);
						return;
					}

					if (result.loadedCount === loadedCount) {
						break;
					}
					loadedCount = result.loadedCount;
					accumulated = result.assignments || accumulated;
					page += 1;

					const isLastPage =
						result.pageSize < PLAN_ASSIGNMENTS_PAGE_SIZE_NEXT ||
						(totalItems > 0 && loadedCount >= totalItems);

					if (isLastPage) {
						break;
					}

					// Pedir N+1 ya: corre en paralelo con el siguiente await/yield.
					prefetchPromise = this._prefetchPlanAssignmentsPage({
						page,
						page_size: PLAN_ASSIGNMENTS_PAGE_SIZE_NEXT,
						signal,
					});
				}
			}

			// Filas de plan ya completas: quitar skeletons ya (no esperar contadores).
			if (!isStale()) {
				this._planAssignmentsTotalItems = 0;
				this.setState({ plan_pending_skeleton_count: 0 });
			}

			// Opciones de filtro con el plan completo (durante chunks se reutilizan las de la 1.ª página).
			if (!isStale() && accumulated.length > 0) {
				const {
					plan_option_functions: computed_functions,
					plan_option_ubications: computed_ubications,
				} = this.filterSelectPlanOptions(accumulated);
				this.setState({
					plan_option_functions: computed_functions,
					plan_option_ubications: computed_ubications,
				});
			}

			if (isStale()) {
				this._releaseStalePaginatedLoad(loadId);
				return;
			}

			const postLoadPromises = [
				this.getAccountAssignments(),
				this.getStaffingLevelAssignments(),
			];
			// Vista Horas: cobertura horaria al final (como el path full de getAllAssignments).
			if (this.state.plan_grid_view === PLAN_GRID_VIEWS.hours) {
				postLoadPromises.push(this.getStaffingLevelHourlyAssignments());
			}

			await Promise.all(postLoadPromises);

			if (isStale()) {
				this._releaseStalePaginatedLoad(loadId);
				return;
			}

			this.setState(
				{
					plan_load_complete: true,
					plan_pending_skeleton_count: 0,
				},
				() => {
					const run = () => this.loadApprovedAbsencesForPeriod();
					if (typeof window.requestIdleCallback === "function") {
						window.requestIdleCallback(run, { timeout: 4000 });
					} else {
						window.setTimeout(run, 800);
					}
				}
			);

			this._schedulePlanScrollSync();

			const pendingIds = this._pendingEmployeeIdsDuringLoad || [];
			this._pendingEmployeeIdsDuringLoad = [];
			if (pendingIds.length > 0) {
				// Turnos / Ubic. agrupadas reagrupan: refresh parcial puede dejar filas incoherentes.
				await this.getAllAssignments(
					this._usesFullPlanAssignmentsRefresh() ? [] : pendingIds
				);
			}
		} catch (error) {
			if (error?.name === "AbortError" || signal.aborted) {
				this._releaseStalePaginatedLoad(loadId);
				return;
			}
			console.error("Error in _getAllAssignmentsPaginated:", error);
			this._planAssignmentsTotalItems = 0;
			this.setState({
				plan_load_complete: true,
				plan_pending_skeleton_count: 0,
				plan_loading: false,
				loading: false,
				accounts_loading: false,
				staffing_loading: false,
			});
		}
	}

	// get counters
	async getAccountAssignments() {
		const {
			group_id,
			start,
			end,
			accounts_loading,
			plan_view_id,
			ubication_id,
			selected_employee_ids,
		} = this.state;
		const { account_assignments } = this.props;

		// Solo mostrar loading si no hay datos previos para evitar re-renders que causen pérdida de scroll
		if (!accounts_loading && account_assignments.length === 0) {
			this.setState({
				accounts_loading: true,
			});
		}
		await this.props.getAccountAssignments({
			group_id,
			start,
			end,
			plan_view_id,
			...this._getFunctionFilterForApi(),
			ubication_id,
			employee_ids: selected_employee_ids,
		});

		this.setState({
			accounts_loading: false,
		});
	}

	/**
	 * Solape (en horas) de una lista de intervalos con un bloque de la rejilla.
	 *
	 * Trabaja en minutos desde medianoche en vez de con moment: se llama una vez
	 * por hora y por media hora de cada empleado/día, y con moment era el punto
	 * más caro de toda la vista Horas (parseo de strings + GC).
	 */
	_overlapInterval = (time_intervals, blockStart, blockEnd) => {
		let totalMinutes = 0; // para pintar (todo)
		let workMinutes = 0; // solo counts_as_total_hours
		let pinta = false;

		const blockStartMin = parseClockMinutes(blockStart);
		const blockEndMin = this._dayViewMinutes(blockEnd, blockStart);

		if (blockStartMin === null || blockEndMin === null) {
			return { paint_count: 0, work_count: 0, pinta: false };
		}

		time_intervals.forEach((interval) => {
			// Convertimos el intervalo de UTC (`Z`) a la hora local del usuario
			const local_start = convertFromUTC(interval.start);
			const local_end = convertFromUTC(interval.end);
			const interval_end_adjusted = this._resolveIntervalDayViewEnd(
				interval,
				local_start,
				local_end
			);

			const intervalStartMin = parseClockMinutes(local_start);
			const intervalEndMin = this._dayViewMinutes(
				interval_end_adjusted,
				blockStart
			);

			if (intervalStartMin === null || intervalEndMin === null) return;

			const overlapStart = Math.max(blockStartMin, intervalStartMin);
			const overlapEnd = Math.min(blockEndMin, intervalEndMin);

			if (overlapStart < overlapEnd) {
				pinta = true;
				const mins = overlapEnd - overlapStart;
				totalMinutes += mins;
				if (interval.time_type?.counts_as_total_hours) {
					workMinutes += mins;
				}
			}
		});

		return {
			paint_count: Math.round((totalMinutes / 60) * 100) / 100,
			work_count: Math.round((workMinutes / 60) * 100) / 100,
			pinta,
		};
	};

	// get plan
	// TODO TODO update employee
	// sustituir fila de empleado por la del empleado modificado
	async getPlanAssignments(employeeIdsOverride, fetchOptions = {}) {
		const {
			page,
			page_size,
			append = false,
			signal,
			trackPagination = false,
			// Acumulado explícito: evita carrera con setState entre páginas.
			baseAssignments,
			// Respuesta HTTP ya resuelta (pipelining con yield).
			prefetchedResponse,
			// Reconstrucción local: las ausencias ya se pidieron en la carga real.
			skipAbsencesReload = false,
		} = fetchOptions;

		// El select de intercambio devuelve el id de destino como string.
		// Sin normalizar, Set.has no reconoce la fila y se pinta en gris (sin `active`).
		const update_employee_ids = normalizeEmployeeIds(
			employeeIdsOverride ?? this.state.update_employee_ids
		);

		const {
			group_id,
			start,
			end,
			selected_function_ids,
			ubication_id,
			selected_employee_ids,
			plan_loading,
			plan_assignments: statePlanAssignments,
			new_plan,
			plan_option_functions,
			plan_option_ubications,
		} = this.state;

		const plan_assignments =
			baseAssignments !== undefined
				? baseAssignments
				: statePlanAssignments;

		if (!plan_loading && !append && !trackPagination) {
			const scopedEmployeeUpdate =
				update_employee_ids && update_employee_ids.length > 0;
			if (!scopedEmployeeUpdate) {
				this.setState({
					plan_loading: true,
				});
			}
		}

		// El filtro de función se aplica en cliente. Si va en la query, el API
		// omite ausencias y vacaciones y esas celdas se pintan como descanso.
		let response;
		if (prefetchedResponse) {
			response = prefetchedResponse;
		} else {
			try {
				response = await plansService.getPlanAssignments({
					group_id,
					start,
					end,
					employee_ids: selected_employee_ids,
					update_employee_ids,
					page,
					page_size,
					signal,
				});
			} catch (error) {
				if (error?.name === "AbortError" || signal?.aborted) {
					return { ok: false, aborted: true };
				}
				throw error;
			}
		}

		if (signal?.aborted) {
			return { ok: false, aborted: true };
		}

		// console.log(response);

		if (response.ok) {
			const isLongPeriod = this._getIsLongPeriod(start, end);

			const server_first_hour = response.first_hour
				? convertFromUTC(response.first_hour)
				: "00:00";
			let server_last_hour = response.last_hour
				? convertFromUTC(response.last_hour)
				: "23:59";

			// Si el rango cruza la medianoche, limito la hora de final
			if (
				moment(server_last_hour, "HH:mm").isBefore(
					moment(server_first_hour, "HH:mm")
				)
			) {
				// server_first_hour = "00:00";
				server_last_hour = "23:59";
			}

			// Unión de horas necesarias (turnos + staffing). El rango del servidor solo si no hay datos:
			// así la vista queda compacta como la tabla de necesidades (sin columnas vacías por configuración del grupo).
			const neededHours = this._collectNeededHoursFromAssignments(
				response.data || []
			);

			this._mergeNeedsStaffingIntoHourSet(
				neededHours,
				this.state.staffing_level_hourly_assignments
			);

			if (neededHours.size === 0) {
				this._mergeClockRangeIntoHourSet(
					neededHours,
					server_first_hour,
					server_last_hour
				);
			}

			const realRange =
				neededHours.size > 0
					? this._minimalArcRangeFromHourSet(neededHours)
					: { first_hour: "00:00", last_hour: "23:59" };

			const first_hour = realRange.first_hour;
			const last_hour = realRange.last_hour;

			// SOLUCIÓN INTELIGENTE: Expandir cuando sea necesario, contraer solo si es seguro
			const current_first_hour = this.state.first_hour;
			const current_last_hour = this.state.last_hour;
			const current_working_hours_list = this.state.working_hours_list;

			let final_first_hour = first_hour;
			let final_last_hour = last_hour;

			// Si hay una actualización de empleado específico, recalcular completamente el rango
			// para evitar problemas de desalineación en la vista de horas
			const isEmployeeSpecificUpdate =
				update_employee_ids && update_employee_ids.length > 0;

			// Definir variables de contracción fuera del bloque if
			const shouldContractStart =
				!isEmployeeSpecificUpdate &&
				current_working_hours_list &&
				current_working_hours_list.length > 0 &&
				moment(first_hour, "HH:mm").isAfter(
					moment(current_first_hour, "HH:mm")
				);
			const shouldContractEnd =
				!isEmployeeSpecificUpdate &&
				current_working_hours_list &&
				current_working_hours_list.length > 0 &&
				moment(last_hour, "HH:mm").isBefore(moment(current_last_hour, "HH:mm"));

			// NUEVA LÓGICA: Si el backend devuelve rangos más restrictivos que el actual, forzar contracción
			const backendRangeIsMoreRestrictive =
				moment(first_hour, "HH:mm").isAfter(
					moment(current_first_hour, "HH:mm")
				) ||
				moment(last_hour, "HH:mm").isBefore(moment(current_last_hour, "HH:mm"));

			// Si el backend es más restrictivo, mantenemos el rango visual actual (más amplio) para depurar/visualizar
			if (backendRangeIsMoreRestrictive && !isEmployeeSpecificUpdate) {
				// Mantener el rango actual si es más amplio; si no existe, usar backend
				final_first_hour =
					current_working_hours_list && current_working_hours_list.length > 0
						? moment(current_first_hour, "HH:mm").isBefore(
								moment(first_hour, "HH:mm")
							)
							? current_first_hour
							: first_hour
						: first_hour;
				final_last_hour =
					current_working_hours_list && current_working_hours_list.length > 0
						? moment(current_last_hour, "HH:mm").isAfter(
								moment(last_hour, "HH:mm")
							)
							? current_last_hour
							: last_hour
						: last_hour;

				// Ampliar rango visual mínimo cuando aún no había rango previo (p.ej., mostrar hasta 23:59)
				if (
					!current_working_hours_list ||
					current_working_hours_list.length === 0
				) {
					const desiredLast = "23:59";
					if (
						moment(desiredLast, "HH:mm").isAfter(
							moment(final_last_hour, "HH:mm")
						)
					) {
						final_last_hour = desiredLast;
					}
				}
			}

			// Si ya tenemos un rango de horas establecido, aplicar lógica inteligente
			if (current_working_hours_list && current_working_hours_list.length > 0) {
				if (isEmployeeSpecificUpdate) {
					// Para actualizaciones específicas de empleado, mantener/expandir el rango visual actual
					// Evitar contraer la vista a un rango más pequeño solo por la actualización parcial
					const minFirst = moment(first_hour, "HH:mm").isBefore(
						moment(current_first_hour, "HH:mm")
					)
						? first_hour
						: current_first_hour;
					const maxLast = moment(last_hour, "HH:mm").isAfter(
						moment(current_last_hour, "HH:mm")
					)
						? last_hour
						: current_last_hour;

					final_first_hour = minFirst;
					final_last_hour = maxLast;
				} else if (!backendRangeIsMoreRestrictive) {
					// LÓGICA DE EXPANSIÓN: Solo expandir si el backend NO es más restrictivo
					final_first_hour = moment(first_hour, "HH:mm").isBefore(
						moment(current_first_hour, "HH:mm")
					)
						? first_hour // Expandir hacia atrás si es necesario
						: current_first_hour; // Mantener el inicio original

					final_last_hour = moment(last_hour, "HH:mm").isAfter(
						moment(current_last_hour, "HH:mm")
					)
						? last_hour // Expandir hacia adelante si es necesario
						: current_last_hour; // Mantener el final original
				}
				// Si backendRangeIsMoreRestrictive es true, ya hemos establecido final_first_hour y final_last_hour arriba
			}

			const newAssignments = response.data || [];
			const apiTotalItems =
				response.pagination?.total_items ??
				response.pagination?.total ??
				0;
			// Sticky + selectables: si una página no trae pagination.total, no apagar skeletons.
			const totalItems = trackPagination
				? this._resolvePlanAssignmentsTotalItems(apiTotalItems)
				: apiTotalItems;
			// Copia superficial en update parcial: no mutar el array de state in-place.
			let updatedPlanAssignments =
				update_employee_ids.length > 0 || append
					? [...(plan_assignments || [])]
					: plan_assignments || [];

			// Cualquier actualización parcial o paginada deja la copia completa
			// desfasada: mejor perder la optimización que realinear con datos viejos.
			if (update_employee_ids.length > 0 || append) {
				this._lastFullPlanAssignmentsData = null;
			}

			if (update_employee_ids.length > 0) {
				newAssignments.forEach((newAssignment) => {
					// Encuentra si el empleado ya existe en plan_assignments
					const existingIndex = updatedPlanAssignments.findIndex(
						(assignment) => assignment.employee.id === newAssignment.employee.id
					);

					if (existingIndex !== -1) {
						// Reemplaza la fila existente
						updatedPlanAssignments[existingIndex] = newAssignment;
					} else {
						// Si no existe, lo agrega
						updatedPlanAssignments.push(newAssignment);
					}
				});
			} else if (append) {
				// Paginación: append estable por orden de llegada; dedupe por employee id.
				const existingIds = new Set(
					updatedPlanAssignments.map((assignment) => assignment.employee?.id)
				);
				newAssignments.forEach((newAssignment) => {
					const employeeId = newAssignment.employee?.id;
					if (employeeId == null || existingIds.has(employeeId)) {
						return;
					}
					existingIds.add(employeeId);
					updatedPlanAssignments.push(newAssignment);
				});
			} else {
				// Comportamiento normal: reemplazar todos los datos
				updatedPlanAssignments = newAssignments;
				// Set sin filtrar por display: permite realinear la rejilla a las
				// necesidades sin repetir la petición ni perder filas filtradas.
				this._lastFullPlanAssignmentsData = this._sortPlanAssignmentsByGroupOrder(
					newAssignments
				);
				this._lastFullPlanAssignmentsKey = `${group_id}|${start}|${end}`;
			}

			updatedPlanAssignments =
				this._sortPlanAssignmentsByGroupOrder(updatedPlanAssignments);

			// Update parcial: solo mirar empleados tocados para expandir rango (no escanear todo el plan).
			if (isEmployeeSpecificUpdate) {
				const updatedOnly = (updatedPlanAssignments || []).filter((pa) =>
					update_employee_ids.includes(pa.employee.id)
				);
				const realRangeUpdated =
					this._calculateRealWorkingHoursRange(updatedOnly);
				const expandedFirst = moment(
					realRangeUpdated.first_hour,
					"HH:mm"
				).isBefore(moment(final_first_hour, "HH:mm"))
					? realRangeUpdated.first_hour
					: final_first_hour;
				const expandedLast = moment(
					realRangeUpdated.last_hour,
					"HH:mm"
				).isAfter(moment(final_last_hour, "HH:mm"))
					? realRangeUpdated.last_hour
					: final_last_hour;
				final_first_hour = expandedFirst;
				final_last_hour = expandedLast;
			}

			// Calcular working_hours_list con el rango final (reusar referencia si no cambia)
			let working_hours_list = this._getWorkingHoursList(
				final_first_hour,
				final_last_hour
			);
			if (
				current_working_hours_list?.length === working_hours_list.length &&
				current_working_hours_list.every(
					(h, i) => h === working_hours_list[i]
				)
			) {
				working_hours_list = current_working_hours_list;
			}

			const updateEmployeeIdSet = new Set(update_employee_ids);
			const isAppendUpdate = append && !isEmployeeSpecificUpdate;
			const newAssignmentIdSet = isAppendUpdate
				? new Set(
						newAssignments
							.map((assignment) => assignment.employee?.id)
							.filter((id) => id != null)
					)
				: null;
			const prevAssignmentsByEmployeeId = isEmployeeSpecificUpdate
				? new Map(
						(plan_assignments || []).map((assignment) => [
							assignment.employee.id,
							assignment,
						])
					)
				: null;

			// Procesa cada asignación
			updatedPlanAssignments.forEach((plan_assignment) => {
				if (
					isEmployeeSpecificUpdate &&
					!updateEmployeeIdSet.has(plan_assignment.employee.id)
				) {
					return;
				}
				// En append paginado solo reprocesar filas nuevas de esta página.
				if (
					isAppendUpdate &&
					!newAssignmentIdSet.has(plan_assignment.employee?.id)
				) {
					return;
				}

				let plan_assignments_hourly_totals = [];

				if (!plan_assignment.plans) {
					plan_assignment.plans = this.props.plan_days.map((d) => ({
						day: d.day,
						active: this.checkEmployeeActive(plan_assignment.ranges, d.day),
						assignments: [],
						assignments_with_overnight: [],
					}));
				}
				let horasExtrasPorDia = {};

				plan_assignment.plans.forEach((plan) => {
					plan.active = this.checkEmployeeActive(
						plan_assignment.ranges,
						plan.day
					);
					plan.plan_assignments_with_overnight = [...plan.assignments] || [];
					if (horasExtrasPorDia[plan.day]) {
						plan.plan_assignments_with_overnight.push(
							...horasExtrasPorDia[plan.day]
						);
						delete horasExtrasPorDia[plan.day];
					}

					plan.assignments.forEach((assignment) => {
						if (
							!assignment.time_intervals_overnight ||
							assignment.time_intervals_overnight.length < 1
						) {
							const intervals = assignment.time_intervals_from_shift
								? assignment.shift.time_intervals
								: assignment.time_intervals;

							if (!intervals?.length) return;

							const slices = splitAssignmentIntervalsByDay(intervals);
							if (!slices?.length) return;

							if (slices.length > 1) {
								assignment.is_overnight = true;
								assignment.span_origin_day = plan.day;
								const day0 = slices.find((slice) => slice.dayOffset === 0);
								if (day0?.intervals?.length) {
									assignment.time_intervals_for_day = day0.intervals;
								}
							}

							slices.forEach((slice) => {
								if (slice.dayOffset === 0) return;
								const nextDay = moment(plan.day, "YYYY-MM-DD")
									.add(slice.dayOffset, "days")
									.format("YYYY-MM-DD");
								const copy = {
									...assignment,
									span_origin_day: plan.day,
									span_day_offset: slice.dayOffset,
									is_overnight: true,
									time_intervals_overnight: slice.intervals,
									time_intervals_for_day: slice.intervals,
								};
								horasExtrasPorDia[nextDay] = horasExtrasPorDia[nextDay] || [];
								horasExtrasPorDia[nextDay].push(copy);
							});
						}
					});
				});
				linkTouchingAssignmentsAcrossDays(plan_assignment.plans);
			});

			const hoursListEqual = (a, b) => {
				if (a === b) return true;
				if (!a || !b || a.length !== b.length) return false;
				for (let i = 0; i < a.length; i++) {
					if (a[i] !== b[i]) return false;
				}
				return true;
			};

			// Paginación: la rejilla horaria no se usa fuera de vista Horas; saltarla libera CPU.
			const skipHoursGrid =
				this._shouldSkipHoursGridOnPaginatedFetch(trackPagination);

			// Refresh parcial: reutilizar rejilla horaria existente si el rango no crece.
			// Evita recorrer todos los turnos con moment() en planes grandes (p.ej. 6145).
			const canReuseDayHoursGrid =
				isEmployeeSpecificUpdate &&
				current_working_hours_list?.length > 0 &&
				hoursListEqual(working_hours_list, current_working_hours_list);

			let dayHoursMap;
			let visualGapHoursByDay;

			if (skipHoursGrid) {
				dayHoursMap = {};
				visualGapHoursByDay = {};
				// Mantener refs de horas: evita re-render de filas ya memoizadas al hacer append.
				if (append && current_working_hours_list?.length) {
					working_hours_list = current_working_hours_list;
					final_first_hour = current_first_hour;
					final_last_hour = current_last_hour;
				}
				// Marca: al entrar en vista Horas hay que reconstruir plans[].hours.
				this._hoursGridSkipped = true;
				// Evitar hours === undefined si alguien monta Horas antes del rebuild.
				updatedPlanAssignments.forEach((pa) => {
					(pa.plans || []).forEach((plan) => {
						if (!Array.isArray(plan.hours)) {
							plan.hours = [];
						}
					});
				});
			} else if (canReuseDayHoursGrid) {
				dayHoursMap = {};
				visualGapHoursByDay = {};
				(this.props.plan_days || []).forEach((d, dayIndex) => {
					const samplePlan = (plan_assignments || [])[0]?.plans?.[dayIndex];
					const existingList = samplePlan?.working_hours_list;
					dayHoursMap[d.day] =
						existingList?.length > 0 ? existingList : current_working_hours_list;
					visualGapHoursByDay[d.day] = samplePlan?.visual_gap_hours || [];
				});
				working_hours_list = current_working_hours_list;
			} else {
				({ dayHoursMap, visualGapHoursByDay } =
					this._computePerDayWorkingHoursMap(
						updatedPlanAssignments,
						this.props.plan_days,
						working_hours_list,
						this.state.staffing_level_hourly_assignments
					));
			}

			if (!skipHoursGrid) {
			this._hoursGridSkipped = false;
			updatedPlanAssignments.forEach((plan_assignment) => {
				const employeeId = plan_assignment.employee.id;

				if (
					isEmployeeSpecificUpdate &&
					!updateEmployeeIdSet.has(employeeId)
				) {
					// Rango horario igual → no tocar otras filas (mismo reference → memo OK).
					if (canReuseDayHoursGrid) {
						return;
					}

					const prevAssignment = prevAssignmentsByEmployeeId?.get(employeeId);
					if (prevAssignment) {
						plan_assignment.plan_assignments_hourly_totals =
							prevAssignment.plan_assignments_hourly_totals;

						plan_assignment.plans.forEach((plan) => {
							const prevPlan = prevAssignment.plans?.find(
								(p) => p.day === plan.day
							);
							const list =
								dayHoursMap[plan.day]?.length > 0
									? dayHoursMap[plan.day]
									: working_hours_list;

							if (hoursListEqual(prevPlan?.working_hours_list, list)) {
								plan.working_hours_list = prevPlan.working_hours_list;
								plan.visual_gap_hours = prevPlan.visual_gap_hours;
								plan.hours = prevPlan.hours;
								return;
							}

							plan.working_hours_list = list;
							plan.visual_gap_hours =
								visualGapHoursByDay[plan.day] || [];

							if (prevPlan?.hours) {
								plan.hours = this._realignPlanHoursToWorkingList(
									prevPlan.hours,
									list
								);
							}
						});
					}
					return;
				}

				// Append paginado (vista Horas): reutilizar hours de filas ya pintadas.
				// Sin esto, cada chunk reconstruye O(n) empleados acumulados → tirones.
				if (
					isAppendUpdate &&
					!newAssignmentIdSet.has(employeeId)
				) {
					(plan_assignment.plans || []).forEach((plan) => {
						const list =
							dayHoursMap[plan.day]?.length > 0
								? dayHoursMap[plan.day]
								: working_hours_list;

						if (hoursListEqual(plan.working_hours_list, list)) {
							return;
						}

						plan.working_hours_list = list;
						plan.visual_gap_hours =
							visualGapHoursByDay[plan.day] || [];

						if (plan.hours?.length) {
							plan.hours = this._realignPlanHoursToWorkingList(
								plan.hours,
								list
							);
						}
					});
					return;
				}

				let plan_assignments_hourly_totals = [];

				const prevAssignmentForEmployee =
					prevAssignmentsByEmployeeId?.get(employeeId) || null;
				const onlyResizeDay = this._resizeRefreshDay || null;
				const resizeDaysToRecompute = this._resizeRefreshDays
					? new Set(this._resizeRefreshDays)
					: onlyResizeDay
						? new Set([
								onlyResizeDay,
								moment(onlyResizeDay, "YYYY-MM-DD")
									.add(1, "days")
									.format("YYYY-MM-DD"),
							])
						: null;

				plan_assignment.plans.forEach((plan) => {
					plan.working_hours_list =
						dayHoursMap[plan.day]?.length > 0
							? dayHoursMap[plan.day]
							: working_hours_list;
					plan.visual_gap_hours = visualGapHoursByDay[plan.day] || [];

					// Resize: reutilizar horas de días no afectados (incluye día+1 por overnight).
					// Importante: seguir empujando a plan_assignments_hourly_totals; si no,
					// la tabla de necesidades pierde cobertura del resto de días.
					if (
						resizeDaysToRecompute &&
						!resizeDaysToRecompute.has(plan.day) &&
						prevAssignmentForEmployee
					) {
						const prevPlan = prevAssignmentForEmployee.plans?.find(
							(p) => p.day === plan.day
						);
						if (
							prevPlan?.hours?.length &&
							hoursListEqual(
								prevPlan.working_hours_list,
								plan.working_hours_list
							)
						) {
							plan.hours = prevPlan.hours;
							plan.visual_gap_hours =
								prevPlan.visual_gap_hours || plan.visual_gap_hours;
							plan_assignments_hourly_totals.push({
								day: plan.day,
								hours: plan.hours,
							});
							return;
						}
						if (prevPlan?.hours?.length) {
							plan.hours = this._realignPlanHoursToWorkingList(
								prevPlan.hours,
								plan.working_hours_list
							);
							plan_assignments_hourly_totals.push({
								day: plan.day,
								hours: plan.hours,
							});
							return;
						}
					}

					// Fragmentar cada hora en un único bloque, pero recolectar medias horas también
					const temp_hours = [];
					const chunk = 30; // minutos por media hora

					!isLongPeriod &&
						plan.working_hours_list.forEach((hours) => {
							const H = String(hours).padStart(2, "0");

							// Primero, calculamos la hora completa
							const fullStart = `${H}:00`;
							const fullEnd = moment(fullStart, "HH:mm")
								.add(1, "hour")
								.format("HH:mm");

							// CORRECCIÓN: Si la hora termina en 00:00, significa que cruzó la medianoche
							// En ese caso, debemos usar 24:00 para el cálculo correcto
							let correctedFullEnd = fullEnd === "00:00" ? "24:00" : fullEnd;

							let full_count = 0;
							let full_pinta = false;
							const full_assignments = [];
							const employee = plan_assignment.employee;
							plan.plan_assignments_with_overnight.forEach((assignment) => {
								assignment.employee = employee;

								if (!plan.active) return;

								const _normalizedType = normalizeShiftType(
									assignment.shift.type
								);
								const _isWorkOrAutomatic =
									_normalizedType === shiftType.work ||
									_normalizedType === shiftType.automatic;
								const rawIntervals =
									this._getAssignmentPaintIntervals(assignment);
								const intervals = fixStartEndIntervals(rawIntervals);
								const _isHourlyAbsenceOrVacation =
									(_normalizedType === shiftType.vacation ||
										_normalizedType === shiftType.absence) &&
									hasPartialDayIntervals(intervals);

								if (_isWorkOrAutomatic || _isHourlyAbsenceOrVacation) {
									// cálculo de solapamiento para trabajo, automático y vacación/ausencia por hora

									// DEBUG: Log para turnos overnight
									// if (
									// 	assignment.is_overnight ||
									// 	assignment.time_intervals_overnight
									// ) {
									// 	console.log("🕐 OVERNIGHT DEBUG:", {
									// 		shift_name: assignment.shift.name,
									// 		day: plan.day,
									// 		hour: H,
									// 		fullStart,
									// 		correctedFullEnd,
									// 		is_overnight: assignment.is_overnight,
									// 		has_time_intervals_overnight:
									// 			!!assignment.time_intervals_overnight,
									// 		raw_intervals: rawIntervals.map((iv) => ({
									// 			start: iv.start,
									// 			end: iv.end,
									// 			work_time: iv.time_type?.work_time,
									// 		})),
									// 		fixed_intervals: intervals.map((iv) => ({
									// 			start: iv.start,
									// 			end: iv.end,
									// 		})),
									// 	});
									// }

									if (intervals.length) {
										var { pinta, paint_count, work_count } =
											this._overlapInterval(
												intervals,
												fullStart,
												correctedFullEnd
											);

										// Para turnos cortados (múltiples intervalos): calcular isFirst/isLast
										// por el SEGMENTO (intervalo) que hace overlap, no por el turno completo
										const blockStart = parseClockMinutes(fullStart);
										const blockEnd = this._dayViewMinutes(
											correctedFullEnd,
											fullStart
										);
										let start_offset = 0;
										let isFirst = false;
										let isLast = false;
										let post_midnight_minutes = 0;

										for (const interval of intervals) {
											const local_start = convertFromUTC(interval.start);
											const local_end = convertFromUTC(interval.end);
											const interval_end_adj = this._resolveIntervalDayViewEnd(
												interval,
												local_start,
												local_end
											);
											const intervalStart = parseClockMinutes(local_start);
											const intervalEnd = this._dayViewMinutes(
												interval_end_adj,
												fullStart
											);
											if (intervalStart === null || intervalEnd === null) {
												continue;
											}
											const overlapStart = Math.max(blockStart, intervalStart);
											const overlapEnd = Math.min(blockEnd, intervalEnd);
											if (overlapStart < overlapEnd) {
												// Este intervalo hace overlap; usar este para isFirst/isLast
												const diffMin = intervalStart - blockStart;
												start_offset =
													diffMin >= 0 && diffMin < 60 ? diffMin / 60 : 0;
												post_midnight_minutes = this._getPostMidnightMinutes(
													local_start,
													local_end,
													interval
												);
												if (assignment.time_intervals_overnight) {
													isFirst = H === "00";
													isLast =
														intervalEnd > blockStart && intervalEnd <= blockEnd;
												} else if (assignment.is_overnight) {
													const [turnStartHour] = local_start.split(":");
													isFirst = turnStartHour === H;
													isLast =
														H === "23" && interval_end_adj.startsWith("24:");
												} else {
													isFirst = diffMin >= 0 && diffMin < 60;
													isLast =
														intervalEnd > blockStart && intervalEnd <= blockEnd;
												}
												break;
											}
										}

										// DEBUG: Log de isFirst/isLast para overnight
										// if (
										// 	assignment.is_overnight ||
										// 	assignment.time_intervals_overnight
										// ) {
										// 	const lastInterval =
										// 		intervals[intervals.length - 1];
										// 	console.log("🎯 isFirst/isLast:", {
										// 		shift_name: assignment.shift.name,
										// 		hour: H,
										// 		isFirst,
										// 		isLast,
										// 		pinta,
										// 		paint_count,
										// 		last_end: convertFromUTC(
										// 			lastInterval.render_end ||
										// 				lastInterval.end
										// 		),
										// 		correctedFullEnd,
										// 	});
										// }

										if (pinta) {
											// marcar pinta y contar minutos de trabajo
											full_pinta = true;
											if (_isWorkOrAutomatic) {
												full_count += work_count;
											}

											full_assignments.push({
												count: _isWorkOrAutomatic ? paint_count : 0,
												work_count: _isWorkOrAutomatic ? work_count : 0,
												assignment,
												pinta,
												start_offset,
												isFirst,
												isLast,
												post_midnight_minutes,
												isAvailability:
													_isWorkOrAutomatic &&
													work_count === 0 &&
													paint_count > 0,
											});
										}
									}
								} else {
									// vacaciones/ausencias de día completo y descansos: pintar todo el día
									full_assignments.push({
										count: 0,
										work_count: 0,
										assignment,
										pinta: true,
										start_offset: 0,
										isFirst: false,
										isLast: false,
										isRest: true,
									});
								}
							});

							// --- Ahora medias horas para halfHourInfo ---
							const halfHourInfo = [];
							["00", "30"].forEach((mm) => {
								const start = `${H}:${mm}`;
								const end = moment(start, "HH:mm")
									.add(chunk, "minutes")
									.format("HH:mm");

								// CORRECCIÓN: Si la hora termina en 00:00, significa que cruzó la medianoche
								// En ese caso, debemos usar 24:00 para el cálculo correcto
								const correctedEnd = end === "00:00" ? "24:00" : end;
								let hh_count = 0;
								let hh_pinta = false;
								const hh_assignments = [];
								const employee = plan_assignment.employee;
								plan.plan_assignments_with_overnight.forEach((assignment) => {
									assignment.employee = employee;
									const _normalizedTypeHH = normalizeShiftType(
										assignment.shift.type
									);
									const _isWorkOrAutomaticHH =
										_normalizedTypeHH === shiftType.work ||
										_normalizedTypeHH === shiftType.automatic;
									if (_isWorkOrAutomaticHH && plan.active) {
										const rawIntervals =
											this._getAssignmentPaintIntervals(assignment);
										const intervals = fixStartEndIntervals(rawIntervals);
										if (intervals.length) {
											const { pinta, paint_count, work_count } =
												this._overlapInterval(intervals, start, correctedEnd);

											if (pinta) {
												hh_pinta = true;
												hh_count += work_count;
												// Para turnos cortados: calcular isFirst/isLast por segmento
												const blockStart = parseClockMinutes(start);
												const blockEnd = parseClockMinutes(correctedEnd);
												let start_offset = 0;
												let isFirst = false;
												let isLast = false;

												for (const interval of intervals) {
													const local_start = convertFromUTC(interval.start);
													const local_end = convertFromUTC(
														interval.render_end || interval.end
													);
													const interval_end_adj =
														local_end === "00:00" ? "24:00" : local_end;
													const intervalStart = parseClockMinutes(local_start);
													if (intervalStart === null) continue;
													let intervalEnd = parseClockMinutes(interval_end_adj);
													if (
														interval_end_adj === "24:00" ||
														intervalEnd === null ||
														intervalEnd <= intervalStart
													) {
														intervalEnd = 24 * 60;
													}
													const overlapStart = Math.max(
														blockStart,
														intervalStart
													);
													const overlapEnd = Math.min(blockEnd, intervalEnd);
													if (overlapStart < overlapEnd) {
														const diffMin = intervalStart - blockStart;
														start_offset =
															diffMin >= 0 && diffMin < chunk
																? diffMin / chunk
																: 0;
														if (assignment.time_intervals_overnight) {
															isFirst = start === "00:00" || start === "00:30";
															isLast =
																intervalEnd > blockStart &&
																intervalEnd <= blockEnd;
														} else if (assignment.is_overnight) {
															isFirst = diffMin >= 0 && diffMin < chunk;
															isLast =
																interval_end_adj === "24:00" ||
																(intervalEnd > blockStart &&
																	intervalEnd <= blockEnd);
														} else {
															isFirst = diffMin >= 0 && diffMin < chunk;
															isLast =
																intervalEnd > blockStart &&
																intervalEnd <= blockEnd;
														}
														break;
													}
												}

												hh_assignments.push({
													count: paint_count,
													work_count,
													assignment,
													pinta,
													start_offset,
													isFirst,
													isLast,
													isAvailability: work_count === 0 && paint_count > 0,
												});
											}
										}
									}
								});

								// Recoger empleados únicos
								const employees = [];
								const seenIds = new Set();

								hh_assignments.forEach(({ assignment }) => {
									const emp =
										assignment.employee_with_ubication || assignment.employee;
									if (emp && !seenIds.has(emp.id)) {
										employees.push(emp);
										seenIds.add(emp.id);
									}
								});

								halfHourInfo.push({
									start: `${start}Z`,
									// start: convertToUTC(start),
									count: hh_count,
									pinta: hh_pinta,
									assignments: hh_assignments,
									employees,
								});
							});

							// --- Finalmente, asignamos a temp_hours ---

							const localHourStr = String(hours).padStart(2, "0") + ":00";
							const utcHour = convertToUTC(localHourStr);

							temp_hours.push({
								hour: hours,
								hour_utc: utcHour,
								count: full_count, // contador de hora completa
								hour_assignments: dropRestWhenShiftPaintsHour(
									full_assignments,
									this.props.default_shift?.id
								),
								pinta: full_pinta, // pinta hora completa
								halfHourInfo, // detalles de medias horas
							});
						});
					plan.hours = temp_hours;
					plan_assignments_hourly_totals.push({
						day: plan.day,
						hours: temp_hours,
					});
				});
				plan_assignment.plan_assignments_hourly_totals =
					plan_assignments_hourly_totals;
			});

			working_hours_list = this._unionWorkingHoursLists([
				working_hours_list,
				...Object.values(dayHoursMap),
			]);
			if (
				working_hours_list.length > 1 &&
				working_hours_list[0] > 0 &&
				working_hours_list[working_hours_list.length - 1] === 0
			) {
				working_hours_list = working_hours_list.slice(0, -1);
			}
			}

			// SOLUCIÓN: Solo recalcular las opciones del select cuando NO hay filtro activo
			// Si hay filtro activo (function/ubication > 0), mantener las opciones previas
			const isFilterActive = this._isPlanFilterActive(
				selected_function_ids,
				ubication_id
			);

			let next_plan_option_functions;
			let next_plan_option_ubications;

			if (
				isFilterActive ||
				isEmployeeSpecificUpdate ||
				(trackPagination && append)
			) {
				// Mantener opciones en filtro activo, refresh parcial o chunks intermedios.
				next_plan_option_functions = this.state.plan_option_functions || [];
				next_plan_option_ubications = this.state.plan_option_ubications || [];
			} else {
				// REGENERAR las opciones solo cuando NO hay filtro
				const {
					plan_option_functions: computed_functions,
					plan_option_ubications: computed_ubications,
				} = this.filterSelectPlanOptions(updatedPlanAssignments);

				next_plan_option_functions = computed_functions;
				next_plan_option_ubications = computed_ubications;
			}

			// Aplicar lógica de contracción después de procesar todos los assignments
			// Solo aplicar contracción si NO es una actualización específica de empleado y NO hemos ya aplicado contracción por backend restrictivo
			if (
				!isEmployeeSpecificUpdate &&
				current_working_hours_list &&
				current_working_hours_list.length > 0 &&
				!backendRangeIsMoreRestrictive
			) {
				// Crear una lista completa de assignments para la verificación de contracción
				// Esto incluye tanto los assignments actualizados como los del estado actual
				const allAssignmentsForContraction = [...updatedPlanAssignments];

				// Si hay assignments en el estado que no están en la lista actualizada, agregarlos
				if (
					this.state.plan_assignments &&
					this.state.plan_assignments.length > 0
				) {
					this.state.plan_assignments.forEach((stateAssignment) => {
						const existsInUpdated = allAssignmentsForContraction.some(
							(updated) => updated.employee.id === stateAssignment.employee.id
						);
						if (!existsInUpdated) {
							allAssignmentsForContraction.push(stateAssignment);
						}
					});
				}

				if (shouldContractStart) {
					// Verificar si hay turnos activos en las horas que se van a eliminar
					const hasActiveShiftsInRemovedHours =
						this._hasActiveShiftsInHourRange(
							allAssignmentsForContraction,
							current_first_hour,
							first_hour
						);

					if (!hasActiveShiftsInRemovedHours) {
						final_first_hour = first_hour;
						working_hours_list = this._getWorkingHoursList(
							final_first_hour,
							final_last_hour
						);
					}
				}

				if (shouldContractEnd) {
					// Verificar si hay turnos activos en las horas que se van a eliminar
					const hasActiveShiftsInRemovedHours =
						this._hasActiveShiftsInHourRange(
							allAssignmentsForContraction,
							last_hour,
							current_last_hour
						);

					if (!hasActiveShiftsInRemovedHours) {
						final_last_hour = last_hour; // Contraer de forma segura
						working_hours_list = this._getWorkingHoursList(
							final_first_hour,
							final_last_hour
						);
					}
				}
			}

			const filteredPlanAssignments = isFilterActive
				? this._filterPlanAssignmentsByActiveFilters(
						updatedPlanAssignments,
						selected_function_ids,
						ubication_id
					)
				: updatedPlanAssignments;

			const plan_assignments_for_display = isFilterActive
				? filteredPlanAssignments.filter(
						(pa) =>
							this._hasPlanAssignments(pa) ||
							this._planAssignmentRowMatchesFilters(
								pa,
								selected_function_ids,
								ubication_id
							)
					)
				: filteredPlanAssignments;

			const plan_assignments_with_selection =
				this._applyDaySelectionToAssignments(
					plan_assignments_for_display,
					this.state.day_selection
				);

			const scheduleApprovedAbsencesLoad = () => {
				const run = () => this.loadApprovedAbsencesForPeriod();
				if (typeof window.requestIdleCallback === "function") {
					window.requestIdleCallback(run, { timeout: 4000 });
				} else {
					window.setTimeout(run, 800);
				}
			};

			// Absences al completar carga (no en cada chunk, update parcial ni
			// realineado local de rejilla: ese reusa datos ya cargados).
			const afterAssignmentsState =
				isEmployeeSpecificUpdate || trackPagination || skipAbsencesReload
					? undefined
					: scheduleApprovedAbsencesLoad;

			// Contar sobre el acumulado sin filtro de display (skeletons vs total_items API).
			const loadedCount = updatedPlanAssignments.length;
			const plan_pending_skeleton_count = trackPagination
				? this._getPlanPendingSkeletonCount(loadedCount, totalItems)
				: 0;

			this.setState(
				{
					plan_option_functions: next_plan_option_functions,
					plan_option_ubications: next_plan_option_ubications,
					plan_assignments: plan_assignments_with_selection,
					plan_no_results: plan_assignments_for_display.length === 0,
					plan_loading: false,
					new_plan: false,
					loading: false,
					no_contract: false,
					userMissingContractModalOpen: false,
					update_employee_ids: [], // Limpia update_employee_ids
					working_hours_list,
					first_hour: final_first_hour,
					last_hour: final_last_hour,
					isLongPeriod,
					...(trackPagination
						? { plan_pending_skeleton_count, plan_load_complete: false }
						: {}),
				},
				afterAssignmentsState
			);

			return {
				ok: true,
				totalItems,
				loadedCount,
				pageSize: newAssignments.length,
				// Devolver acumulado completo para el siguiente merge paginado.
				assignments: updatedPlanAssignments,
			};
		} else {
			const hasMissingContractError = Boolean(
				response.errors?.some(
					(error) => error.key === "contract.not_found"
				)
			);

			this.setState(
				{
					plan_loading: false,
					loading: false,
					plan_assignments: [],
					plan_no_results: true,
					plan_pending_skeleton_count: 0,
					plan_load_complete: true,
					no_contract: hasMissingContractError,
					userMissingContractModalOpen: hasMissingContractError,
				},
				() => {
					if (hasMissingContractError) return;

					const textError =
						response.errors?.[0]?.description ||
						this.props.t("common.errorUnknown");

					this.openAlertModal(
						textError,
						this.props.t("plan.errorLoadingDataTitle")
					);
				}
			);

			return {
				ok: false,
				totalItems: 0,
				loadedCount: 0,
				pageSize: 0,
				assignments: [],
			};
		}
	}

	setShowMax = (value) => {
		var sidebar = document.querySelector(".sidebar");
		var mainContent = document.querySelector(".main-content");

		if (value === true || value === "true") {
			sidebar.classList.add("mini");
			mainContent.classList.add("mini");
			value = true;
			if (this.refResizablePanels.current)
				this.refResizablePanels.current.forceResize([99, 1]);
		} else {
			sidebar.classList.remove("mini");
			mainContent.classList.remove("mini");
			value = false;
		}

		localStorage.setItem("max_plan", value);

		this.setState({
			showMax: value,
		});
	};

	toggleShowMax = () => {
		const { showMax } = this.state;
		this.setShowMax(!showMax);
	};

	checkEmployeeActive = (ranges, day) => {
		var active = false;

		if (ranges) {
			ranges.forEach((range) => {
				if (moment(day).isBetween(range.start, range.end, undefined, "[]"))
					active = true;
			});
		}

		return active;
	};

	async getStaffingLevelAssignments() {
		const {
			name,
			group_id,
			start,
			end,
			staffing_loading,
			ubication_id,
			ubication_staffing_id,
			hasPrivileges,
		} = this.state;

		const filtro_ubicacion_id = this._isActiveFilterId(ubication_staffing_id)
			? ubication_staffing_id
			: ubication_id;
		const filtro_funcion_ids = this._getStaffingFunctionFilterIds();
		const staffingFunctionFilter =
			filtro_funcion_ids.length > 0 ? { function_ids: filtro_funcion_ids } : {};

		if (hasPrivileges) {
			if (!staffing_loading) {
				this.setState({
					staffing_loading: true,
				});
			}
			const staffing_level_assignments =
				await this.props.getStaffingLevelAssignments({
					name,
					group_id,
					start,
					end,
					...staffingFunctionFilter,
					ubication_id: filtro_ubicacion_id,
				});

			let staffing_level_current_assignments;
			if (!staffing_level_assignments?.length) {
				staffing_level_current_assignments =
					await this.props.getStaffingLevelCurrentAssignments({
						name,
						group_id,
						start,
						end,
						...staffingFunctionFilter,
						ubication_id: filtro_ubicacion_id,
					});
			}

			this.getFilteredStaffingLevelAssignments({
				staffing_level_assignments,
				staffing_level_current_assignments,
			});
		}
	}

	sortShiftsByLocationAndStartTime(needs) {
		if (!Array.isArray(needs) || needs.length === 0) {
			return [];
		}

		return needs.sort((a, b) => {
			const locationA = a.ubication?.name || "";
			const locationB = b.ubication?.name || "";

			// Ordenar por ubicación
			if (locationA !== locationB) {
				return locationA.localeCompare(locationB);
			}

			// Función para normalizar el tiempo según la lógica de "mañana" y "noche"
			const normalizeTime = (time) => {
				const [hours, minutes] = time.split(":").map(Number);
				// Si la hora es menor que 4, se considera como parte de la noche anterior
				return hours < 4 ? hours + 24 : hours;
			};

			const intervalsA = getStaffingAssignmentIntervals(a);
			const intervalsB = getStaffingAssignmentIntervals(b);
			if (!intervalsA.length || !intervalsB.length) {
				return !intervalsA.length ? 1 : -1;
			}

			// Si la ubicación es la misma, ordenar por la hora de inicio
			const startA = normalizeTime(intervalsA[0].start);
			const startB = normalizeTime(intervalsB[0].start);

			if (startA !== startB) {
				return startA - startB;
			}

			// Si las horas son iguales, se comparan los minutos
			const minutesA = parseInt(intervalsA[0].start.split(":")[1], 10);
			const minutesB = parseInt(intervalsB[0].start.split(":")[1], 10);
			return minutesA - minutesB;
		});
	}

	_normalizeStaffingAssignmentsPayload(payload) {
		if (!payload) return [];
		if (Array.isArray(payload)) return payload;
		if (Array.isArray(payload.data)) return payload.data;
		return [];
	}

	// get staffing levels assignments
	getFilteredStaffingLevelAssignments(overrides = {}) {
		const {
			staffing_loading,
			ubication_id,
			ubication_staffing_id,
			name,
			search_staffing_shift,
		} = this.state;

		const filtro_ubicacion_id = this._isActiveFilterId(ubication_staffing_id)
			? ubication_staffing_id
			: ubication_id;
		const filtro_funcion_ids = this._getStaffingFunctionFilterIds();

		if (!staffing_loading) {
			this.setState({
				staffing_loading: true,
			});
		}

		var staffing_level_assignments =
			overrides.staffing_level_assignments !== undefined
				? overrides.staffing_level_assignments
				: this._normalizeStaffingAssignmentsPayload(
						this.props.staffing_level_assignments
					);

		// filtrar por nombre de necesidad de personal (con sugerencias)
		if (name && name.length > 0) {
			staffing_level_assignments = staffing_level_assignments
				? staffing_level_assignments.filter((o) =>
						o.name.toLowerCase().includes(name.toLowerCase())
					)
				: [];
		}

		// filtrar por nombre de turno
		if (search_staffing_shift && search_staffing_shift.length > 0) {
			staffing_level_assignments = staffing_level_assignments
				? staffing_level_assignments.filter(
						(o) =>
							o.shift &&
							o.shift.name
								.toLowerCase()
								.includes(search_staffing_shift.toLowerCase())
					)
				: [];
		}

		// filtrar por ubicación
		if (parseInt(filtro_ubicacion_id) > 0) {
			staffing_level_assignments = staffing_level_assignments
				? staffing_level_assignments.filter(
						(o) =>
							o.ubication && o.ubication.id === parseInt(filtro_ubicacion_id)
					)
				: [];
		}

		// filtrar por función
		if (filtro_funcion_ids.length > 0) {
			staffing_level_assignments = staffing_level_assignments
				? staffing_level_assignments.filter(
						(o) => o.function && filtro_funcion_ids.includes(o.function.id)
					)
				: [];
		}

		if (staffing_level_assignments.length === 0) {
			var staffing_level_current_assignments =
				overrides.staffing_level_current_assignments !== undefined
					? overrides.staffing_level_current_assignments
					: this._normalizeStaffingAssignmentsPayload(
							this.props.staffing_level_current_assignments
						);

			if (staffing_level_current_assignments.length > 0) {
				if (parseInt(filtro_ubicacion_id) > 0) {
					staffing_level_current_assignments =
						staffing_level_current_assignments
							? staffing_level_current_assignments.filter(
									(o) =>
										o.ubication &&
										o.ubication.id === parseInt(filtro_ubicacion_id)
								)
							: [];
				}

				if (filtro_funcion_ids.length > 0) {
					staffing_level_current_assignments =
						staffing_level_current_assignments
							? staffing_level_current_assignments.filter(
									(o) =>
										o.function && filtro_funcion_ids.includes(o.function.id)
								)
							: [];
				}
			}

			this.setState({
				staffing_loading: false,
				staffing_level_assignments: [],
				staffing_level_current_assignments:
					this.sortShiftsByLocationAndStartTime(
						staffing_level_current_assignments
					),
				needs_selection: [], // reset selection
			});
		} else {
			this.setState({
				staffing_loading: false,
				staffing_level_assignments: this.sortShiftsByLocationAndStartTime(
					staffing_level_assignments
				),
				staffing_level_current_assignments: [],
				needs_selection: [], // reset selection
			});
		}
	}

	// get staffing levels HOURLY assignments
	async getStaffingLevelHourlyAssignments() {
		const {
			group_id,
			start,
			end,
			staffing_hourly_loading,
			ubication_id,
			hasPrivileges,
		} = this.state;

		const { working_hours } = this.props;

		// const format = 'HH:mm';
		// var start_hour = moment(working_hours.start).format(format);
		// var end_hour = moment(working_hours.end).format(format);
		var start_hour = working_hours.start;
		var end_hour = working_hours.end;

		start_hour = start_hour.substring(0, 3) + "00"; // fix guarro perque sigui en punt

		// Incluir necesidades de madrugada en la API (columna 0h del día siguiente u overflow en 23h)
		const postMidnightEndHour = this._getPostMidnightStaffingEndHour(
			this.state.plan_assignments
		);
		if (
			postMidnightEndHour ||
			this._planHasPostMidnightExtension(this.state.plan_assignments) ||
			(this.state.staffing_level_hourly_assignments || []).some((assignment) =>
				(assignment.counters || []).some((day) =>
					(day.hours || []).some((hourEntry) => {
						const local = convertFromUTC(hourEntry.hour);
						return (
							local &&
							Number(hourEntry.needed) > 0 &&
							parseInt(local.split(":")[0], 10) === 0
						);
					})
				)
			)
		) {
			end_hour = postMidnightEndHour || "00:59";
		}

		if (hasPrivileges) {
			if (!staffing_hourly_loading) {
				this.setState({
					staffing_hourly_loading: true,
				});
			}
			await this.props.getStaffingLevelHourlyAssignments({
				group_id,
				start,
				end,
				...this._getFunctionFilterForApi(),
				ubication_id,
				start_hour,
				end_hour,
			});

			var staffing_level_hourly_assignments =
				this.props.staffing_level_hourly_assignments;

			// Si el rango de las necesidades excede el rango visual actual
			// (first_hour/last_hour calculado desde los turnos), re-ejecutamos
			// getPlanAssignments para que working_hours_list y plan_assignments[].plans[].hours
			// se reconstruyan cubriendo también las horas con necesidad
			// (p. ej. necesidad 09:00 cuando el primer turno del personal empieza a las 11:00).
			const needsRange = this._calculateNeedsHoursRange(
				staffing_level_hourly_assignments
			);

			const currentFirst = this.state.first_hour;
			const currentLast = this.state.last_hour;
			const needsExpandGrid =
				needsRange.hasNeeds &&
				needsRange.first_hour &&
				needsRange.last_hour &&
				(moment(needsRange.first_hour, "HH:mm").isBefore(
					moment(currentFirst, "HH:mm")
				) ||
					moment(needsRange.last_hour, "HH:mm").isAfter(
						moment(currentLast, "HH:mm")
					));

			this.setState(
				{
					staffing_hourly_loading: false,
					staffing_level_hourly_assignments,
				},
				() => {
					// Solo realinear el plan si las needs exigen columnas fuera del rango actual.
					// Evita getPlanAssignments() full (congela planes grandes) en cada refresh de staffing.
					if (needsExpandGrid) {
						this._realignPlanGridToNeedsRange();
					}
				}
			);
		} else if (this.state.staffing_hourly_loading) {
			// Sin privilegios no hay API de needs; permitir revelar planned-only.
			this.setState({ staffing_hourly_loading: false });
		}
	}

	/**
	 * Rehace `working_hours_list` y `plans[].hours` cuando las necesidades piden
	 * columnas fuera del rango actual.
	 *
	 * Los turnos no han cambiado, solo el rango de la rejilla, así que reutiliza
	 * la última respuesta completa en memoria en vez de repetir
	 * `GET plans/assignments`. Antes esta rama duplicaba en cada carga de la
	 * vista Horas la petición de assignments (y con ella la de ausencias).
	 */
	_realignPlanGridToNeedsRange() {
		const { group_id, start, end } = this.state;
		const cached = this._lastFullPlanAssignmentsData;
		const isCurrentPeriod =
			this._lastFullPlanAssignmentsKey === `${group_id}|${start}|${end}`;

		if (!cached?.length || !isCurrentPeriod) {
			this.getPlanAssignments();
			return;
		}

		this.getPlanAssignments(undefined, {
			prefetchedResponse: { ok: true, data: cached },
			skipAbsencesReload: true,
		});
	}

	closeModal = () => {
		this.props.hideModal();
	};

	openNewPlanviewModal = async () => {
		await Promise.all([this.props.getAccounts(), this.props.getRules()]);

		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.newView"),
				style: { width: "600px" },
				content: <PlanViewEditModal handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	};

	// change group published modal
	openChangePublishedModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.publicationDate"),
				style: { width: "400px" },
				content: (
					<GroupPublished
						group={this.state.group}
						handleClose={this.closeModal}
						updateGroup={this.updateGroup}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// open new shift modal
	openNewShiftModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.newShift"),
				style: { width: "600px" },
				content: (
					<ShiftEditModal
						getShifts={this.getShifts}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditShiftModal(shift) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("shifts.editShift"),
				style: { width: "640px", maxHeight: "90vh" },
				content: (
					<ShiftEditModal
						shift={shift}
						getShifts={this.getShifts}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// open new employee modal
	openNewEmployeeModal() {
		const { group_id } = this.state;

		const setModalTitle = (newTitle) => {
			this.props.showModal(
				{
					open: true,
					title: newTitle, // Se actualiza dinámicamente
					style: { width: "500px" },
					content: (
						<EmployeeEditModal
							group_id={group_id}
							handleClose={this.closeModal}
							setModalTitle={setModalTitle} // Se pasa al componente del modal
							reloadGroupData={this.getAllAssignments} // Recarga los datos al cerrar el modal
						/>
					),
					closeModal: this.closeModal,
				},
				"edit"
			);
		};

		// Configura el título inicial
		setModalTitle(this.props.t("plan.modal.newEmployee"));
	}

	openNewFunctionModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("functions.newFunction"),
				style: { width: "400px" },
				content: (
					<FunctionEdit
						getFunctions={this.props.getSelectableFunctions}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openNewStaffingLevelCatalogModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("staffingLevels.createModal"),
				style: STAFFING_LEVEL_MODAL_STYLE,
				content: (
					<StaffingLevelCatalogModal
						handleClose={this.closeModal}
						getStaffingLevels={this.props.getSelectableStaffingLevels}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openNewUbicationModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.newUbication"),
				style: { width: "450px" },
				content: (
					<UbicationEdit
						getUbications={() => this.getUbications()}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openNewShiftPatternModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftPatterns.newShiftPattern"),
				style: { width: "980px", maxWidth: "calc(100vw - 32px)" },
				content: (
					<ShiftPatternEditModal handleClose={this.closeModal} />
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// edit shift modal
	openEditPlanShiftModal(plan) {
		const shift_name = plan.shift_plan.shift.name;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.editPlanShift", { name: shift_name }),
				style: { width: "600px" },
				content: (
					<PlanShiftEditModal
						plan={plan}
						groupId={this.state.group_id}
						registerUndoAndShowToast={this.props.registerUndoAndShowToast}
						patchPlanShiftAfterEdit={this.patchPlanShiftAfterEdit}
						updateEmployeeIdsAndGetAllAssignments={
							this.updateEmployeeIdsAndGetAllAssignments
						}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// exchange shift modal
	openExchangePlanShiftModal(plan) {
		// const shift_name = plan.shift_plan.shift.name;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("planShiftExchange.title"),
				style: { width: "400px" },
				content: (
					<PlanShiftExchangeModal
						plan={plan}
						updateEmployeeIdsAndGetAllAssignments={
							this.updateEmployeeIdsAndGetAllAssignments
						}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openTemporaryEmployeesModal = (itemStaffing) => {
		const functionId = itemStaffing?.function?.id;
		const groupId = this.state.group?.id;
		if (!functionId || !groupId || !itemStaffing?.day) return;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.temporaryEmployees.title"),
				style: { width: "1040px" },
				content: (
					<TemporaryGroupEmployeesModal
						functionId={functionId}
						functionName={itemStaffing.function.name}
						groupId={groupId}
						openDay={itemStaffing.day}
						onAssigned={this.getAllAssignments}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// edit staffing level modal
	openEditStaffingLevelModal(options) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.editStaffingNeeds"),
				style: { width: "850px" },
				content: (
					<StaffingLevelEditModal
						options={options}
						getStaffingLevelAssignments={this.getStaffingLevelAssignments}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// sort employees modal
	loadEmployeeGroupOrder = async (group_id) => {
		if (!group_id) return;

		try {
			const response = await employeesService.getEmployeesByGroupOrdered(group_id);
			if (response.ok && Array.isArray(response.data)) {
				this._employeeGroupOrderIds = response.data.map((employee) => employee.id);
			}
		} catch (error) {
			console.error("Error loading employee group order:", error);
		}
	};

	_unwrapEmployeeList = (response) => {
		if (Array.isArray(response)) return response;
		if (response?.ok && Array.isArray(response.data)) return response.data;
		return [];
	};

	resolveChildGroupAssignments = async (employees, groupId) => {
		return Promise.all(
			employees.map(async (employee) => {
				const currentAssignment = employee.employee_with_group;
				const assignmentGroupId = currentAssignment?.group
					? currentAssignment.group.id
					: null;

				if (Number(assignmentGroupId) === Number(groupId)) {
					return employee;
				}

				const employeeGroupsResponse = await employeesService.getGroups(
					employee.id
				);
				const employeeGroups = this._unwrapEmployeeList(employeeGroupsResponse);
				if (employeeGroups.length === 0) return employee;

				const groupAssignment = employeeGroups
					.filter(
						(item) =>
							item.group && Number(item.group.id) === Number(groupId)
					)
					.sort(
						(a, b) =>
							moment(b.start_day).valueOf() - moment(a.start_day).valueOf()
					)[0];

				return groupAssignment
					? { ...employee, employee_with_group: groupAssignment }
					: employee;
			})
		);
	};

	loadChildGroupMemberships = async (group) => {
		if (!group?.is_multigroup || !Array.isArray(group.groups)) {
			this.setState({ childGroupMemberships: {} });
			return;
		}

		const memberships = {};
		await Promise.all(
			group.groups.map(async (child) => {
				const response = await employeesService.getAll({
					history_group_id: child.id,
					variant: "detailed",
					page_size: 2000,
				});
				const employees = await this.resolveChildGroupAssignments(
					this._unwrapEmployeeList(response),
					child.id
				);
				employees.forEach((emp) => {
					const assignment = emp.employee_with_group;
					if (!assignment || Number(assignment.group?.id) !== Number(child.id)) {
						return;
					}
					if (!memberships[emp.id]) memberships[emp.id] = [];
					memberships[emp.id].push({
						groupId: child.id,
						start_day: assignment.start_day,
						end_day: assignment.end_day || null,
					});
				});
			})
		);
		this.setState({ childGroupMemberships: memberships }, () =>
			this._schedulePlanRowHeightSync()
		);
	};

	toggleMultigroupSection = (groupId) => {
		this.setState((prev) => ({
			collapsedGroupIds: {
				...prev.collapsedGroupIds,
				[groupId]: !prev.collapsedGroupIds[groupId],
			},
		}));
	};

	_getMultigroupGrouping = () => {
		const {
			group,
			plan_grid_view,
			plan_assignments,
			childGroupMemberships,
			collapsedGroupIds,
			start,
			end,
		} = this.state;
		const accountAssignments = this.props.account_assignments;

		if (
			!group?.is_multigroup ||
			plan_grid_view !== PLAN_GRID_VIEWS.default
		) {
			this._multigroupDataCache = null;
			return null;
		}

		const cache = this._multigroupDataCache;
		const dataUnchanged =
			cache &&
			cache.group === group &&
			cache.plan_assignments === plan_assignments &&
			cache.accountAssignments === accountAssignments &&
			cache.childGroupMemberships === childGroupMemberships &&
			cache.start === start &&
			cache.end === end;

		const data = dataUnchanged
			? cache.data
			: buildMultigroupPlanSections({
					childGroups: group.groups || [],
					assignments: plan_assignments,
					accountAssignments,
					memberships: childGroupMemberships,
					range: { start, end },
			  });

		if (!dataUnchanged) {
			this._multigroupDataCache = {
				group,
				plan_assignments,
				accountAssignments,
				childGroupMemberships,
				start,
				end,
				data,
			};
		}

		return {
			...data,
			sections: data.sections.map((section) => ({
				...section,
				collapsed: Boolean(collapsedGroupIds[section.group.id]),
			})),
		};
	};

	_sortPlanAssignmentsByGroupOrder = (plan_assignments) =>
		sortPlanAssignmentsByEmployeeIds(
			plan_assignments,
			this._employeeGroupOrderIds
		);

	handleEmployeeOrderSaved = async (employeeIds) => {
		this._employeeGroupOrderIds = employeeIds;

		if (this._lastFullPlanAssignmentsData?.length) {
			this._lastFullPlanAssignmentsData = sortPlanAssignmentsByEmployeeIds(
				this._lastFullPlanAssignmentsData,
				employeeIds
			);
		}

		await this.getPlanAssignments();
	};

	openEmployeesOrderModal(group) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.sortEmployees"),
				style: { width: "450px" },
				content: (
					<EmployeeOrderModal
						group={group}
						planAssignments={this.state.plan_assignments}
						handleEmployeeOrderSaved={this.handleEmployeeOrderSaved}
						getAccountAssignments={this.getAccountAssignments}
						syncRowHeights={this.syncRowHeights}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// Plan view normal / timetables
	// plan: 1,
	// times: 2,
	// ubications: 3,
	// hours: 4,
	// combo: 5
	// vertical: 6
	// ubication_grouped: 7

	// Verifica si los datos de staffing necesitan ser recargados
	shouldReloadStaffingData = (staffingOverride) => {
		const staffing_level_hourly_assignments =
			staffingOverride ??
			(this.state.staffing_level_hourly_assignments?.length
				? this.state.staffing_level_hourly_assignments
				: this.props.staffing_level_hourly_assignments);

		if (
			!staffing_level_hourly_assignments ||
			staffing_level_hourly_assignments.length === 0
		) {
			return true; // No hay datos, necesita cargar
		}

		// Verificar si los datos corresponden al rango de fechas actual
		const { start, end } = this.state;
		const dayKey = (d) => (d || "").toString().slice(0, 10);

		// Obtener todos los días únicos de los datos de staffing
		const staffingDays = new Set();
		staffing_level_hourly_assignments.forEach((assignment) => {
			(assignment.counters || []).forEach((counter) => {
				staffingDays.add(dayKey(counter.day));
			});
		});

		// Generar los días esperados basados en start y end
		const expectedDays = new Set();
		const startMoment = moment(start);
		const endMoment = moment(end);

		let current = startMoment.clone();
		while (current.isSameOrBefore(endMoment)) {
			expectedDays.add(current.format("YYYY-MM-DD"));
			current.add(1, "day");
		}

		// Verificar si los días coinciden
		const hasAllExpectedDays = Array.from(expectedDays).every((day) =>
			staffingDays.has(day)
		);
		const hasOnlyExpectedDays = Array.from(staffingDays).every((day) =>
			expectedDays.has(day)
		);

		const needsReload = !hasAllExpectedDays || !hasOnlyExpectedDays;

		return needsReload;
	};

	isPlanSelectionView = () => {
		if (this.state.planViewMode !== "grid") {
			return false;
		}

		const { plan_grid_view } = this.state;

		return (
			plan_grid_view === PLAN_GRID_VIEWS.default ||
			plan_grid_view === PLAN_GRID_VIEWS.grid ||
			plan_grid_view === PLAN_GRID_VIEWS.ubications
		);
	};

	handleChangeView = (grid_view) => {
		localStorage.setItem("plan_grid_view", grid_view);

		const enteringHours = grid_view === PLAN_GRID_VIEWS.hours;
		const leavingHours =
			this.state.plan_grid_view === PLAN_GRID_VIEWS.hours && !enteringHours;
		// Staffing horario solo alimenta la cobertura; la grilla ya tiene plans[].hours.
		// No bloquear el switch: chrome+velo al instante; montar grilla tras paint.
		const needsStaffingData =
			enteringHours && this.shouldReloadStaffingData();

		if (this._hoursLayoutReadyRaf != null) {
			cancelAnimationFrame(this._hoursLayoutReadyRaf);
			this._hoursLayoutReadyRaf = null;
		}
		if (this._hoursNeedsRevealRaf != null) {
			cancelAnimationFrame(this._hoursNeedsRevealRaf);
			this._hoursNeedsRevealRaf = null;
		}
		if (this._hoursEnterTimer != null) {
			clearTimeout(this._hoursEnterTimer);
			this._hoursEnterTimer = null;
		}
		if (leavingHours) {
			this._abortPlanAssignmentsLoad();
			this._releaseStalePaginatedLoad(this._planAssignmentsLoadId);
		}

		this.setState(
			() => {
				const nextState = {
					isExtendedView:
						grid_view === PLAN_GRID_VIEWS.ubication_grouped ||
						grid_view === PLAN_GRID_VIEWS.shifts,
					plan_grid_view: grid_view,
				};

				if (enteringHours) {
					// 1.er paint: solo shell + velo (sin grilla horas ni needs).
					// La grilla ±800–2600 celdas bloqueaba el main thread y el 2.º
					// switch parecía “no entrar” hasta terminar el render.
					nextState.hoursNeedsRevealed = false;
					nextState.hoursNeedsMaxHeightPx = 0;
					nextState.hoursLayoutReady = false;
					nextState.hoursPlanMounted = false;
					if (needsStaffingData) {
						nextState.staffing_hourly_loading = true;
					}
				}

				return nextState;
			},
			() => {
				if (enteringHours) {
					// setTimeout(0): ceder al browser para pintar botón Horas + velo
					// antes de montar la grilla pesada bajo el overlay.
					this._hoursEnterTimer = setTimeout(async () => {
						this._hoursEnterTimer = null;
						if (this.state.plan_grid_view !== PLAN_GRID_VIEWS.hours) {
							return;
						}
						this.unselectAllDays();

						// Paginación en otras vistas salta plans[].hours (skipHoursGrid).
						// Sin rebuild, getHourlyPlanRowContentList hace .map sobre undefined.
						try {
							const loadIncomplete = !this._isPlanLoadComplete();
							const hoursMissing = this._planHoursGridMissing();
							if (loadIncomplete || hoursMissing) {
								if (loadIncomplete) {
									// Abort + relanzar: vista ya es Horas → pagina y construye hours por chunk.
									this._abortPlanAssignmentsLoad();
									await this.getAllAssignments([]);
								} else {
									// Carga completa: rebuild local sin nueva llamada a plans/assignments.
									await this._rebuildPlanHoursGridLocally();
								}
							}
						} catch (error) {
							console.error(
								"Error rebuilding hours grid for Hours view:",
								error
							);
						}

						if (this.state.plan_grid_view !== PLAN_GRID_VIEWS.hours) {
							return;
						}
						this.setState({ hoursPlanMounted: true }, () => {
							this._hoursLayoutReadyRaf = requestAnimationFrame(() => {
								this._hoursLayoutReadyRaf = null;
								if (this.state.plan_grid_view !== PLAN_GRID_VIEWS.hours) {
									return;
								}
								this.setState({ hoursLayoutReady: true }, () => {
									this._schedulePlanRowHeightSync();
									this.ensureScrollSyncListeners();
								});
							});
						});
						if (needsStaffingData) {
							this.getStaffingLevelHourlyAssignments();
						}
					}, 0);
					return;
				}
				this.unselectAllDays();
				requestAnimationFrame(() => {
					this._schedulePlanRowHeightSync();
					this.ensureScrollSyncListeners();
				});
			}
		);
	};

	// Método para generar las opciones del select de vistas
	getViewOptions = () => {
		const { plan_grid_view, isLongPeriod, plan_option_ubications } = this.state;
		const options = [];

		// Funciones (siempre disponible)
		options.push({
			value: PLAN_GRID_VIEWS.default,
			label: this.props.t("plan.view.functions"),
			disabled: false,
		});

		// Horas
		options.push({
			value: PLAN_GRID_VIEWS.hours,
			label: this.props.t("plan.view.hours"),
			disabled: isLongPeriod,
		});

		// Turnos
		options.push({
			value: PLAN_GRID_VIEWS.shifts,
			label: this.props.t("plan.view.shifts"),
			disabled: false,
		});

		// Ubicaciones (si están disponibles)
		if (plan_option_ubications && plan_option_ubications.length > 0) {
			options.push({
				value: PLAN_GRID_VIEWS.ubications,
				label: this.props.t("plan.view.ubications"),
				disabled: false,
			});

			options.push({
				value: PLAN_GRID_VIEWS.ubication_grouped,
				label: this.props.t("plan.view.ubicationsGrouped"),
				disabled: false,
			});
		}

		// Simple
		options.push({
			value: PLAN_GRID_VIEWS.grid,
			label: this.props.t("plan.view.simple"),
			disabled: false,
		});

		return options;
	};

	// change plan view -> refresh counters or filter by function
	handleChangeSearch = (event) => {
		const target = event.target.id;
		const value = event.target.value;

		this.setState(
			(prevState) => {
				// Crear un nuevo estado basado en la condición del target
				const newState = { [target]: value };

				if (target === "ubication_id") {
					newState["ubication_staffing_id"] = value;
				}

				return newState;
			},
			async () => {
				if (
					target === "ubication_staffing_id" ||
					target === "function_staffing_id" ||
					target === "search_staffing_shift"
				) {
					// filtro por front
					this.getFilteredStaffingLevelAssignments();
				} else if (target === "name") {
					// nada
				} else {
					if (target === "ubication_id") {
						await this.getPlanAssignments();
						await this.getStaffingLevelAssignments();
					}

					await this.getAccountAssignments();

					this.syncRowHeights();
				}
			}
		);
	};

	onClearStaffingShiftSearch = () => {
		this.setState(
			{
				search_staffing_shift: "",
			},
			() => {
				this.getFilteredStaffingLevelAssignments();
			}
		);
	};

	autoPlan = async () => {
		const { group_id, start, end } = this.state;

		if (group_id && start && end) {
			await plansService.setAssignments({ group_id, start, end });
			this.getPlanCalculations();
			this.unselectAllDays();
		}
	};

	// Devuelve los IDs de TODOS los empleados del grupo, obtenidos de forma
	// fresca y acotada por group_id. Si la llamada falla, cae a la lista ya
	// cargada en `select_employees`.
	getGroupEmployeeIds = async (groupId) => {
		const toIds = (list) =>
			(Array.isArray(list) ? list : [])
				.map((emp) => parseInt(emp?.id, 10))
				.filter((id) => !Number.isNaN(id));

		try {
			const response = await employeesService.getSelectable({
				group_id: groupId,
				page_size: 2000,
			});
			const data = response?.data ?? response;
			const ids = toIds(data);
			if (ids.length > 0) return ids;
		} catch (error) {
			console.error("Error obteniendo empleados del grupo:", error);
		}

		return toIds(this.props.select_employees);
	};

	planIntelligentHandler = async () => {
		if (this.state.planIntelligentStatus.state === "FINISHED") {
			const result = ScheduleParser.parseDetailed(
				this.state.planIntelligentStatus
			);
			// Enviamos TODOS los empleados del grupo, no solo los que tienen algún
			// turno en los planes. Así el backend elimina los turnos de
			// disponibilidad de todos los empleados aunque no se les haya asignado
			// ningún turno. Obtenemos la lista fresca y ACOTADA por group_id para
			// no depender de `select_employees` (que otro flujo podría sobrescribir
			// con empleados de otros grupos). Fallbacks: `select_employees` y, en
			// último caso, los empleados presentes en los planes/`request`.
			const groupId = this.state.planIntelligentStatus.group_id;
			const groupEmployeeIds = await this.getGroupEmployeeIds(groupId);

			const mergedEmployeeIds = Array.from(
				new Set([
					...groupEmployeeIds,
					...(result.all_employee_ids || result.employee_ids || []),
				])
			).sort((a, b) => a - b);

			const employee_ids =
				mergedEmployeeIds.length > 0
					? mergedEmployeeIds
					: result.employee_ids;
			const plans_to_save = {
				group_id: this.state.planIntelligentStatus.group_id,
				employee_ids,
				start: result.start,
				end: result.end,
				plans: result.plans,
				id: result.process_id,
			};
			const roundedCobertura = parseFloat(
				result.stats.completion_rate.toFixed(2)
			);

			this.props.showModal(
				{
					open: true,
					title: this.props.t("plan.intelligentPlan.confirmTitle"),
					style: { width: "600px" },
					content: (
						<PlanIntelligentModal
							roundedCobertura={roundedCobertura}
							planIntelligentStatus={this.state.planIntelligentStatus}
							handleClose={async () => {
								const response = await plansService.discardIntelligent(
									this.state.planIntelligentStatus.id
								);
								if (response.ok) {
									this.setState({
										planBtnState: "",
									});
									this.props.hideModal();
								} else {
									this.openAlertModal(
										this.props.t("plan.intelligentPlan.errorDiscarding")
									);
								}
							}}
							handleSubmit={(e) => {
								e.preventDefault(); // Prevent default form submission
								this.saveIntelligentPlan(plans_to_save);
							}}
						/>
					),
					closeModal: this.closeModal,
				},
				"edit"
			);
		}
	};

	handleIntelligentPlanButtonClick = async () => {
		if (this.isPlanButtonActionRunning) return;

		this.isPlanButtonActionRunning = true;
		try {
			if (this.state.planBtnState === "PROCESSING") {
				await this.cancelIntelligentPlanning();
				return;
			}

			await this.planIntelligentHandler();
		} finally {
			this.isPlanButtonActionRunning = false;
		}
	};

	saveIntelligentPlan = async (plans_to_save) => {
		const response = await plansService.updateIntelligent(plans_to_save);
		if (response.ok) {
			this._clearPlanUndoScope();
			window.location.reload();
		}
		this.props.hideModal();
	};

	cancelIntelligentPlanning = async () => {
		const { planIntelligentStatus, group_id } = this.state;

		try {
			let response;

			// Si tenemos el ID de la planificación, usarlo directamente
			if (planIntelligentStatus && planIntelligentStatus.id) {
				response = await iPlanService.cancelIntelligentPlanning(
					planIntelligentStatus.id
				);
			} else {
				// Si no tenemos ID, obtener el estado actual del servidor y cancelar
				const statusResponse =
					await plansService.getPlanIntelligentStatus(group_id);
				if (statusResponse && statusResponse[0] && statusResponse[0].id) {
					response = await iPlanService.cancelIntelligentPlanning(
						statusResponse[0].id
					);
				} else {
					plansSocketService.unsubscribeIntelligentPlanning();
					this.setState(
						{
							planBtnState: "",
							planIntelligentStatus: null,
							planIntelligentTimerStart: null,
						},
						() => {
							plansSocketService.subscribeToIntelligentPlanning(
								this.state.group_id,
								this.handleIntelligentPlanningMessage
							);
						}
					);
					toastr.success(
						this.props.t("plan.intelligentPlan.title"),
						this.props.t("plan.intelligentPlan.cancelledOk"),
						{ progressBar: true, timeOut: 3000 }
					);
					return;
				}
			}

			if (response && response.ok) {
				plansSocketService.unsubscribeIntelligentPlanning();
				this.setState(
					{
						planBtnState: "",
						planIntelligentStatus: null,
						planIntelligentTimerStart: null,
					},
					() => {
						plansSocketService.subscribeToIntelligentPlanning(
							this.state.group_id,
							this.handleIntelligentPlanningMessage
						);
					}
				);
				toastr.success(
					this.props.t("plan.intelligentPlan.title"),
					this.props.t("plan.intelligentPlan.cancelledOk"),
					{ progressBar: true, timeOut: 3000 }
				);
			} else {
				this.openAlertModal(
					this.props.t("plan.intelligentPlan.errorCancelling")
				);
			}
		} catch (error) {
			console.error("Error al cancelar planificación:", error);
			this.openAlertModal(this.props.t("plan.intelligentPlan.errorCancelling"));
		}
	};

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title || this.props.t("plan.modal.errorDeleting"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	formatPlanEmployeeName = (employee) =>
		[employee?.name, employee?.surname].filter(Boolean).join(" ").trim();

	openPlanMissingContractPrompt = (entries = []) => {
		if (!entries.length) return;

		this.setState({ missingContractPromptEntries: entries });
	};

	_loadEmployeeContractsForPlan = async (employeeId) => {
		if (this._cachedEmployeeContracts.has(employeeId)) {
			return this._cachedEmployeeContracts.get(employeeId);
		}

		const response = await employeesService.getContracts(employeeId);
		const contracts = Array.isArray(response)
			? response
			: Array.isArray(response?.data)
				? response.data
				: null;
		if (!contracts) {
			throw new Error("contracts unavailable");
		}

		this._cachedEmployeeContracts.set(employeeId, contracts);
		return contracts;
	};

	_missingContractsForSelection = (plan_assignments, day_selection) =>
		resolveEmployeesWithoutContractForDays(
			plan_assignments,
			day_selection,
			(employeeId) => this._loadEmployeeContractsForPlan(employeeId)
		);

	closePlanMissingContractPrompt = () => {
		this.setState({ missingContractPromptEntries: [] });
	};

	closeUserMissingContractModal = () => {
		this.setState({ userMissingContractModalOpen: false });
	};

	handleUserMissingContractAssign = () => {
		this.closeUserMissingContractModal();
		this.openEmployeeContractAssignModal(this.props.user);
	};

	handlePlanMissingContractAssign = (employee, day) => {
		this.closePlanMissingContractPrompt();
		this.openEmployeeContractAssignModal(employee, day);
	};

	openEmployeeContractAssignModal = (employee, suggestedStartDay) => {
		if (!employee?.id) return;

		if (typeof this.props.getContracts === "function") {
			this.props.getContracts();
		}
		if (typeof this.props.getEmployeeContracts === "function") {
			this.props.getEmployeeContracts(employee.id);
		}

		this.props.showModal(
			{
				open: true,
				title: this.props.t("contracts.assignment.assignContract"),
				style: { width: "350px" },
				content: (
					<EmployeeContractEdit
						handleClose={this.closeModal}
						employee={employee}
						suggestedStartDay={suggestedStartDay}
						onDataChanged={this.handlePlanEmployeeContractChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	};

	handlePlanEmployeeContractChanged = () => {
		clearTimeout(this._planEmployeeContractRefreshTimer);
		this._planEmployeeContractRefreshTimer = setTimeout(() => {
			this.getAllAssignments();
		}, 300);
	};

	_tryOpenMissingContractPromptFromPlanErrors = (
		chunkResults,
		plansToSave,
		plan_assignments
	) => {
		const employeeById = new Map(
			(plan_assignments || []).map((row) => [row.employee?.id, row.employee])
		);

		let flatIndex = 0;
		for (const result of chunkResults || []) {
			if (result.status !== "fulfilled" || !Array.isArray(result.value)) {
				continue;
			}

			for (const item of result.value) {
				const planPayload = plansToSave?.[flatIndex];
				flatIndex += 1;

				const contractError = (item.errors || []).find(
					isContractNotFoundPlanError
				);
				if (!contractError) continue;

				const employeeId = planPayload?.employee_id;
				const employee = employeeById.get(employeeId);

				if (employee && planPayload?.day) {
					this.openPlanMissingContractPrompt([
						{ employee, day: planPayload.day },
					]);
					return true;
				}
			}
		}

		return false;
	};

	// Restaura checked en plan_assignments según day_selection (p. ej. tras recargar datos).
	_applyDaySelectionToAssignments = (plan_assignments, day_selection = []) => {
		if (!Array.isArray(plan_assignments) || plan_assignments.length === 0) {
			return plan_assignments;
		}
		if (!Array.isArray(day_selection) || day_selection.length === 0) {
			return plan_assignments;
		}

		const selectionSet = new Set(
			day_selection.map((d) => `${d.row}:${d.index}`)
		);

		return plan_assignments.map((assignment, row) => ({
			...assignment,
			plans: (assignment.plans || []).map((plan, index) => ({
				...plan,
				checked: selectionSet.has(`${row}:${index}`),
			})),
		}));
	};

	// seleccionar días

	handleDaySelection = (row, index, event) => {
		if (!this.isPlanSelectionView() || this.state.isSidebarDragging) {
			return;
		}

		this.setState(
			(prevState) => {
				const alreadySelected = isDaySelected(
					prevState.day_selection,
					row,
					index
				);
				const value = nextCheckedFromDayClick(event, alreadySelected);

				if (value === alreadySelected) {
					return null;
				}

				return {
					plan_assignments: setAssignmentDayChecked(
						prevState.plan_assignments,
						row,
						index,
						value
					),
					day_selection: setDaySelected(
						prevState.day_selection,
						row,
						index,
						value
					),
				};
			},
			() => {
				if (this.state.day_selection.length > 0) {
					this.logReopenAbsenceUiState();
				}
			}
		);
	};

	selectAllDays = () => {
		if (!this.isPlanSelectionView() || !this._isPlanLoadComplete()) {
			return;
		}

		this.setState((prevState) => {
			const newSelection = [];
			const newPlanAssignments = prevState.plan_assignments.map(
				(assignment, row) => {
					const newPlans = assignment.plans.map((plan, index) => {
						newSelection.push({ row, index });
						return { ...plan, checked: true };
					});
					return { ...assignment, plans: newPlans };
				}
			);

			return {
				day_selection: newSelection,
				plan_assignments: newPlanAssignments,
			};
		});
	};

	unselectAllDays = () => {
		this.setState((prevState) => {
			const hasDaySelection = prevState.day_selection?.length > 0;
			const hasCheckedPlans = (prevState.plan_assignments || []).some(
				(assignment) =>
					(assignment.plans || []).some((plan) => plan.checked)
			);

			if (!hasDaySelection && !hasCheckedPlans) {
				return prevState;
			}

			const newPlanAssignments = prevState.plan_assignments.map(
				(assignment) => {
					const newPlans = assignment.plans.map((plan) => ({
						...plan,
						checked: false,
					}));
					return { ...assignment, plans: newPlans };
				}
			);

			return {
				plan_assignments: newPlanAssignments,
				day_selection: [],
				day_selection_copy: [],
				day_selection_dashed: [],
			};
		});
	};

	handleColumnSelection = (index) => {
		if (!this.isPlanSelectionView()) {
			return;
		}
		this.setState((prevState) => {
			const isColumnFullySelected = prevState.plan_assignments.every(
				(assignment, row) =>
					assignment.plans[index] &&
					prevState.day_selection.some(
						(d) => d.row === row && d.index === index
					)
			);

			const newPlanAssignments = prevState.plan_assignments.map(
				(assignment, row) => ({
					...assignment,
					plans: assignment.plans.map((plan, planIndex) =>
						planIndex === index
							? { ...plan, checked: !isColumnFullySelected }
							: plan
					),
				})
			);

			const selectionWithoutColumn = prevState.day_selection.filter(
				(d) => d.index !== index
			);
			const columnSelection = isColumnFullySelected
				? []
				: prevState.plan_assignments
						.map((assignment, row) =>
							assignment.plans[index] ? { row, index } : null
						)
						.filter(Boolean);

			return {
				day_selection: [...selectionWithoutColumn, ...columnSelection],
				plan_assignments: newPlanAssignments,
			};
		});
	};

	handleRowSelection = (row) => {
		if (!this.isPlanSelectionView()) {
			return;
		}

		this.setState((prevState) => {
			const assignment = prevState.plan_assignments[row];
			if (!assignment) {
				return null;
			}

			const plans = assignment.plans || [];

			// Índices de días activos (los inactivos son celdas deshabilitadas)
			const activeIndices = plans.reduce((acc, plan, index) => {
				if (plan.active) acc.push(index);
				return acc;
			}, []);

			const allSelected =
				activeIndices.length > 0 &&
				activeIndices.every((index) =>
					isDaySelected(prevState.day_selection, row, index)
				);

			let day_selection;
			let nextPlans;
			if (allSelected) {
				// Segunda pulsada: deseleccionar toda la fila
				day_selection = prevState.day_selection.filter((d) => d.row !== row);
				nextPlans = plans.map((plan) => ({ ...plan, checked: false }));
			} else {
				// Primera pulsada: seleccionar todos los días activos de la fila
				day_selection = [...prevState.day_selection];
				const selectedIndexes = new Set(activeIndices);
				activeIndices.forEach((index) => {
					if (!isDaySelected(day_selection, row, index)) {
						day_selection.push({ row, index });
					}
				});
				nextPlans = plans.map((plan, index) =>
					selectedIndexes.has(index) ? { ...plan, checked: true } : plan
				);
			}

			return {
				day_selection,
				plan_assignments: prevState.plan_assignments.map((item, r) =>
					r === row ? { ...item, plans: nextPlans } : item
				),
			};
		});
	};

	selectSingleDay = (row, index) => {
		// Vista Horas (y otras no-selection) no usan selección multi-día en UI,
		// pero el drop desde el sidebar de turnos sí necesita marcar el día destino
		// antes de handlePasteShifts.
		if (this._isSidebarDragging || this.state.isSidebarDragging) {
			return;
		}

		if (!this.isPlanSelectionView()) {
			return;
		}

		this.setState((prevState) => {
			const { plan_assignments, day_selection } = prevState;

			if (!plan_assignments || row >= plan_assignments.length) {
				return null;
			}

			if (
				!plan_assignments[row] ||
				!plan_assignments[row].plans ||
				index >= plan_assignments[row].plans.length
			) {
				return null;
			}

			if (isDaySelected(day_selection, row, index)) {
				return null;
			}

			return {
				plan_assignments: setAssignmentDayChecked(
					plan_assignments,
					row,
					index,
					true
				),
				day_selection: setDaySelected(day_selection, row, index, true),
			};
		});
	};

	// seleccionar necesidades de personal (celdas)

	handleNeedSelection = (row, index, isDragging, event, overrides = {}) => {
		const { staffing_level_assignments, group, shift_list } = this.state;
		var { needs_selection } = this.state;
		const value = event ? event.target.checked : true;
		const hasShiftSelection = this._hasSelection(shift_list);

		if (hasShiftSelection && isDragging) return;

		// validar que siguin de la mateixa fila
		var isValid = true;

		const assignment = staffing_level_assignments[row];
		var selectedAssignment = assignment.counters[index];
		const fn = selectedAssignment.function || assignment.function;
		const shift = selectedAssignment.shift || assignment.shift;
		const timeInterval =
			selectedAssignment.time_interval || assignment.time_interval;
		const ubication = selectedAssignment.ubication || assignment.ubication;

		if (value) {
			const neededValue = getEffectiveNeeded(selectedAssignment);
			const newSelection = {
				row,
				index,
				day: selectedAssignment.day,
				needed: neededValue,
				current:
					overrides.current !== undefined
						? overrides.current
						: selectedAssignment.current,
				function_id: fn.id,
				group_id: group.id, // selected group in plan
			};

			if (shift?.id) {
				newSelection.shift_id = shift.id;
			} else if (timeInterval) {
				newSelection.time_interval = timeInterval;
			}

			if (selectedAssignment.overwrite != null) {
				newSelection.overwrite = selectedAssignment.overwrite;
			}

			if (ubication) {
				newSelection.ubication_id = ubication.id;
			}

			if (overrides.replace) {
				// Flujo de edición (un solo click en el lápiz): reemplaza cualquier
				// selección previa en lugar de rechazar el cambio de fila. Así el modal
				// siempre refleja la necesidad realmente editada y no una anterior.
				needs_selection
					.filter((o) => o.row !== row || o.index !== index)
					.forEach((o) => {
						const prevAssignment = staffing_level_assignments[o.row];
						if (prevAssignment && prevAssignment.counters[o.index]) {
							prevAssignment.counters[o.index].checked = false;
						}
					});
				needs_selection = [newSelection];
			} else {
				if (needs_selection.length > 0) {
					const temp = needs_selection.filter((o) => o.row !== row);

					// si hay selecciones de otra fila
					if (temp.length > 0) {
						isValid = false;
					}
				}

				const existingIndex = needs_selection.findIndex(
					(o) => o.row === row && o.index === index
				);

				if (isValid) {
					if (existingIndex >= 0) {
						needs_selection[existingIndex] = {
							...needs_selection[existingIndex],
							...newSelection,
						};
					} else {
						needs_selection.push(newSelection);
					}
				}
			}
		} else {
			// remove need from list
			needs_selection = needs_selection.filter((o) => o.index !== index);
		}

		if (isValid) {
			staffing_level_assignments[row].counters[index].checked = value;

			this.setState({
				staffing_level_assignments,
				needs_selection,
			});
		} else {
			this.openAlertModal(
				this.props.t("plan.error.multipleRowSelection"),
				this.props.t("plan.error.selectionTitle")
			);
		}
	};

	// shifts stuff
	async getShifts() {
		const shift_list = await this.props.getAllShifts({
			q: this.state.search_shift,
			shift_type: this.state.search_shift_type_id,
			group_id: this.state.group_id,
		});

		this.setState({
			shift_list: shift_list || [],
		});
	}

	handleChangeFilter = (event) => {
		const target = event.target.id;

		this.setState(
			{
				[target]: event.target.value,
			},
			() => {
				if (target === "search_ubication") {
					this.getUbications();
				} else {
					this.getShifts();
				}
			}
		);
	};

	handleShiftSelection = (event) => {
		const { shift_list } = this.state;
		const countSelected = shift_list.filter((o) => o.checked === true).length;
		var id = event.target.id;
		id = id.replace("shift_", "");
		const value = event.target.checked;

		if (countSelected >= 3 && value) {
			toastr.error("", this.props.t("plan.error.maxShiftsPerDay"));
		} else {
			this.setState({
				shift_list: this.state.shift_list.map((o) =>
					o.id === parseInt(id) ? { ...o, checked: value } : o
				),
			});
		}
	};

	handleShiftDragSelection = (event) => {
		const { shift_list } = this.state;
		const countSelected = shift_list.filter((o) => o.checked === true).length;
		// currentTarget = <li draggable>; target puede ser un hijo (label/span) sin id
		const rawId =
			event.currentTarget?.id ||
			event.target?.closest?.("[id^='shift_li_']")?.id ||
			"";
		const id = rawId.replace("shift_li_", "");

		if (countSelected >= 3) {
			toastr.error("", this.props.t("plan.error.maxShiftsPerDay"));
			event.preventDefault();
			return;
		}

		if (!id || Number.isNaN(parseInt(id, 10))) {
			event.preventDefault();
			return;
		}

		this._isSidebarDragging = true;
		this._sidebarDragShiftId = parseInt(id, 10);
		this.setState({
			shift_list: this.state.shift_list.map((o) =>
				o.id === parseInt(id, 10) ? { ...o, checked: true } : o
			),
			isSidebarDragging: true,
		});
	};

	handleSidebarDragEnd = () => {
		// En algunos navegadores dragend del sidebar puede ejecutarse antes de
		// procesar el drop; esperamos un frame para no deshacer la selección.
		requestAnimationFrame(() => this._resetSidebarDragIfCancelled());
	};

	_resetSidebarDragIfCancelled = () => {
		if (this._sidebarDropInProgress || !this._isSidebarDragging) {
			return;
		}

		this._isSidebarDragging = false;
		this._sidebarDragShiftId = null;

		this.setState((prevState) => ({
			isSidebarDragging: false,
			day_selection: [],
			day_selection_copy: [],
			day_selection_dashed: [],
			shift_list: this._uncheckSelectedList(prevState.shift_list),
			ubication_list: this._uncheckSelectedList(prevState.ubication_list),
			plan_assignments: prevState.plan_assignments.map((assignment) => ({
				...assignment,
				plans: (assignment.plans || []).map((plan) => ({
					...plan,
					checked: false,
				})),
			})),
		}));
	};

	// shift list

	getShiftList = () =>
		this.state.shift_list
		.filter((item) => {
			if (!item.group_ids || item.group_ids.length === 0) return true;
			return item.group_ids.map(Number).includes(this.state.group_id);
		})
		.map((item) => {
			const checked = item.checked || false;

			// const tooltip = <Tooltip className="tooltip-shift"><ShiftPreviewTooltip shift={item} time_intervals={item.time_intervals} /></Tooltip>;

			return (
				// <OverlayTrigger key={item.id} overlay={tooltip}>
				<li
					key={`shift_li_${item.id}`}
					id={`shift_li_${item.id}`}
					title={`${item.name}${
						item.description ? ` - ${item.description}` : ""
					}`}
					onDragStart={(e) => this.handleShiftDragSelection(e)}
					onDragEnd={this.handleSidebarDragEnd}
					className={`shift-item btn-checkbox ${checked ? "active" : ""} ${
						this.state.planBtnState ? "btn-not-draggable" : ""
					}`}
					style={{
						backgroundColor: item.background_color && item.background_color,
						borderColor: item.border_color
							? item.border_color
							: item.background_color || undefined,
						color: getContrastColor(item.background_color, "#55536b"),
						borderRadius: "4px",
					}}
					draggable={!this.state.planBtnState}
				>
					<button
						type="button"
						className="shift-item__edit-btn"
						onClick={(event) => {
							event.preventDefault();
							event.stopPropagation();
							this.openEditShiftModal(item);
						}}
						aria-label={this.props.t("plan.modal.editPlanShift", {
							name: item.name,
						})}
						title={this.props.t("plan.modal.editPlanShift", {
							name: item.name,
						})}
					>
						<FiEdit2 />
					</button>
					<input
						type="checkbox"
						id={`shift_${item.id}`}
						onChange={this.handleShiftSelection}
						checked={checked}
					/>
					<label
						htmlFor={`shift_${item.id}`}
						className={`btn-check-label ${
							this.state.planBtnState ? "btn-not-draggable" : ""
						}`}
					>
						<span className="shift-name">{item.name}</span>
						<ul className="time-intervals">
							{this.getShiftIntervals(item.time_intervals)}
						</ul>
					</label>
				</li>
				// </OverlayTrigger>
			);
		});

	getShiftIntervals = (time_intervals) => {
		if (!time_intervals || time_intervals.length === 0) return null;

		return time_intervals.map((item, i) => {
			const start = convertFromUTC(item.start);
			const end = convertFromUTC(item.end);
			return (
				<li key={i} className="time-interval">
					{start}-{end}
				</li>
			);
		});
	};

	getShiftFilter = () => {
		const { shift_types } = this.props;
		const shiftTypeLabel = (name) => {
			if (name === "Trabajo") return this.props.t("shifts.form.typeWork");
			if (name === "Ausencia") return this.props.t("shifts.form.typeAbsence");
			if (name === "Vacaciones")
				return this.props.t("shifts.form.typeVacation");
			if (name === "Descanso") return this.props.t("shifts.form.typeRest");
			return name;
		};
		const optionShiftTypeList =
			shift_types.length > 0 &&
			shift_types.map((item, i) => {
				return (
					<option key={i} value={item.name}>
						{shiftTypeLabel(item.name)}
					</option>
				);
			}, this);

		return (
			<div
				className={`pattern-filter${
					this.state.highlightAvailabilityPalette
						? " pattern-filter--highlight"
						: ""
				}`}
			>
				<div className="heading-filters">
					<FormGroup
						className="form-group form-search"
						controlId="search_shift"
					>
						<FormControl
							type="text"
							placeholder="Buscar..."
							value={this.state.search_shift}
							onChange={this.handleChangeFilter}
						/>
						<HiOutlineMagnifyingGlass size={16} />
					</FormGroup>
					<FormGroup
						className="form-group form-search"
						controlId="search_shift_type_id"
					>
						<FormControl
							type="text"
							placeholder="Buscar..."
							value={this.state.search_shift_type_id}
							onChange={this.handleChangeFilter}
							as="select"
						>
							<option value="">{this.props.t("plan.allTypes")}</option>
							{optionShiftTypeList}
						</FormControl>
					</FormGroup>
				</div>

				<ul className="pattern-list">{this.getShiftList()}</ul>
				<div className="pattern-footer">
					<HiOutlineClock size={16} />
					{this.props.t("plan.dragShiftsToPlan")}
				</div>
			</div>
		);
	};

	// ubication list stuff

	async getUbications() {
		await this.props.getSelectableUbications({
			q: this.state.search_ubication,
		});

		const ubication_list = this.props.select_ubications;

		this.setState({
			ubication_list,
		});
	}

	getUbicationList = () =>
		this.state.ubication_list.map((item) => {
			const checked = item.checked || false;
			return (
				<li
					key={item.id}
					id={`ubication_li_${item.id}`}
					title={`${item.name}${
						item.description ? ` - ${item.description}` : ""
					}`}
					onDragStart={(e) => this.handleUbicationDragSelection(e)}
					onDragEnd={this.handleSidebarDragEnd}
					className={`shift-item btn-checkbox ${checked ? "active" : ""}`}
					style={{
						backgroundColor: item.background_color && item.background_color,
						borderColor: item.border_color
							? item.border_color
							: item.background_color || undefined,
						color: getContrastColor(item.background_color, "#55536b"),
					}}
					draggable={!this.state.planBtnState}
				>
					<input
						type="checkbox"
						id={`ubication_${item.id}`}
						onChange={this.handleUbicationSelection}
						checked={checked}
					/>
					<label htmlFor={`ubication_${item.id}`} className="btn-check-label">
						{item.name}
					</label>
				</li>
			);
		});

	getUbicationFilter = () => {
		return (
			<div className="pattern-filter">
				<div className="heading-filters">
					<FormGroup
						className="form-group form-search"
						controlId="search_ubication"
					>
						<FormControl
							type="text"
							placeholder="Buscar..."
							value={this.state.search_ubication}
							onChange={this.handleChangeFilter}
						/>
						<HiOutlineMagnifyingGlass size={16} />
					</FormGroup>
				</div>

				<ul className="pattern-list">{this.getUbicationList()}</ul>
			</div>
		);
	};

	getComboFilter = () => {
		return (
			<div className="combo-filter">
				<Tab.Container defaultActiveKey="shifts">
					<Nav variant="tabs ml-3">
						<Nav.Item>
							<Nav.Link eventKey="shifts">
								{this.props.t("plan.shiftsTab")}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="ubications">
								{this.props.t("plan.ubicationsTab")}
							</Nav.Link>
						</Nav.Item>
					</Nav>
					<Tab.Content>
						<Tab.Pane eventKey="shifts">{this.getShiftFilter()}</Tab.Pane>
						<Tab.Pane eventKey="ubications">
							{this.getUbicationFilter()}
						</Tab.Pane>
					</Tab.Content>
				</Tab.Container>
			</div>
		);
	};

	handleUbicationSelection = (event) => {
		const { ubication_list } = this.state;
		const countSelected = ubication_list.filter(
			(o) => o.checked === true
		).length;
		var id = event.target.id;
		id = id.replace("ubication_", "");
		const value = event.target.checked;

		if (countSelected >= 3 && value) {
			toastr.error("", this.props.t("plan.error.maxUbicationsPerShift"));
		} else {
			this.setState({
				ubication_list: this.state.ubication_list.map((o) =>
					o.id === parseInt(id) ? { ...o, checked: value } : o
				),
			});
		}
	};

	handleUbicationDragSelection = (event) => {
		const { ubication_list } = this.state;
		const countSelected = ubication_list.filter(
			(o) => o.checked === true
		).length;
		var id = event.target.id;
		id = id.replace("ubication_li_", "");

		if (countSelected > 3) {
			toastr.error("", this.props.t("plan.error.maxUbicationsPerShift"));
		} else {
			this._isSidebarDragging = true;
			this.setState({
				ubication_list: this.state.ubication_list.map((o) =>
					o.id === parseInt(id) ? { ...o, checked: true } : o
				),
				isSidebarDragging: true,
			});
		}
	};

	// menu contextual turno
	handleLockShift = async (id, locked) => {
		const plan = {
			id,
			locked,
		};
		const response = await plansService.update(plan);

		if (response.ok) {
			this.updateLockedShift(id, locked);
		}
	};

	updateLockedShift = async (assignmentId, locked) => {
		const { plan_assignments } = this.state;
		var hasChanged = false;

		if (plan_assignments?.length) {
			plan_assignments.forEach((item) => {
				// Verificar que item tenga plans y que haya elementos:
				if (item?.plans?.length) {
					item.plans.forEach((plan) => {
						// Verificar que plan tenga assignments y que haya elementos:
						if (plan?.assignments?.length) {
							const assignment = plan.assignments.find(
								(a) => a.id === assignmentId
							);
							if (assignment) {
								assignment.locked = locked;
								hasChanged = true;
							}
						}
					});
				}
			});
		}

		if (hasChanged) {
			this.setState({
				plan_assignments,
			});
		}
	};

	handleEditShift = async (plan) => {
		this.openEditPlanShiftModal(plan);
	};

	handleResizeHourlyShift = async ({
		employee,
		day,
		shift_plan,
		edge,
		deltaMinutes,
		intervalIndex,
		dayShift: previewDayShift,
		nextIntervals: previewNextIntervals,
	}) => {
		if (!employee?.id || !day || !shift_plan?.id || !deltaMinutes) {
			return false;
		}

		const rawIntervals = (() => {
			if (shift_plan.time_intervals_span?.length) {
				return shift_plan.time_intervals_span;
			}
			if (shift_plan.time_intervals?.length) {
				return shift_plan.time_intervals;
			}
			if (shift_plan.time_intervals_from_shift) {
				return shift_plan.shift?.time_intervals ?? null;
			}
			return shift_plan.shift?.time_intervals ?? null;
		})();

		const applied =
			previewNextIntervals?.length
				? {
						intervals: previewNextIntervals,
						dayShift: previewDayShift || 0,
					}
				: applyHourlyShiftDelta(
						rawIntervals,
						edge,
						deltaMinutes,
						intervalIndex
					);

		if (!applied?.intervals) {
			return false;
		}

		const nextIntervals = applied.intervals;
		const originDay = shift_plan.span_origin_day || day;
		const nextDay = addDaysYmd(originDay, applied.dayShift || 0);

		const updatedAssignment = {
			id: shift_plan.id,
			day: nextDay,
			employee_id: employee.id,
			shift_id: shift_plan.shift?.id,
			locked: !!shift_plan.locked,
			time_intervals: prepareIntervalsForUpdate(nextIntervals),
		};

		if (shift_plan.function?.id || shift_plan.function_id) {
			updatedAssignment.function_id =
				shift_plan.function?.id ?? shift_plan.function_id;
		}

		if (shift_plan.comments) {
			updatedAssignment.comments = shift_plan.comments;
		}

		const ubicationIds = (shift_plan.ubications || [])
			.map((u) => u.id)
			.filter(Boolean);
		if (ubicationIds.length > 0) {
			updatedAssignment.ubication_ids = ubicationIds;
		}

		const employeeRow = this.state.plan_assignments?.find(
			(row) => row.employee?.id === employee.id
		);
		const needsExpand = employeeRow
			? resizeNeedsColumnExpandOnDays(employeeRow, nextIntervals, nextDay)
			: resizeNeedsColumnExpand(
					this.state.working_hours_list,
					nextIntervals
				);

		const optimisticPatchArgs = {
			employeeId: employee.id,
			day: originDay,
			originDay,
			nextDay,
			assignmentId: shift_plan.id,
			nextIntervals,
			prevIntervals: rawIntervals,
			spanParts: shift_plan.span_parts,
			assignmentSnapshot: shift_plan,
		};

		// Materializar geometría en plan.hours ANTES del persist.
		// En move entre días también hay que strippear copias overnight del
		// origen; si no, el refresh parcial deja un pedazo fantasma.
		let didOptimisticPaint = false;
		await new Promise((resolve) => {
			this.setState((prevState) => {
				didOptimisticPaint = true;
				return {
					plan_assignments: applyOptimisticHourlyResizeToPlanAssignments(
						prevState.plan_assignments,
						optimisticPatchArgs
					),
				};
			}, resolve);
		});

		const revertOptimisticPaint = () => {
			if (!didOptimisticPaint || !rawIntervals?.length) return;
			this.setState((prevState) => ({
				plan_assignments: applyOptimisticHourlyResizeToPlanAssignments(
					prevState.plan_assignments,
					{
						...optimisticPatchArgs,
						nextDay: originDay,
						nextIntervals: rawIntervals,
						extraStripDays: [
							...collectAssignmentPaintDays(nextDay, nextIntervals),
						],
					}
				),
			}));
		};

		const defaultRestIdsOnDays = (days) => {
			const defaultShiftId = this.props.default_shift?.id;
			if (!defaultShiftId || !employeeRow?.plans) return [];
			const daySet = new Set((days || []).filter(Boolean));
			const ids = [];
			employeeRow.plans.forEach((plan) => {
				if (!daySet.has(plan.day)) return;
				(plan.assignments || []).forEach((assignment) => {
					if (
						assignment.id != null &&
						assignment.id !== -1 &&
						assignment.shift?.id === defaultShiftId
					) {
						ids.push(assignment.id);
					}
				});
			});
			return [...new Set(ids)];
		};

		const removeDefaultRestOnDays = async (days) => {
			for (const id of defaultRestIdsOnDays(days)) {
				try {
					await plansService.remove(id);
				} catch (_) {
					// El API a veces ya sustituyó el descanso al crear el turno.
				}
			}
		};

		const persistDayChanged = async () => {
			const createPayload = { ...updatedAssignment };
			delete createPayload.id;
			createPayload.time_intervals = (
				createPayload.time_intervals || []
			).map(({ id, ...interval }) => interval);
			const response = await plansService.updateMultiple([createPayload]);
			const responses = Array.isArray(response) ? response : [response];
			const firstError = responses.find((item) => item?.errors?.length);
			if (firstError) {
				const textError =
					firstError.errors[0]?.description ||
					this.props.t("common.error");
				return { ok: false, textError };
			}
			await removeDefaultRestOnDays([nextDay]);
			const removed = await plansService.remove(shift_plan.id);
			if (!removed?.ok) {
				toastr.warning(
					this.props.t("plan.modal.attention"),
					this.props.t("plan.error.copiedButNotDeleted")
				);
			}
			return { ok: true };
		};

		const stripIntervalIds = (intervals) =>
			(intervals || []).map(({ id, ...interval }) => interval);

		const persistLongShiftSlices = async () => {
			const slices = splitAssignmentIntervalsByDay(nextIntervals);
			const desired = slices.map((slice) => ({
				day: addDaysYmd(nextDay, slice.dayOffset),
				intervals: prepareIntervalsForUpdate(slice.intervals),
			}));
			const oldParts = (
				shift_plan.span_parts?.length
					? shift_plan.span_parts
					: [{ day: originDay, id: shift_plan.id }]
			).filter((part) => part?.id && part?.day);
			const oldByDay = {};
			oldParts.forEach((part) => {
				oldByDay[part.day] = part.id;
			});
			const createdIds = [];
			const template = { ...updatedAssignment };
			delete template.id;
			delete template.time_intervals;

			try {
				const toCreate = desired.filter((part) => !oldByDay[part.day]);
				const toUpdate = desired.filter((part) => oldByDay[part.day]);
				const toDelete = oldParts.filter(
					(part) => !desired.some((item) => item.day === part.day)
				);

				for (const part of toCreate) {
					const response = await plansService.updateMultiple([
						{
							...template,
							day: part.day,
							time_intervals: stripIntervalIds(part.intervals),
						},
					]);
					const responses = Array.isArray(response)
						? response
						: [response];
					const firstError = responses.find(
						(item) => item?.errors?.length
					);
					if (firstError) {
						const textError =
							firstError.errors[0]?.description ||
							this.props.t("common.error");
						for (const id of createdIds) {
							try {
								await plansService.remove(id);
							} catch (_) {}
						}
						return { ok: false, textError };
					}
					const newId =
						responses[0]?.id ||
						responses[0]?.plan?.id ||
						responses[0]?.data?.id;
					if (newId) createdIds.push(newId);
				}

				await removeDefaultRestOnDays(desired.map((part) => part.day));

				for (const part of toUpdate) {
					const response = await plansService.updateAssignment({
						...template,
						id: oldByDay[part.day],
						day: part.day,
						time_intervals: part.intervals,
					});
					if (!response.ok) {
						const textError =
							response.errors?.[0]?.description ||
							this.props.t("common.error");
						for (const id of createdIds) {
							try {
								await plansService.remove(id);
							} catch (_) {}
						}
						return { ok: false, textError };
					}
				}

				for (const part of toDelete) {
					await plansService.remove(part.id);
				}
				return { ok: true };
			} catch (error) {
				for (const id of createdIds) {
					try {
						await plansService.remove(id);
					} catch (_) {
						// rollback best-effort
					}
				}
				return {
					ok: false,
					textError: this.props.t("common.error"),
				};
			}
		};

		try {
			const dayChanged = nextDay !== originDay;
			const isLongShift =
				getIntervalsAbsDurationMinutes(nextIntervals) > 24 * 60;
			let persisted;
			if (isLongShift) {
				persisted = await persistLongShiftSlices();
			} else if (dayChanged) {
				persisted = await persistDayChanged();
			} else {
				const response = await plansService.updateAssignment(
					updatedAssignment
				);
				persisted = response.ok
					? { ok: true }
					: {
							ok: false,
							textError:
								response.errors?.[0]?.description ||
								this.props.t("common.error"),
						};
			}
			if (!persisted.ok) {
				revertOptimisticPaint();
				toastr.error(
					this.props.t("common.error"),
					persisted.textError || this.props.t("common.error")
				);
				return false;
			}

			if (!isLongShift && shift_plan.span_parts?.length > 1) {
				for (const part of shift_plan.span_parts) {
					if (!part?.id || part.id === shift_plan.id) continue;
					try {
						await plansService.remove(part.id);
					} catch (_) {
						// extra slice ya no aplica
					}
				}
			}

			const resizeInverse = buildPlanResizeInverse({
				shiftPlan: shift_plan,
				employee,
				originDay,
				rawIntervals,
				updatedAssignment,
			});
			this._notifyPlanMutation({
				type: "UPDATE",
				messageKey: "undo.plan.shiftUpdated",
				inverse: resizeInverse || undefined,
				employeeIds: [employee.id],
			});

			if (needsExpand || dayChanged || isLongShift || shift_plan.span_parts?.length > 1) {
				// Extender rejilla o cambio de día (nuevo id de assignment).
				const refreshDays = collectAssignmentPaintDays(
					nextDay,
					nextIntervals,
					[
						originDay,
						nextDay,
						...((shift_plan.span_parts || []).map((part) => part?.day)),
					]
				);
				collectAssignmentPaintDays(originDay, rawIntervals).forEach(
					(paintDay) => {
						refreshDays.add(paintDay);
					}
				);
				this._resizeRefreshDays = refreshDays;
				this._resizeRefreshDay = nextDay;
				const runRefresh = async () => {
					try {
						await this.getPlanAssignments([employee.id]);
						this.unselectAllDays();
					} finally {
						this._resizeRefreshDay = null;
						this._resizeRefreshDays = null;
					}
					this._scheduleCountersRefreshAfterHourlyEdit({
						includeStaffing: true,
						idleTimeout: 12000,
					});
				};
				if (typeof window.requestIdleCallback === "function") {
					window.requestIdleCallback(() => runRefresh(), { timeout: 800 });
				} else {
					window.setTimeout(runRefresh, 0);
				}
				return "pending-refresh";
			}

			// Horas ya materializadas; la UI no depende de preview sticky.
			this.unselectAllDays();
			// Balance / horas planificadas: solo cuentas en idle (sin staffing ni rejilla).
			this._scheduleCountersRefreshAfterHourlyEdit();
			return "optimistic";
		} catch (error) {
			revertOptimisticPaint();
			toastr.error(
				this.props.t("common.error"),
				this.props.t("common.error")
			);
			return false;
		}
	};

	handleExchangeShift = async (plan) => {
		this.openExchangePlanShiftModal(plan);
	};

	handleCopyShift = async (plan) => {
		toastr.success("¡Bien!", this.props.t("plan.shiftCopiedOk"));

		this.setState({
			copied_shift: plan,
		});
	};

	_getPlanFromFirstSelection = () => {
		const { plan_assignments, day_selection } = this.state;

		if (day_selection.length === 0) {
			return null;
		}

		const { row, index } = day_selection[0];
		const plan_assignment = plan_assignments[row];
		const day_plan = plan_assignment?.plans?.[index];

		if (!day_plan) {
			return null;
		}

		const assignment =
			day_plan.assignments?.find((item) => item.id !== -1) ||
			day_plan.assignments?.[0];

		if (!assignment) {
			return null;
		}

		return {
			employee: plan_assignment.employee,
			day: day_plan.day,
			shift_plan: assignment,
		};
	};

	handleFloatingBarExchange = () => {
		if (this.state.day_selection.length !== 1) {
			return;
		}

		const plan = this._getPlanFromFirstSelection();
		if (plan) {
			this.handleExchangeShift(plan);
		}
	};

	loadApprovedAbsencesForPeriod = async () => {
		const { group_id, start, end, plan_assignments } = this.state;
		const employeeIds = new Set(
			(plan_assignments || []).map((pa) => pa.employee?.id).filter(Boolean)
		);

		planReopenLog("Fetch ausencias aprobadas", {
			group_id,
			start_from: start,
			start_to: end,
			queryRange: getPlanningAbsenceQueryRange(start, end),
			planRowsAtFetch: plan_assignments?.length ?? 0,
			employeeIdsInPlan: [...employeeIds],
		});

		try {
			const fetchResult = await fetchApprovedWorkflowsForPlanPeriod({
				workflowsService,
				group_id,
				start_from: start,
				start_to: end,
				employeeIds,
				includeAllCompany: isAdmin() || isSupervisor(),
			});

			const approvedWorkflowAbsences = fetchResult.workflows || [];

			planReopenLog("Fetch resultado", {
				source: fetchResult.source,
				rawCount: fetchResult.rawCount,
				filteredCount: fetchResult.filteredCount,
				attempts: fetchResult.attempts,
				hint: "Si httpStatus=404, revisa [PlanWorkflows] en consola (DEBUG_PLAN_WORKFLOWS=1 en prod)",
			});

			const workflowAbsenceByAssignmentId = buildWorkflowAbsenceByAssignmentId(
				plan_assignments,
				approvedWorkflowAbsences
			);

			logWorkflowAbsenceMatchDiagnostics(
				plan_assignments,
				approvedWorkflowAbsences,
				workflowAbsenceByAssignmentId
			);

			this.setState({
				approvedWorkflowAbsences,
				workflowAbsenceByAssignmentId,
			});
		} catch (error) {
			console.error(
				"[PlanReopenAbsence] Error loading approved absences:",
				error
			);
		}
	};

	getWorkflowForAssignment = (assignmentId) => {
		const { workflowAbsenceByAssignmentId } = this.state;
		return (
			workflowAbsenceByAssignmentId[assignmentId] ||
			workflowAbsenceByAssignmentId[String(assignmentId)]
		);
	};

	getSelectedWorkflowAbsence = () => {
		const { day_selection, plan_assignments } = this.state;

		if (day_selection.length !== 1) {
			return null;
		}

		const { row, index } = day_selection[0];
		const dayPlan = plan_assignments[row]?.plans?.[index];

		if (!dayPlan) {
			return null;
		}

		const linkedAssignments = (dayPlan.assignments || []).filter(
			(assignment) =>
				assignment.id !== -1 && this.getWorkflowForAssignment(assignment.id)
		);

		if (linkedAssignments.length !== 1) {
			return null;
		}

		const assignment = linkedAssignments[0];

		return {
			assignment,
			workflow: this.getWorkflowForAssignment(assignment.id),
		};
	};

	logReopenAbsenceUiState = () => {
		const { day_selection, plan_assignments, workflowAbsenceByAssignmentId } =
			this.state;
		const { hasPrivileges } = this.state;

		logSelectedWorkflowAbsenceDiagnostics({
			day_selection,
			plan_assignments,
			workflowAbsenceByAssignmentId,
			isPlanSelectionView: this.isPlanSelectionView(),
			showActions:
				this.isPlanSelectionView() && hasPrivileges && !this.state.planBtnState,
			hasPrivileges,
			planBtnState: this.state.planBtnState,
			plan_grid_view: this.state.plan_grid_view,
			planViewMode: this.state.planViewMode,
		});
	};

	handleFloatingBarReopenAbsence = () => {
		const selected = this.getSelectedWorkflowAbsence();

		if (!selected?.workflow) {
			return;
		}

		this.handleReopenAbsenceFromPlan(selected.workflow);
	};

	handleReopenAbsenceFromPlan = (workflow) => {
		this.props.showModal(
			{
				open: true,
				title: "Reabrir ausencia",
				style: { width: "350px" },
				message: "¿Deseas reabrir y editar la ausencia?",
				deleteAction: () => this.confirmReopenAbsenceFromPlan(workflow),
				closeModal: this.closeModal,
			},
			"delete"
		);
	};

	openEditAbsenceFromPlanModal = (absence, disabled = false) => {
		this.props.getAbsenceShifts();

		this.props.showModal(
			{
				open: true,
				title: disabled ? "Ver ausencia" : "Editar ausencia",
				style: { width: "430px" },
				content: (
					<AbsenceEditModal
						absence={absence}
						disabled={disabled}
						handleClose={this.closeModal}
						autoApproveOnSave
						onPlanningSaveComplete={this.handlePlanningAbsenceSaveComplete}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	};

	refreshPlanAfterAbsenceChange = async () => {
		await new Promise((resolve) => {
			this.setState(
				(prevState) => ({
					day_selection: [],
					day_selection_copy: [],
					day_selection_dashed: [],
					workflowAbsenceByAssignmentId: {},
					approvedWorkflowAbsences: [],
					update_employee_ids: [],
					plan_loading: true,
					plan_assignments: (prevState.plan_assignments || []).map(
						(assignment) => ({
							...assignment,
							plans: (assignment.plans || []).map((plan) => ({
								...plan,
								checked: false,
							})),
						})
					),
				}),
				resolve
			);
		});

		await this.getPlanCalculations();
		await new Promise((resolve) => setTimeout(resolve, 1200));
		await this.getAllAssignments();
		await this.loadApprovedAbsencesForPeriod();
	};

	confirmReopenAbsenceFromPlan = async (workflow) => {
		this.closeModal();

		const absence = normalizeWorkflowForEdit({
			...workflow,
			status: "Pendiente",
			shift_id: workflow.shift?.id,
		});

		if (this.state.workflowAbsenceReopenSubmit) {
			return;
		}

		this.setState({ workflowAbsenceReopenSubmit: true });
		const response = await workflowsService.update(absence);
		this.setState({ workflowAbsenceReopenSubmit: false });

		if (response.ok) {
			toastr.success(
				this.props.t("common.success"),
				this.props.t("common.changesSaved")
			);
			await this.refreshPlanAfterAbsenceChange();
			this.openEditAbsenceFromPlanModal(absence, false);
		} else if (
			response.errors !== undefined &&
			Object.keys(response.errors).length > 0
		) {
			const textError = response.errors[0].description;
			toastr.warning("Reabierta con errores", textError);
		}
	};

	handlePlanningAbsenceSaveComplete = async (savedAbsence) => {
		planReopenLog("Refresco plan tras guardar ausencia", {
			workflowId: savedAbsence?.id,
			start: savedAbsence?.start,
			end: savedAbsence?.end,
		});

		await this.refreshPlanAfterAbsenceChange();
	};

	handleCopyPasteShift = async (shiftPlan, newRow, newIndex) => {
		const { plan_assignments } = this.state;

		const sourceEmployee = shiftPlan.employee;
		const sourceDay = shiftPlan.day;
		const targetEmployee = plan_assignments[newRow].employee;
		const targetPlan = plan_assignments[newRow].plans[newIndex];
		const targetDay = targetPlan.day;

		const missingContracts = await this._missingContractsForSelection(
			plan_assignments,
			[{ row: newRow, index: newIndex }]
		);
		if (missingContracts.length > 0) {
			this.openPlanMissingContractPrompt(missingContracts);
			return;
		}

		const defaultShiftId = this.props.default_shift?.id;
		const existingDefaultShiftIds = (targetPlan.assignments || [])
			.filter((a) => a.id !== -1 && a.shift?.id === defaultShiftId)
			.map((a) => a.id);
		const replacedDefaultRestoreBodies = collectDefaultShiftRestoreBodies(
			targetPlan.assignments,
			defaultShiftId,
			targetEmployee.id,
			targetDay,
			this.state.group_id
		);
		this._rememberReplacedDefaultRests(replacedDefaultRestoreBodies);

		// ——— Validación de función (igual que mover) ———
		let functionId = null;
		if (shiftPlan.shift_plan.function) {
			const targetHasFunction =
				targetEmployee.employee_with_function &&
				targetEmployee.employee_with_function.function &&
				targetEmployee.employee_with_function.function.id ===
					shiftPlan.shift_plan.function.id;
			functionId = targetHasFunction ? shiftPlan.shift_plan.function.id : null;
		}

		// ——— Validación de ubicaciones (igual que mover) ———
		let ubicationIds = [];
		if (shiftPlan.shift_plan.ubications?.length) {
			try {
				const employeeId = targetEmployee.id;

				const targetUbications =
					await employeesService.getUbications(employeeId);

				const allowedUbicationIds = new Set(
					targetUbications.map((u) => u.ubication.id)
				);

				ubicationIds = shiftPlan.shift_plan.ubications
					.map((u) => u.id)
					.filter((id) => allowedUbicationIds.has(id));
			} catch (err) {
				console.error("Error loading employee ubications", err);
			}
		}

		// ——— Construcción del nuevo turno a CREAR en destino ———
		const newPlan = {
			day: targetDay,
			employee_id: targetEmployee.id,
			shift_id: shiftPlan.shift_plan.shift.id,
			locked: true,
		};

		if (functionId) newPlan.function_id = functionId;
		if (ubicationIds.length > 0) newPlan.ubication_ids = ubicationIds;
		if (shiftPlan.shift_plan.comments)
			newPlan.comments = shiftPlan.shift_plan.comments;

		if (shiftPlan.shift_plan.time_intervals) {
			const time_intervals = shiftPlan.shift_plan.time_intervals.map(
				(interval) => {
					return { ...interval, time_type_id: interval.time_type.id };
				}
			);
			newPlan.time_intervals = time_intervals;
		}

		try {
			// Copiar = crear uno nuevo (no tocamos el origen)
			const response = await plansService.updateMultiple([newPlan]);

			const responses = Array.isArray(response) ? response : [response];
			let hasErrors = false;
			let errorMessage = this.props.t("plan.error.copyShiftErrors");

			responses.forEach((item) => {
				if (item.errors) {
					hasErrors = true;
					item.errors.forEach((error) => {
						errorMessage += `- ${error.description}\n`;
					});
				}
			});

			if (hasErrors) {
				const showedContractPrompt =
					this._tryOpenMissingContractPromptFromPlanErrors(
						[{ status: "fulfilled", value: responses }],
						[newPlan],
						plan_assignments
					);
				if (!showedContractPrompt) {
					this.openAlertModal(
						errorMessage,
						this.props.t("plan.error.copyShiftTitle")
					);
				}
			} else {
				// Eliminar turno Descanso previo en el destino si la API no lo reemplazó
				for (const existingId of existingDefaultShiftIds) {
					try {
						await plansService.remove(existingId);
					} catch (_) {
						// Ya fue reemplazado por la API
					}
				}

				const pasteInverse = await this._resolvePasteUndoInverse({
					plansToSave: [newPlan],
					responses,
					employeeIds: [sourceEmployee.id, targetEmployee.id],
					replacedDefaultRestoreBodies,
				});

				// Similar a mover: refrescamos origen+destino (dos empleados)
				this.setState(
					{
						update_employee_ids: [sourceEmployee.id, targetEmployee.id],
						day_selection: [],
					},
					() => this.getAllAssignments()
				);

				this._notifyPlanMutation({
					type: "CREATE",
					messageKey: "undo.plan.shiftCopied",
					inverse: pasteInverse || undefined,
					employeeIds: [sourceEmployee.id, targetEmployee.id],
				});
			}
		} catch (err) {
			console.error("Error al copiar el turno:", err);
			toastr.error("", this.props.t("plan.error.copyShiftProblem"));
		}
	};

	handleReassignShiftInShiftsView = async (
		shiftPlan,
		targetShiftId,
		targetDay,
		targetIntervals
	) => {
		const { plan_assignments } = this.state;

		if (!shiftPlan?.employee || !shiftPlan?.shift_plan) {
			toastr.error(
				this.props.t("common.error"),
				this.props.t("plan.error.invalidShiftData")
			);
			return;
		}

		// No-op solo si coincide turno, día Y horario. Para turnos "Automático"
		// existen variantes con el mismo shift.id pero distinto horario, así que
		// mover entre ellas debe reasignar (no retornar en seco).
		const intervalsSignature = (intervals) =>
			Array.isArray(intervals)
				? intervals.map((it) => `${it.start}|${it.end}`).join(";")
				: "";
		const sameShiftAndDay =
			shiftPlan.shift_plan.shift?.id === targetShiftId &&
			shiftPlan.day === targetDay;
		const sameIntervals =
			!targetIntervals ||
			intervalsSignature(shiftPlan.shift_plan.time_intervals) ===
				intervalsSignature(targetIntervals);
		if (sameShiftAndDay && sameIntervals) {
			return;
		}

		const sourceEmployee = shiftPlan.employee;
		const originalId = shiftPlan.shift_plan.id;
		const employeeRow = plan_assignments.find(
			(item) => item.employee.id === sourceEmployee.id
		);
		const targetPlan = employeeRow?.plans?.find(
			(plan) => plan.day === targetDay
		);

		const defaultShiftId = this.props.default_shift?.id;
		const existingDefaultShiftIds = (targetPlan?.assignments || [])
			.filter((a) => a.id !== -1 && a.shift?.id === defaultShiftId)
			.map((a) => a.id);

		let functionId = null;
		if (shiftPlan.shift_plan.function) {
			const employeeHasFunction =
				sourceEmployee.employee_with_function?.function?.id ===
				shiftPlan.shift_plan.function.id;
			functionId = employeeHasFunction
				? shiftPlan.shift_plan.function.id
				: null;
		}

		let ubicationIds = [];
		if (shiftPlan.shift_plan.ubications?.length) {
			try {
				const targetUbications = await employeesService.getUbications(
					sourceEmployee.id
				);
				const allowedUbicationIds = new Set(
					targetUbications.map((u) => u.ubication.id)
				);
				ubicationIds = shiftPlan.shift_plan.ubications
					.map((u) => u.id)
					.filter((id) => allowedUbicationIds.has(id));
			} catch (err) {
				console.error("Error loading employee ubications", err);
			}
		}

		const refreshShiftsView = () => {
			this.setState({ day_selection: [] }, () => {
				this.getAllAssignments([]);
			});
		};

		const newPlan = {
			day: targetDay,
			employee_id: sourceEmployee.id,
			shift_id: targetShiftId,
			locked: true,
			ubication_ids: ubicationIds,
		};

		if (functionId) newPlan.function_id = functionId;
		if (shiftPlan.shift_plan.comments) {
			newPlan.comments = shiftPlan.shift_plan.comments;
		}

		// Heredar el horario EFECTIVO del grupo de turno destino (lo que se ve
		// en la celda, p. ej. 06:00-14:00). Sin esto, el backend crea la
		// asignación con los intervalos del template del turno, que en turnos
		// "Automático" son degenerados (p. ej. 01:00-01:00 de "Disponibilidad"),
		// generando un grupo/turno "virtual" en la vista por turnos en vez de
		// caer dentro del turno destino real.
		let inheritedIntervals = Array.isArray(targetIntervals)
			? targetIntervals
			: null;
		if (!inheritedIntervals?.length) {
			const targetShift = (this.state.shift_list || []).find(
				(s) => s.id === targetShiftId
			);
			inheritedIntervals = targetShift?.time_intervals || null;
		}
		if (inheritedIntervals?.length) {
			newPlan.time_intervals = inheritedIntervals.map((interval) => ({
				...interval,
				time_type_id: interval.time_type?.id ?? interval.time_type_id,
			}));
		}

		// Cambiar solo el horario dentro del mismo turno y día (típico en turnos
		// "Automático" con varias variantes horarias). El backend rechaza crear
		// un segundo turno igual el mismo día (plan.shift_already_assigned), así
		// que aquí ACTUALIZAMOS la asignación existente (PUT) en vez de borrar y
		// crear, evitando perder el turno.
		const isSameSlotShift =
			originalId !== -1 &&
			shiftPlan.shift_plan.shift?.id === targetShiftId &&
			shiftPlan.day === targetDay;

		if (isSameSlotShift) {
			const updatedAssignment = {
				id: originalId,
				day: targetDay,
				employee_id: sourceEmployee.id,
				shift_id: targetShiftId,
				locked: true,
			};
			if (functionId) updatedAssignment.function_id = functionId;
			if (shiftPlan.shift_plan.comments) {
				updatedAssignment.comments = shiftPlan.shift_plan.comments;
			}
			if (ubicationIds.length > 0) {
				updatedAssignment.ubication_ids = ubicationIds;
			}
			if (newPlan.time_intervals?.length) {
				updatedAssignment.time_intervals = newPlan.time_intervals;
			}

			try {
				const responseUpdate =
					await plansService.updateAssignment(updatedAssignment);
				if (!responseUpdate.ok) {
					const textError =
						responseUpdate.errors?.[0]?.description ||
						this.props.t("plan.error.moveShiftProblem");
					this.openAlertModal(
						textError,
						this.props.t("plan.error.moveShiftTitle")
					);
					return;
				}
				refreshShiftsView();
				toastr.success("¡Bien!", this.props.t("plan.shiftMovedOk"));
			} catch (error) {
				toastr.error(
					this.props.t("common.error"),
					this.props.t("plan.error.moveShiftProblem")
				);
			}
			return;
		}

		try {
			// El API no permite cambiar shift_id en una asignación existente (PUT).
			// Reasignar = eliminar la asignación anterior y crear una nueva.
			if (originalId !== -1) {
				const responseRemove = await plansService.remove(originalId);
				if (!responseRemove.ok) {
					const textError =
						responseRemove.errors?.[0]?.description ||
						this.props.t("plan.error.moveShiftProblem");
					this.openAlertModal(
						textError,
						this.props.t("plan.error.moveShiftTitle")
					);
					return;
				}
			}

			for (const existingId of existingDefaultShiftIds) {
				if (existingId !== originalId) {
					try {
						await plansService.remove(existingId);
					} catch (_) {}
				}
			}

			const response = await plansService.add(newPlan);
			if (!response.ok) {
				const textError =
					response.errors?.[0]?.description ||
					this.props.t("plan.error.moveShiftProblem");
				this.openAlertModal(
					textError,
					this.props.t("plan.error.moveShiftTitle")
				);
				return;
			}

			trackHaddockPlanningShiftCreated(this.props.user, {
				group_id: this.state.group_id,
				day: targetDay,
			});

			refreshShiftsView();
			toastr.success("¡Bien!", this.props.t("plan.shiftMovedOk"));
		} catch (error) {
			toastr.error(
				this.props.t("common.error"),
				this.props.t("plan.error.moveShiftProblem")
			);
		}
	};

	handleMoveShift = async (shiftPlan, newRow, newIndex) => {
		const { plan_assignments } = this.state;

		// Validaciones iniciales
		if (!shiftPlan || !shiftPlan.employee || !shiftPlan.shift_plan) {
			toastr.error(
				this.props.t("common.error"),
				this.props.t("plan.error.invalidShiftData")
			);
			return;
		}

		if (!plan_assignments || newRow >= plan_assignments.length) {
			toastr.error(
				this.props.t("common.error"),
				this.props.t("plan.error.invalidTargetEmployee")
			);
			return;
		}

		if (
			!plan_assignments[newRow].plans ||
			newIndex >= plan_assignments[newRow].plans.length
		) {
			toastr.error(
				this.props.t("common.error"),
				this.props.t("plan.error.invalidTargetDay")
			);
			return;
		}

		const sourceEmployee = shiftPlan.employee;
		const targetEmployee = plan_assignments[newRow].employee;
		const targetPlan = plan_assignments[newRow].plans[newIndex];
		const targetDay = targetPlan.day;

		const missingContracts = await this._missingContractsForSelection(
			plan_assignments,
			[{ row: newRow, index: newIndex }]
		);
		if (missingContracts.length > 0) {
			this.openPlanMissingContractPrompt(missingContracts);
			return;
		}

		const defaultShiftId = this.props.default_shift?.id;
		const existingDefaultShiftIds = (targetPlan.assignments || [])
			.filter((a) => a.id !== -1 && a.shift?.id === defaultShiftId)
			.map((a) => a.id);
		const replacedDefaultRestoreBodies = collectDefaultShiftRestoreBodies(
			targetPlan.assignments,
			defaultShiftId,
			targetEmployee.id,
			targetDay,
			this.state.group_id
		);
		this._rememberReplacedDefaultRests(replacedDefaultRestoreBodies);

		// Validar si el empleado de destino tiene la función requerida
		let functionId = null;
		if (shiftPlan.shift_plan.function) {
			const targetHasFunction =
				targetEmployee.employee_with_function &&
				targetEmployee.employee_with_function.function &&
				targetEmployee.employee_with_function.function.id ===
					shiftPlan.shift_plan.function.id;
			functionId = targetHasFunction ? shiftPlan.shift_plan.function.id : null;
		}

		// Validar si el empleado de destino tiene las ubicaciones requeridas
		let ubicationIds = [];
		if (shiftPlan.shift_plan.ubications?.length) {
			try {
				const employeeId = targetEmployee.id;

				const targetUbications =
					await employeesService.getUbications(employeeId);

				const allowedUbicationIds = new Set(
					targetUbications.map((u) => u.ubication.id)
				);

				ubicationIds = shiftPlan.shift_plan.ubications
					.map((u) => u.id)
					.filter((id) => allowedUbicationIds.has(id));
			} catch (err) {
				console.error("Error loading employee ubications", err);
			}
		}

		const object_to_paste = {
			day: targetDay,
			employee_id: targetEmployee.id,
			shift_id: shiftPlan.shift_plan.shift.id,
			locked: true,
		};

		if (functionId) object_to_paste.function_id = functionId;
		if (ubicationIds.length > 0) object_to_paste.ubication_ids = ubicationIds;
		if (shiftPlan.shift_plan.comments)
			object_to_paste.comments = shiftPlan.shift_plan.comments;

		if (shiftPlan.shift_plan.time_intervals) {
			const time_intervals = shiftPlan.shift_plan.time_intervals.map(
				(interval) => {
					return { ...interval, time_type_id: interval.time_type.id };
				}
			);
			object_to_paste.time_intervals = time_intervals;
		}

		// Enviar actualización al backend
		try {
			const response = await plansService.updateMultiple([object_to_paste]);

			// Aseguramos que sea un array
			const responses = Array.isArray(response) ? response : [response];

			// Verificar errores en la respuesta
			let hasErrors = false;
			let errorMessage = this.props.t("plan.error.moveShiftErrors");

			responses.forEach((item) => {
				if (item.errors) {
					hasErrors = true;
					item.errors.forEach((error) => {
						errorMessage += `- ${error.description}\n`;
					});
				}
			});

			if (hasErrors) {
				const showedContractPrompt =
					this._tryOpenMissingContractPromptFromPlanErrors(
						[{ status: "fulfilled", value: responses }],
						[object_to_paste],
						plan_assignments
					);
				if (!showedContractPrompt) {
					this.openAlertModal(
						errorMessage,
						this.props.t("plan.error.moveShiftTitle")
					);
				}
				return;
			}

			// Eliminar turno Descanso previo en el destino si la API no lo reemplazó
			for (const existingId of existingDefaultShiftIds) {
				try {
					await plansService.remove(existingId);
				} catch (_) {
					// Ya fue reemplazado por la API
				}
			}

			// BORRAR EL TURNO ORIGINAL
			const originalId = shiftPlan.shift_plan.id;
			const responseRemove = await plansService.remove(originalId);

			if (!responseRemove.ok) {
				toastr.warning(
					this.props.t("plan.modal.attention"),
					this.props.t("plan.error.copiedButNotDeleted")
				);
			}

			const sourceDay = shiftPlan.day ?? shiftPlan.shift_plan.day;
			const shiftId = shiftPlan.shift_plan.shift.id;
			await this._restoreVacatedCellDefaultRest({
				employeeId: sourceEmployee.id,
				day: sourceDay,
			});
			const sourceRestoreBody = buildPlanRestoreBody(
				shiftPlan.shift_plan,
				sourceEmployee.id,
				sourceDay
			);

			let createdId = extractCreatedPlanId(responses[0], {
				day: targetDay,
				shiftId,
				employeeId: targetEmployee.id,
			});

			if (createdId == null) {
				try {
					const refreshed = await plansService.getPlanAssignments({
						group_id: this.state.group_id,
						start: this.state.start,
						end: this.state.end,
						update_employee_ids: [targetEmployee.id],
					});
					createdId = findPlanAssignmentId(refreshed.data, {
						employeeId: targetEmployee.id,
						day: targetDay,
						shiftId,
					});
				} catch (_) {
					// fall through to toast without undo
				}
			}

			const moveInverse = buildPlanMoveInverse({
				createdId,
				sourceRestoreBody,
				sourceEmployeeId: sourceEmployee.id,
				destinationEmployeeId: targetEmployee.id,
				replacedDefaultRestoreBodies,
			});

			// Actualizar estado y refrescar planificación
			this.setState(
				{
					update_employee_ids: [sourceEmployee.id, targetEmployee.id],
					day_selection: [],
				},
				() => {
					this.getAllAssignments();
				}
			);

			this._notifyPlanMutation({
				type: "MOVE",
				messageKey: "undo.plan.shiftMoved",
				inverse: moveInverse || undefined,
				employeeIds: [sourceEmployee.id, targetEmployee.id],
			});
		} catch (error) {
			toastr.error(
				this.props.t("common.error"),
				this.props.t("plan.error.moveShiftProblem")
			);
		}
	};

	// UPDATE EMPLEADO OK
	handlePasteShiftPlan = async () => {
		const { copied_shift, plan_assignments, day_selection } = this.state;
		const shift_plan = copied_shift.shift_plan;
		const plans_to_save = [];

		// const update_employee = plan_assignments[day_selection[0].row].employee.id;
		const update_employee_ids = day_selection.map(
			(selection) => plan_assignments[selection.row].employee.id
		);

		for (const item of day_selection) {
			const day = plan_assignments[item.row].plans[item.index].day;
			const employee = plan_assignments[item.row].employee;

			const newPlan = {
				day: day,
				employee_id: employee.id,
				shift_id: shift_plan.shift.id,
				locked: true,
			};

			if (shift_plan.function) {
				newPlan.function_id = shift_plan.function.id;
			}

			if (shift_plan.ubications) {
				const ubication_ids = [];
				shift_plan.ubications.map((ubication) => {
					ubication_ids.push(ubication.id);
					return true;
				});

				newPlan.ubication_ids = ubication_ids;
			}

			if (shift_plan.comments) newPlan.comments = shift_plan.comments;

			if (shift_plan.time_intervals) {
				const time_intervals = shift_plan.time_intervals.map((interval) => {
					interval.time_type_id = interval.time_type.id;
					return interval;
				});
				newPlan.time_intervals = time_intervals;
			}

			plans_to_save.push(newPlan);
		}

		const response = await plansService.updateMultiple(plans_to_save);

		var hasErrors = false;
		var textError = this.props.t("plan.error.foundErrors");
		response.map((item) => {
			if (item.errors !== undefined) {
				hasErrors = true;
				item.errors.map((error) => {
					textError += "- " + error.description + "\r\n";
				});
			}
		});

		if (!hasErrors) {
			const pasteInverse = await this._resolvePasteUndoInverse({
				plansToSave: plans_to_save,
				responses: response,
				employeeIds: update_employee_ids,
			});

			this._notifyPlanMutation({
				type: "BULK_CREATE",
				messageKey: "undo.plan.shiftsPasted",
				inverse: pasteInverse || undefined,
				employeeIds: update_employee_ids,
			});
			this.setState(
				{
					plan_loading: false,
					update_employee_ids,
				},
				() => {
					this.unselectAllDays();
					this.getAllAssignments();
				}
			);
		} else {
			this.openAlertModal(
				textError,
				this.props.t("plan.error.pasteShiftsTitle")
			);

			this.setState(
				{
					plan_loading: false,
				},
				() => this.unselectAllDays()
			);
		}
	};

	/** Vistas que reagrupan datos: necesitan recarga completa tras editar/borrar. */
	_usesFullPlanAssignmentsRefresh = () => {
		const view = this.state.plan_grid_view;
		return (
			view === PLAN_GRID_VIEWS.shifts ||
			view === PLAN_GRID_VIEWS.ubication_grouped
		);
	};

	_getPlanUndoScope = () => planGroupScope(this.state.group_id);

	_clearPlanUndoScope = () => {
		this.props.clearUndoScope(this._getPlanUndoScope());
	};

	_defaultRestCellKey = (employeeId, day) =>
		`${employeeId}|${normalizePlanDay(day)}`;

	_rememberReplacedDefaultRests = (bodies = []) => {
		(bodies || []).forEach((body) => {
			if (!body?.employee_id || !body?.day) {
				return;
			}
			this._replacedDefaultRestsByCell.set(
				this._defaultRestCellKey(body.employee_id, body.day),
				body
			);
		});
	};

	_restoreVacatedCellDefaultRest = async ({ employeeId, day }) => {
		if (!employeeId || !day) {
			return { ok: true };
		}

		const key = this._defaultRestCellKey(employeeId, day);
		const snapshot = this._replacedDefaultRestsByCell.get(key);
		if (snapshot) {
			this._replacedDefaultRestsByCell.delete(key);
			return restorePlanAssignment(snapshot);
		}

		const defaultShiftId = this.props.default_shift?.id;
		if (!defaultShiftId) {
			return { ok: true };
		}

		return unlockDefaultRestIfPresent({
			employee_id: employeeId,
			day,
			shift_id: defaultShiftId,
			locked: false,
			group_id: this.state.group_id,
		});
	};

	_restoreVacatedCellsDefaultRests = async (cells = []) => {
		const unique = [];
		const seen = new Set();
		(cells || []).forEach((cell) => {
			if (!cell?.employeeId || !cell?.day) {
				return;
			}
			const key = this._defaultRestCellKey(cell.employeeId, cell.day);
			if (seen.has(key)) {
				return;
			}
			seen.add(key);
			unique.push(cell);
		});

		for (const cell of unique) {
			await this._restoreVacatedCellDefaultRest(cell);
		}
	};

	_collectVacatedCellsFromSelection = () => {
		const { plan_assignments, day_selection } = this.state;
		return (day_selection || [])
			.map((item) => ({
				employeeId: plan_assignments[item.row]?.employee?.id,
				day: plan_assignments[item.row]?.plans?.[item.index]?.day,
			}))
			.filter((cell) => cell.employeeId && cell.day);
	};

	_resolvePasteUndoInverse = async ({
		plansToSave,
		responses,
		chunks,
		chunkResults,
		employeeIds,
		replacedDefaultRestoreBodies,
	}) => {
		let createdIds = [];
		let successfulPlans = plansToSave || [];

		if (chunkResults && chunks) {
			createdIds = extractCreatedPlanIdsFromChunkedPaste(chunks, chunkResults);
			successfulPlans = collectSuccessfulPastePlansFromChunks(
				chunks,
				chunkResults
			);
		} else if (responses) {
			const responseItems = Array.isArray(responses) ? responses : [responses];
			createdIds = extractCreatedPlanIdsFromResponses(
				responseItems,
				plansToSave
			);
			successfulPlans = collectSuccessfulPastePlans(plansToSave, responseItems);
		}

		if (createdIds.length < successfulPlans.length && successfulPlans.length > 0) {
			let planAssignments = this.state.plan_assignments;

			try {
				const refreshed = await plansService.getPlanAssignments({
					group_id: this.state.group_id,
					start: this.state.start,
					end: this.state.end,
					update_employee_ids: [...new Set(employeeIds || [])],
				});
				planAssignments = refreshed.data;
			} catch (_) {
				// keep state snapshot for fallback
			}

			createdIds = fillMissingPastedAssignmentIds(
				successfulPlans,
				createdIds,
				planAssignments
			);
		}

		return buildPlanPasteInverse(
			createdIds,
			employeeIds,
			replacedDefaultRestoreBodies
		);
	};

	_planUndoRefresh = (refresh = {}) => {
		const employeeIds = refresh.employeeIds || [];
		this.getAllAssignments(
			this._usesFullPlanAssignmentsRefresh() ? [] : employeeIds
		);
	};

	_notifyPlanMutation = ({
		type = "UPDATE",
		messageKey,
		messageParams = {},
		inverse,
		employeeIds = [],
	}) => {
		const payload = {
			scope: this._getPlanUndoScope(),
			type,
			entity: "plan_assignment",
			messageKey,
			messageParams,
			inverse,
			refresh: { employeeIds },
		};

		if (inverse?.requests?.length) {
			this.props.registerUndoAndShowToast(payload);
		} else {
			showSuccessToast({
				message: this.props.t(messageKey, messageParams),
			});
		}
	};

	_handleShiftAssigned = async ({
		createdId,
		employeeId,
		day,
		shiftId,
		planAssignments,
		replacedDefaultRestoreBody,
	}) => {
		if (!employeeId) {
			return;
		}

		if (replacedDefaultRestoreBody) {
			this._rememberReplacedDefaultRests([replacedDefaultRestoreBody]);
		}

		const lookupContext = { employeeId, day, shiftId };
		let assignmentId =
			createdId ??
			findPlanAssignmentId(planAssignments, lookupContext) ??
			findPlanAssignmentId(this.state.plan_assignments, lookupContext);

		if (assignmentId == null && day && shiftId != null) {
			try {
				const response = await plansService.getPlanAssignments({
					group_id: this.state.group_id,
					start: this.state.start,
					end: this.state.end,
					update_employee_ids: [employeeId],
				});
				assignmentId = findPlanAssignmentId(response.data, lookupContext);
			} catch (_) {
				// fall through to toast without undo
			}
		}

		const inverse =
			assignmentId != null
				? replacedDefaultRestoreBody
					? buildReplaceDefaultShiftInverse({
							createdId: assignmentId,
							replacedDefaultRestoreBody,
							employeeId,
						})
					: buildCreateInverse(assignmentId, employeeId)
				: null;

		this._notifyPlanMutation({
			type: "CREATE",
			messageKey: "undo.plan.shiftCreated",
			inverse: inverse || undefined,
			employeeIds: [employeeId],
		});
	};

	// UPDATE EMPLOYEE OK
	handleRemoveShift = async (plan, id) => {
		if (!id || id === -1) {
			toastr.error(
				this.props.t("common.error"),
				this.props.t("plan.error.invalidShiftData")
			);
			return;
		}

		const employeeId = plan?.employee?.id;
		if (!employeeId) {
			toastr.error(
				this.props.t("common.error"),
				this.props.t("plan.error.invalidShiftData")
			);
			return;
		}

		const update_employee_ids = [employeeId];
		const vacatedCell = {
			employeeId,
			day: plan.day ?? plan.shift_plan?.day,
		};
		const deleteInverse = buildPlanDeleteInverseFromCell(plan);
		const response = await plansService.remove(id);

		if (response.ok) {
			await this._restoreVacatedCellDefaultRest(vacatedCell);
			this._notifyPlanMutation({
				type: "DELETE",
				messageKey: "undo.plan.shiftDeleted",
				inverse: deleteInverse || undefined,
				employeeIds: update_employee_ids,
			});
			this.setState(
				{
					update_employee_ids,
					day_selection_dashed: [],
				},
				() => {
					this.getAllAssignments(
						this._usesFullPlanAssignmentsRefresh() ? [] : update_employee_ids
					);
				}
			);
		} else {
			// show error
			let textError = response.errors[0].description;

			this.openAlertModal(
				textError,
				this.props.t("plan.error.deleteShiftsTitle")
			);
		}
	};

	// menu contextual turno
	handleShiftMenuClick = (e, data, target) => {
		const targetId = data.targetId;

		if (data.action === "lock") {
			this.handleLockShift(targetId, true);
		}
		if (data.action === "unlock") {
			this.handleLockShift(targetId, false);
		}
		if (data.action === "copy") {
			this.handleCopyShift(data.plan);
		}
		if (data.action === "edit") {
			this.handleEditShift(data.plan);
		}
		if (data.action === "exchange") {
			this.handleExchangeShift(data.plan);
		}
		if (data.action === "delete") {
			this.handleRemoveShift(data.plan, targetId);
		}
	};

	_isActiveFilterId = (id) => {
		const numericId = parseInt(id, 10);
		return !Number.isNaN(numericId) && numericId > 0;
	};

	_normalizeFunctionFilterIds = (functionFilter) => {
		if (Array.isArray(functionFilter)) {
			return functionFilter
				.map((id) => parseInt(id, 10))
				.filter((id) => !Number.isNaN(id) && id > 0);
		}

		if (this._isActiveFilterId(functionFilter)) {
			return [parseInt(functionFilter, 10)];
		}

		return [];
	};

	_getActiveFunctionFilterIds = () =>
		this._normalizeFunctionFilterIds(this.state.selected_function_ids);

	_getFunctionFilterForApi = () => {
		const function_ids = this._getActiveFunctionFilterIds();
		return function_ids.length > 0 ? { function_ids } : {};
	};

	_getStaffingFunctionFilterIds = () => {
		const { function_staffing_id } = this.state;
		if (this._isActiveFilterId(function_staffing_id)) {
			return [parseInt(function_staffing_id, 10)];
		}
		return this._getActiveFunctionFilterIds();
	};

	_isPlanFilterActive = (functionFilter, ubication_id) => {
		return (
			this._normalizeFunctionFilterIds(functionFilter).length > 0 ||
			this._isActiveFilterId(ubication_id)
		);
	};

	_hasPlanAssignments = (plan_assignment) => {
		if (!plan_assignment?.plans?.length) {
			return false;
		}

		return plan_assignment.plans.some(
			(plan) => plan.assignments && plan.assignments.length > 0
		);
	};

	_getEmployeeProfileFunctionId = (employee) =>
		employee?.employee_with_function?.function?.id ?? null;

	_getEmployeeProfileUbicationId = (employee) =>
		employee?.employee_with_ubication?.ubication?.id ?? null;

	_planAssignmentHasAssignmentFunction = (plan_assignment, funId) =>
		(plan_assignment.plans || []).some((plan) =>
			(plan.assignments || []).some((ass) => ass?.function?.id === funId)
		);

	_planAssignmentHasAssignmentUbication = (plan_assignment, ubiId) =>
		(plan_assignment.plans || []).some((plan) =>
			(plan.assignments || []).some((ass) =>
				(ass?.ubications || []).some((ub) => ub?.id === ubiId)
			)
		);

	_assignmentIsVacation = (assignment) => {
		const type = normalizeShiftType(assignment?.shift?.type);
		if (type === shiftType.vacation) {
			return true;
		}
		if (type !== shiftType.absence) {
			return false;
		}
		return (
			normalizeShiftType(assignment?.shift?.description) === shiftType.vacation
		);
	};

	_dayIsOnlyVacation = (plan) => {
		const meaningful = (plan?.assignments || []).filter((assignment) => {
			const type = normalizeShiftType(assignment?.shift?.type);
			return type && type !== shiftType.rest;
		});

		return (
			meaningful.length > 0 &&
			meaningful.every((assignment) => this._assignmentIsVacation(assignment))
		);
	};

	_planRowIsFullyOnVacation = (plan_assignment) => {
		const plans = plan_assignment?.plans || [];
		return plans.length > 0 && plans.every((plan) => this._dayIsOnlyVacation(plan));
	};

	_assignmentMatchesPlanFilters = (
		assignment,
		functionFilter,
		ubication_id
	) => {
		const funIds = this._normalizeFunctionFilterIds(functionFilter);
		const ubiId = this._isActiveFilterId(ubication_id)
			? parseInt(ubication_id, 10)
			: null;

		const isVacation = this._assignmentIsVacation(assignment);

		if (
			!isVacation &&
			funIds.length > 0 &&
			(!assignment?.function || !funIds.includes(assignment.function.id))
		) {
			return false;
		}

		if (ubiId) {
			const ubications = assignment?.ubications || [];
			if (!ubications.some((ub) => ub?.id === ubiId)) {
				return false;
			}
		}

		return true;
	};

	_planAssignmentRowMatchesFilters = (
		plan_assignment,
		functionFilter,
		ubication_id
	) => {
		const funIds = this._normalizeFunctionFilterIds(functionFilter);
		const ubiId = this._isActiveFilterId(ubication_id)
			? parseInt(ubication_id, 10)
			: null;
		const employee = plan_assignment?.employee;

		if (funIds.length > 0) {
			const profileFunctionId = this._getEmployeeProfileFunctionId(employee);
			const matchesProfile =
				profileFunctionId !== null && funIds.includes(profileFunctionId);
			const matchesAssignment = funIds.some((funId) =>
				this._planAssignmentHasAssignmentFunction(plan_assignment, funId)
			);
			if (!matchesProfile && !matchesAssignment) {
				return false;
			}
		}

		// En Plain hace falta un turno en esa ubicación. La ficha no basta.
		// En Haddock la ficha sigue contando, como antes del arreglo de octubre.
		if (ubiId) {
			const matchesAssignment = this._planAssignmentHasAssignmentUbication(
				plan_assignment,
				ubiId
			);
			const matchesProfile =
				isHaddockEnvironment() &&
				this._getEmployeeProfileUbicationId(employee) === ubiId;
			if (!matchesAssignment && !matchesProfile) {
				return false;
			}
		}

		return true;
	};

	_filterPlanAssignmentsByActiveFilters = (
		plan_assignments,
		functionFilter,
		ubication_id
	) => {
		if (!this._isPlanFilterActive(functionFilter, ubication_id)) {
			return plan_assignments;
		}

		const funIds = this._normalizeFunctionFilterIds(functionFilter);
		const ubiId = this._isActiveFilterId(ubication_id)
			? parseInt(ubication_id, 10)
			: null;

		return (plan_assignments || [])
			.filter((plan_assignment) => {
				if (
					!this._planAssignmentRowMatchesFilters(
						plan_assignment,
						functionFilter,
						ubication_id
					)
				) {
					return false;
				}

				// Solo se oculta si las vacaciones cubren todo el periodo. Si queda
				// algún día libre, la fila sigue para poder asignar turno ahí.
				if (
					funIds.length > 0 &&
					this._planRowIsFullyOnVacation(plan_assignment)
				) {
					return false;
				}

				return true;
			})
			.map((plan_assignment) => {
				const employee = plan_assignment.employee;
				const profileMatchesUbication =
					ubiId && this._getEmployeeProfileUbicationId(employee) === ubiId;

				// Sin filtro de función, la ubicación de perfil muestra todo el periodo.
				if (funIds.length === 0 && profileMatchesUbication) {
					return plan_assignment;
				}

				return {
					...plan_assignment,
					plans: (plan_assignment.plans || []).map((plan) => ({
						...plan,
						assignments: (plan.assignments || []).filter((assignment) =>
							this._assignmentMatchesPlanFilters(
								assignment,
								functionFilter,
								ubication_id
							)
						),
					})),
				};
			});
	};

	_hasSelection = (list) => {
		const result = list.find((o) => o.checked === true);
		return result !== undefined;
	};

	_filterSelected = (list) => {
		return list.filter((o) => o.checked === true);
	};

	_uncheckSelectedList = (list) => {
		return list.map((item) => {
			item.checked = false;
			return item;
		});
	};

	// menu contextual dia
	handleDayMenuClick = (e, data, target) => {
		if (data.action === "paste-shift") {
			const dropTarget =
				Number.isInteger(data.row) && Number.isInteger(data.index)
					? { row: data.row, index: data.index }
					: null;
			this.handlePasteShifts(dropTarget);
		}
		if (data.action === "paste-plan") {
			this.handlePasteShiftPlan();
		}
		if (data.action === "cut") {
			this.handleCutShifts();
		}
		if (data.action === "cut-paste") {
			this.handlePasteCutShifts();
		}
		if (data.action === "remove") {
			this.handleRemoveShifts();
		}
		if (data.action === "paste-ubication") {
			this.handleDayPasteUbications();
		}
	};

	// UPDATE EMPLOYEE OK
	handlePasteShifts = async (dropTarget = null) => {
		this._sidebarDropInProgress = true;

		try {
		const { plan_assignments, shift_list, ubication_id } =
			this.state;
		const day_selection = resolvePasteDaySelection(
			this.state.day_selection,
			dropTarget
		);

		const missingContracts = await this._missingContractsForSelection(
			plan_assignments,
			day_selection
		);
		if (missingContracts.length > 0) {
			this.openPlanMissingContractPrompt(missingContracts);
			return;
		}

		let filteredShifts = this._filterSelected(shift_list);
		if (filteredShifts.length === 0 && this._sidebarDragShiftId != null) {
			const dragged = shift_list.find(
				(shift) => shift.id === this._sidebarDragShiftId
			);
			if (dragged) {
				filteredShifts = [dragged];
			}
		}
		const plans_to_save = [];
		const update_employee_ids = [];

		const defaultShiftId = this.props.default_shift?.id;
		const existingDefaultShiftIds = [];
		const replacedDefaultRestoreBodies = [];

		// for each selected day, save shift list
		day_selection.forEach((item) => {
			const employee = plan_assignments[item.row].employee;
			const targetPlan = plan_assignments[item.row].plans[item.index];
			const day = targetPlan.day;
			const fun = employee.employee_with_function
				? employee.employee_with_function.function.id
				: -1;
			const ubi = employee.employee_with_ubication
				? employee.employee_with_ubication.ubication.id
				: -1;

			update_employee_ids.push(employee.id);

			if (defaultShiftId && targetPlan.assignments) {
				targetPlan.assignments.forEach((a) => {
					if (a.id !== -1 && a.shift?.id === defaultShiftId) {
						existingDefaultShiftIds.push(a.id);
					}
				});
				replacedDefaultRestoreBodies.push(
					...collectDefaultShiftRestoreBodies(
						targetPlan.assignments,
						defaultShiftId,
						employee.id,
						day,
						this.state.group_id
					)
				);
			}

			filteredShifts.forEach((shift) => {
				const newPlan = {
					day: day,
					employee_id: employee.id,
					shift_id: shift.id,
					locked: true,
					ubication_ids: [],
				};

				if (shift.time_intervals) {
					const time_intervals = shift.time_intervals.map((interval) => {
						interval.time_type_id = interval.time_type.id;

						return interval;
					});

					newPlan.time_intervals = time_intervals;
				}

				if (fun > 0) newPlan.function_id = fun;

				if (ubi > 0) newPlan.ubication_ids.push(ubi * 1);

				plans_to_save.push(newPlan);
			});
		});

		// dividimos en bloques de 10 para no saturar la API
		const chunkArray = (arr, size) => {
			return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
				arr.slice(i * size, i * size + size)
			);
		};

		const chunks = chunkArray(plans_to_save, 10);
		const results = await Promise.allSettled(
			chunks.map((chunk) => plansService.updateMultiple(chunk))
		);

		let hasErrors = false;
		let hasSuccess = false;
		let textError = this.props.t("plan.error.foundErrors");

		// Recorremos los resultados para capturar errores y éxitos parciales
		results.forEach((result, index) => {
			if (result.status === "rejected") {
				hasErrors = true;
				textError += `- Error en el bloque ${index + 1}: ${result.reason} \r\n`;
			} else {
				// Si la API respondió correctamente, verificamos si hubo errores dentro de la respuesta
				if (result.value && result.value.length > 0) {
					result.value.forEach((item) => {
						if (item.errors) {
							hasErrors = true;
							item.errors.forEach((error) => {
								textError += `- ${error.description} \r\n`;
							});
						} else {
							// Si al menos un turno se guardó correctamente, marcamos `hasSuccess`
							hasSuccess = true;
						}
					});
				}
			}
		});

		// Si hubo al menos un éxito, actualizamos la planificación
		if (hasSuccess) {
			this._rememberReplacedDefaultRests(replacedDefaultRestoreBodies);
			for (const existingId of existingDefaultShiftIds) {
				try {
					await plansService.remove(existingId);
				} catch (_) {
					// Ya fue reemplazado por la API
				}
			}

			const pasteInverse = await this._resolvePasteUndoInverse({
				plansToSave: plans_to_save,
				chunks,
				chunkResults: results,
				employeeIds: update_employee_ids,
				replacedDefaultRestoreBodies,
			});

			this._notifyPlanMutation({
				type: "BULK_CREATE",
				messageKey: "undo.plan.shiftsPasted",
				inverse: pasteInverse || undefined,
				employeeIds: update_employee_ids,
			});

			this.setState(
				(prevState) => ({
					update_employee_ids,
					plan_assignments: prevState.plan_assignments.map((assignment) => ({
						...assignment,
						plans: (assignment.plans || []).map((plan) => ({
							...plan,
							checked: false,
						})),
					})),
					day_selection: [],
					day_selection_copy: [],
					day_selection_dashed: [],
					shift_list: this._uncheckSelectedList(prevState.shift_list),
					isSidebarDragging: false,
				}),
				() => {
					this.getAllAssignments(); // Refrescar vista
				}
			);
		} else {
			this.setState({ isSidebarDragging: false });
		}

		// Si hubo errores, mostramos la alerta
		if (hasErrors) {
			const showedContractPrompt =
				!hasSuccess &&
				this._tryOpenMissingContractPromptFromPlanErrors(
					results,
					plans_to_save,
					plan_assignments
				);
			if (!showedContractPrompt) {
				this.openAlertModal(
					textError,
					this.props.t("plan.error.pasteShiftsTitle")
				);
			}
		}
		} finally {
			this._sidebarDropInProgress = false;
			this._isSidebarDragging = false;
			this._sidebarDragShiftId = null;
		}
	};

	syncStaffingHeaderScroll = (scrollLeft = 0) => {
		if (!this.staffingHeaderRef || !document.contains(this.staffingHeaderRef)) {
			this.staffingHeaderRef = document.querySelector(
				".staffing-container .heading.gray"
			);
		}

		if (this.staffingHeaderRef) {
			this.staffingHeaderRef.style.transform = `translateX(${scrollLeft}px)`;
		}
	};

	// Al acortar el periodo, un scrollLeft/transform antiguos inflan el
	// scrollWidth del plan-container y dejan la vista en blanco hasta
	// scrollear a la izquierda. Hay que resetear ambos al cambiar fechas.
	resetPlanHorizontalScroll = () => {
		scrollPlanLeft = 0;
		this.staffingHeaderRef = null;

		if (this.refScrollPlan.current) {
			this.refScrollPlan.current.scrollLeft = 0;
		}

		if (this.refScrollNeeds.current) {
			this.refScrollNeeds.current.scrollLeft = 0;
		}

		this.syncStaffingHeaderScroll(0);
	};

	updatePlanScroll = () => {
		// Leer la posición real del DOM antes de mutar alturas/spacers: si un
		// evento scroll se perdió por _scrollSyncLock, scrollPlanTop queda viejo
		// y al restaurar el scroll “salta” hacia arriba (muy visible en vista Horas).
		this._capturePlanScrollFromDom();

		if (this.refScrollPlan.current) {
			const el = this.refScrollPlan.current;
			const maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
			scrollPlanLeft = Math.min(Math.max(0, scrollPlanLeft), maxScrollLeft);
			el.scrollLeft = scrollPlanLeft;
			el.scrollTop = scrollPlanTop;
			this.syncStaffingHeaderScroll(scrollPlanLeft);
		}

		if (this.refScrollNeeds.current) {
			this.refScrollNeeds.current.scrollLeft = scrollPlanLeft;
		}

		// También restaurar el scroll del contenedor de contadores
		if (this.refScrollCounter.current) {
			this.refScrollCounter.current.scrollTop = scrollPlanTop;
		}

		this.syncRowHeights();
		this.updateCounterScrollSpacer();
		this.updateNeedsCounterSpacer();

		// Restaurar el scroll después de sincronizar las alturas
		if (this.refScrollPlan.current) {
			const el = this.refScrollPlan.current;
			const maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
			scrollPlanLeft = Math.min(Math.max(0, scrollPlanLeft), maxScrollLeft);
			el.scrollLeft = scrollPlanLeft;
			el.scrollTop = scrollPlanTop;
			this.syncStaffingHeaderScroll(scrollPlanLeft);
		}

		if (this.refScrollNeeds.current) {
			this.refScrollNeeds.current.scrollLeft = scrollPlanLeft;
		}

		// Restaurar también el contador después de syncRowHeights
		if (this.refScrollCounter.current) {
			this.refScrollCounter.current.scrollTop = scrollPlanTop;
		}

		this.ensureScrollSyncListeners();
	};

	_buildRemoveShiftsPayload = () => {
		const { plan_assignments, day_selection } = this.state;

		const plans_to_delete = [];
		const employeeIds = new Set(); // evita duplicados

		day_selection.forEach((item) => {
			const plan_assignment = plan_assignments[item.row];
			const assignments = plan_assignment.plans[item.index].assignments || [];

			assignments.forEach((assignment) => {
				plans_to_delete.push({ id: assignment.id });

				if (plan_assignment.employee?.id) {
					employeeIds.add(plan_assignment.employee.id);
				}
			});
		});

		return {
			plans_to_delete,
			update_employee_ids: Array.from(employeeIds),
		};
	};

	_removeShiftsNow = async ({ plans_to_delete, update_employee_ids }) => {
		const count = plans_to_delete.length;
		const vacatedCells = this._collectVacatedCellsFromSelection();
		const bulkDeleteInverse = buildPlanBulkDeleteInverse(
			this.state.plan_assignments,
			plans_to_delete
		);
		const response = await plansService.removeMultiple(plans_to_delete);

		if (response.ok) {
			await this._restoreVacatedCellsDefaultRests(vacatedCells);
			this._notifyPlanMutation({
				type: "BULK_DELETE",
				messageKey: "undo.plan.shiftsDeletedCount",
				messageParams: { count },
				inverse: bulkDeleteInverse || undefined,
				employeeIds: update_employee_ids,
			});
			this.setState(
				{
					update_employee_ids,
					day_selection_dashed: [],
					shift_list: this._uncheckSelectedList(this.state.shift_list),
					isSidebarDragging: false,
				},
				() => {
					this.unselectAllDays();
					this.getAllAssignments();
				}
			);
		} else {
			const textError =
				response.errors?.[0]?.description ||
				this.props.t("common.errorUnknown");
			this.openAlertModal(
				textError,
				this.props.t("plan.error.deleteShiftsTitle")
			);
		}
	};

	// UPDATE EMPLOYEE OK
	handleRemoveShifts = async () => {
		const payload = this._buildRemoveShiftsPayload();
		const count = payload.plans_to_delete.length;

		// Nada que borrar
		if (count === 0) return;

		// Si solo hay 1, borra directo
		if (count === 1) {
			return this._removeShiftsNow(payload);
		}

		// Si hay más de 1, confirmación
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.deleteShifts"),
				style: { width: "450px" },
				confirmText: "Eliminar",
				loadingText: this.props.t("plan.deleting"),
				message: `Vas a eliminar ${count} turnos. Esta acción no se puede deshacer. ¿Deseas continuar?`,
				closeModal: this.closeModal,
				confirmAction: async () => {
					this.props.updateModalLoading(true);
					await this._removeShiftsNow(payload);
					this.closeModal();
				},
			},
			"confirm"
		);
	};

	// cortar turnos (no es necesario update empleado)
	handleCutShifts = async () => {
		const { day_selection, plan_assignments } = this.state;

		// comprueba que solo corresponda a un empleado
		var moreEmployees = false;
		var check_row;
		day_selection.map((item, index) => {
			if (index === 0) {
				check_row = item.row;
			} else {
				if (check_row != item.row) {
					moreEmployees = true;
				}
			}
		});

		if (day_selection.length >= 7) {
			toastr.error("", this.props.t("plan.error.maxDaysCut"));
		} else if (moreEmployees) {
			toastr.error("", this.props.t("plan.error.cutSameEmployee"));
		} else {
			// todo ok, vamos:
			day_selection.forEach((item) => {
				plan_assignments[item.row].plans[item.index].checked = false;
			});

			this.setState(
				{
					day_selection: [],
					shift_list: this._uncheckSelectedList(this.state.shift_list),
					isSidebarDragging: false,
					day_selection_copy: day_selection,
					plan_assignments,
				},
				() => {
					toastr.success("¡Bien!", this.props.t("plan.cutOk"));
				}
			);
		}
	};

	// UPDATE EMPLOYEE OK
	// pegar turnos cortados
	handlePasteCutShifts = async () => {
		const { day_selection, day_selection_copy, plan_assignments } = this.state;
		// empleado de destino (será único)
		const update_employee_ids = [];
		const target_employee = plan_assignments[day_selection[0].row].employee;
		update_employee_ids.push(target_employee.id);

		// el dia del plan lo cogemos de la selección de días de destino (day_selection), usando el primer objeto seleccionado
		const target_day =
			plan_assignments[day_selection[0].row].plans[day_selection[0].index].day;

		const object_to_paste = {
			day: target_day, // target day
			employee_id: target_employee.id, // target employee
		};
		const plans_to_save = [];

		// recorremos la selección de días cortados (day_selection_copy)
		day_selection_copy.forEach((selected_day, index) => {
			const day_plans =
				plan_assignments[selected_day.row].plans[selected_day.index];
			const day = day_plans.day;
			const employee = plan_assignments[selected_day.row].employee;

			// entra en los assignments del dia seleccionado
			day_plans.assignments.forEach((shift_plan) => {
				const newPlan = {
					id: shift_plan.id,
					employee_id: employee.id,
					day,
					locked: true,
				};

				newPlan.shift_id = shift_plan.shift.id;

				if (shift_plan.function) {
					newPlan.function_id = shift_plan.function.id;
				}

				if (shift_plan.ubications) {
					const ubication_ids = [];
					shift_plan.ubications.map((ubication) => {
						ubication_ids.push(ubication.id);
						return true;
					});

					newPlan.ubication_ids = ubication_ids;
				}

				if (shift_plan.comments) newPlan.comments = shift_plan.comments;

				if (shift_plan.time_intervals) {
					const time_intervals = shift_plan.time_intervals.map((interval) => {
						interval.time_type_id = interval.time_type.id;
						return interval;
					});
					newPlan.time_intervals = time_intervals;
				}

				plans_to_save.push(newPlan);
			});
		});

		// PEGAR turnos planificados en la nueva selección:
		const paste_response = await plansService.cutAndPaste(object_to_paste);
		var hasErrors = false;
		var textError = this.props.t("plan.error.foundErrors");
		paste_response.map((item) => {
			if (item.errors !== undefined) {
				hasErrors = true;
				item.errors.map((error) => {
					textError += "- " + error.description + "\r\n";
				});
			}
		});

		if (hasErrors) {
			this.openAlertModal(
				textError,
				this.props.t("plan.error.pasteShiftsTitle")
			);
		}

		this.setState(
			{
				day_selection_dashed: day_selection_copy,
				day_selection_copy: [],
				update_employee_ids,
			},
			() => {
				this.unselectAllDays();
				this.getAllAssignments();
			}
		);
	};

	// pegar ubicaciones en uno o varios días (menu day)
	// UPDATE EMPLOYEE OK
	handleDayPasteUbications = async () => {
		const { plan_assignments, day_selection, ubication_list } = this.state;
		const filteredUbications = this._filterSelected(ubication_list);
		const plans_to_save = [];
		const update_employee_ids = [];
		const undoUpdates = collectUbicationPasteUpdates(
			plan_assignments,
			day_selection,
			filteredUbications
		);

		// for each selected day and each shift, add ubication(s)
		day_selection.map((selected_day, index) => {
			const day_plans =
				plan_assignments[selected_day.row].plans[selected_day.index];
			const day = day_plans.day;
			const employee = plan_assignments[selected_day.row].employee;
			update_employee_ids.push(employee.id);

			// entra en los assignments del dia seleccionado
			day_plans.assignments.map((shift_plan) => {
				// solo entramos si tiene turno asignado
				if (shift_plan.id !== -1) {
					const newPlan = {
						id: shift_plan.id,
						employee_id: employee.id,
						day,
						locked: true,
					};

					newPlan.shift_id = shift_plan.shift.id;

					if (shift_plan.function) {
						newPlan.function_id = shift_plan.function.id;
					}

					if (shift_plan.comments) newPlan.comments = shift_plan.comments;

					if (shift_plan.time_intervals) {
						const time_intervals = shift_plan.time_intervals.map((interval) => {
							interval.time_type_id = interval.time_type.id;
							return interval;
						});
						newPlan.time_intervals = time_intervals;
					}

					// y ahora sí, las ubicaciones
					const ubication_ids = [];
					// las existentes:
					shift_plan.ubications &&
						shift_plan.ubications.map((ubication) => {
							ubication_ids.push(ubication.id);
							return true;
						});
					// las nuevas:
					filteredUbications.map((ubication) => {
						ubication_ids.push(ubication.id);
						return true;
					});
					newPlan.ubication_ids = ubication_ids;

					plans_to_save.push(newPlan);
				}
				return true;
			});

			return true;
		});

		if (plans_to_save.length > 0) {
			const response = await plansService.updateMultiple(plans_to_save);
			var hasErrors = false;
			var textError = this.props.t("plan.error.foundErrors");
			response.map((item) => {
				if (item.errors !== undefined) {
					hasErrors = true;
					item.errors.map((error) => {
						textError += "- " + error.description + "\r\n";
					});
				}
			});

			if (!hasErrors) {
				const ubicationsInverse = buildPlanBulkUpdateInverse(undoUpdates);

				this._notifyPlanMutation({
					type: "BULK_UPDATE",
					messageKey: "undo.plan.ubicationsPasted",
					inverse: ubicationsInverse || undefined,
					employeeIds: [...new Set(update_employee_ids)],
				});

				this.setState(
					{
						day_selection: [],
						day_selection_dashed: [],
						ubication_list: this._uncheckSelectedList(
							this.state.ubication_list
						),
						isSidebarDragging: false,
						update_employee_ids,
					},
					() => {
						this.getAllAssignments();
					}
				);
			} else {
				this.openAlertModal(
					textError,
					this.props.t("plan.error.pasteUbicationsTitle")
				);
			}
		} else {
			this.openAlertModal(
				this.props.t("plan.error.pasteUbicationsOnShifts"),
				this.props.t("plan.error.pasteUbicationsTitle")
			);
		}
	};

	// menu contextual staffing levels

	handleEditStaffingLevel = async (options) => {
		const { group, needs_selection } = this.state;

		options.group = group;
		options.needs_selection = needs_selection;
		options.isMultiple =
			needs_selection !== undefined && needs_selection.length > 1;

		this.openEditStaffingLevelModal(options);
	};

	handleStaffingMenuClick = (e, data, target) => {
		if (data.action === "edit") {
			this.handleEditStaffingLevel(data.itemStaffing);
		}
	};

	handleScroll(e) {
		const target = e.target;
		const isPlanScroll = target === this.refScrollPlan.current;
		const isCounterScroll = target === this.refScrollCounter.current;

		// Siempre persistir la posición aunque el lock esté activo: el lock solo
		// evita re-sincronizar en bucle, no debe perder scrollTop para restore.
		if (isPlanScroll) {
			scrollPlanLeft = target.scrollLeft;
			scrollPlanTop = target.scrollTop;
		} else if (isCounterScroll) {
			scrollPlanTop = target.scrollTop;
		}

		if (this._scrollSyncLock) return;

		// Needs no es líder de scroll X: solo recibe scrollLeft del plan.
		// Su scroll Y es nativo e independiente (sin listener de sync).
		if (isPlanScroll) {
			this._scrollLeader = "plan";
			this._applyLinkedScrollFromPlan();
		} else if (isCounterScroll) {
			this._scrollLeader = "counter";
			this._applyLinkedScrollFromCounter();
		} else {
			return;
		}

		this._armScrollSyncLoop();
	}

	_clampScroll = (value, max) => Math.max(0, Math.min(max, value));

	_getScrollMax = (el, axis) => {
		if (!el) return 0;
		return axis === "left"
			? Math.max(0, el.scrollWidth - el.clientWidth)
			: Math.max(0, el.scrollHeight - el.clientHeight);
	};

	_normalizeWheelDelta = (e) => {
		let { deltaX, deltaY, deltaMode } = e;
		if (deltaMode === 1) {
			deltaX *= 16;
			deltaY *= 16;
		} else if (deltaMode === 2) {
			const plan = this.refScrollPlan.current;
			deltaX *= plan?.clientWidth || 800;
			deltaY *= plan?.clientHeight || 600;
		}
		return { deltaX, deltaY };
	};

	_applyLinkedScrollFromPlan = () => {
		const plan = this.refScrollPlan.current;
		const needs = this.refScrollNeeds.current;
		const counter = this.refScrollCounter.current;
		if (!plan) return;

		const scrollLeft = plan.scrollLeft;
		const scrollTop = plan.scrollTop;

		this._scrollSyncLock = true;
		if (needs && needs.scrollLeft !== scrollLeft) {
			needs.scrollLeft = scrollLeft;
		}
		if (counter && counter.scrollTop !== scrollTop) {
			counter.scrollTop = scrollTop;
		}
		this._scrollSyncLock = false;

		scrollPlanLeft = scrollLeft;
		scrollPlanTop = scrollTop;
		this.syncStaffingHeaderScroll(scrollLeft);
	};

	_applyLinkedScrollFromCounter = () => {
		const plan = this.refScrollPlan.current;
		const counter = this.refScrollCounter.current;
		if (!counter) return;

		const scrollTop = counter.scrollTop;
		this._scrollSyncLock = true;
		if (plan && plan.scrollTop !== scrollTop) {
			plan.scrollTop = scrollTop;
		}
		this._scrollSyncLock = false;

		scrollPlanTop = scrollTop;
	};

	/**
	 * Wheel en el mismo frame: evita el desfase de 1 frame del evento scroll
	 * (compositor). La inercia del trackpad sigue llegando como eventos wheel.
	 */
	handlePlanWheel = (e) => {
		const plan = this.refScrollPlan.current;
		const needs = this.refScrollNeeds.current;
		const counter = this.refScrollCounter.current;
		if (!plan || (!needs && !counter)) return;

		e.preventDefault();
		this._scrollLeader = "plan";

		const { deltaX, deltaY } = this._normalizeWheelDelta(e);
		// El tope horizontal lo marca solo el plan (needs no tiene scroll-x).
		const maxLeft = this._getScrollMax(plan, "left");
		const planMaxTop = this._getScrollMax(plan, "top");
		const counterMaxTop = counter
			? this._getScrollMax(counter, "top")
			: planMaxTop;
		// No superar el tope del contador: si el spacer aún no cuadra, forzar recálculo.
		const maxTop = Math.min(planMaxTop, counterMaxTop);
		if (counter && counterMaxTop < planMaxTop - 2) {
			this.updateCounterScrollSpacer();
		}

		const nextLeft = this._clampScroll(plan.scrollLeft + deltaX, maxLeft);
		const nextTop = this._clampScroll(plan.scrollTop + deltaY, maxTop);

		this._scrollSyncLock = true;
		plan.scrollLeft = nextLeft;
		plan.scrollTop = nextTop;
		if (needs) needs.scrollLeft = nextLeft;
		if (counter) counter.scrollTop = nextTop;
		this._scrollSyncLock = false;

		scrollPlanLeft = nextLeft;
		scrollPlanTop = nextTop;
		this.syncStaffingHeaderScroll(nextLeft);
		this._armScrollSyncLoop();
	};

	handleNeedsWheel = (e) => {
		const needs = this.refScrollNeeds.current;
		if (!needs) return;

		const { deltaX, deltaY } = this._normalizeWheelDelta(e);
		const absX = Math.abs(deltaX);
		const absY = Math.abs(deltaY);

		// Horizontal solo desde la tabla de turnos. Sobre needs: tragar el
		// gesto X (no mover el plan). Si el gesto es vertical, dejar nativo
		// o aplicar solo Y cuando haya componente X que habría que anular.
		if (absX < 1) return;

		e.preventDefault();
		if (absY > absX) {
			const maxTop = this._getScrollMax(needs, "top");
			needs.scrollTop = this._clampScroll(needs.scrollTop + deltaY, maxTop);
		}
	};

	handleCounterWheel = (e) => {
		const plan = this.refScrollPlan.current;
		const counter = this.refScrollCounter.current;
		if (!plan || !counter) return;

		e.preventDefault();
		this._scrollLeader = "counter";

		const { deltaY } = this._normalizeWheelDelta(e);
		const maxTop = this._getScrollMax(counter, "top");
		const nextTop = this._clampScroll(counter.scrollTop + deltaY, maxTop);

		this._scrollSyncLock = true;
		counter.scrollTop = nextTop;
		plan.scrollTop = nextTop;
		this._scrollSyncLock = false;

		scrollPlanTop = nextTop;
		this._armScrollSyncLoop();
	};

	_armScrollSyncLoop = () => {
		// Cubre inercia residual y arrastre de scrollbar (~1 frame de corrección).
		this._scrollSyncUntil = performance.now() + 180;
		if (this._scrollSyncRaf != null) return;

		const tick = () => {
			if (this._scrollLeader === "counter") {
				this._applyLinkedScrollFromCounter();
			} else {
				this._applyLinkedScrollFromPlan();
			}

			if (performance.now() < this._scrollSyncUntil) {
				this._scrollSyncRaf = requestAnimationFrame(tick);
			} else {
				this._scrollSyncRaf = null;
			}
		};

		this._scrollSyncRaf = requestAnimationFrame(tick);
	};

	detachScrollSyncListeners = () => {
		if (this._boundScrollPlan) {
			this._boundScrollPlan.removeEventListener("scroll", this.handleScroll);
			this._boundScrollPlan.removeEventListener("wheel", this.handlePlanWheel);
			this._boundScrollPlan = null;
		}
		if (this._boundScrollNeeds) {
			this._boundScrollNeeds.removeEventListener("wheel", this.handleNeedsWheel);
			this._boundScrollNeeds = null;
		}
		if (this._boundScrollCounter) {
			this._boundScrollCounter.removeEventListener("scroll", this.handleScroll);
			this._boundScrollCounter.removeEventListener(
				"wheel",
				this.handleCounterWheel
			);
			this._boundScrollCounter = null;
		}
	};

	ensureScrollSyncListeners = () => {
		const plan = this.refScrollPlan.current;
		const needs = this.refScrollNeeds.current;
		const counter = this.refScrollCounter.current;

		if (plan !== this._boundScrollPlan) {
			if (this._boundScrollPlan) {
				this._boundScrollPlan.removeEventListener("scroll", this.handleScroll);
				this._boundScrollPlan.removeEventListener("wheel", this.handlePlanWheel);
			}
			if (plan) {
				plan.addEventListener("scroll", this.handleScroll, { passive: true });
				plan.addEventListener("wheel", this.handlePlanWheel, { passive: false });
			}
			this._boundScrollPlan = plan;
		}

		if (needs !== this._boundScrollNeeds) {
			if (this._boundScrollNeeds) {
				this._boundScrollNeeds.removeEventListener(
					"wheel",
					this.handleNeedsWheel
				);
			}
			if (needs) {
				// Solo wheel X → plan. Sin listener scroll: needs no lidera X.
				needs.addEventListener("wheel", this.handleNeedsWheel, {
					passive: false,
				});
			}
			this._boundScrollNeeds = needs;
		}

		if (counter !== this._boundScrollCounter) {
			if (this._boundScrollCounter) {
				this._boundScrollCounter.removeEventListener(
					"scroll",
					this.handleScroll
				);
				this._boundScrollCounter.removeEventListener(
					"wheel",
					this.handleCounterWheel
				);
			}
			if (counter) {
				counter.addEventListener("scroll", this.handleScroll, {
					passive: true,
				});
				counter.addEventListener("wheel", this.handleCounterWheel, {
					passive: false,
				});
			}
			this._boundScrollCounter = counter;
		}
	};

	getPlanContent = () => {
		const { error } = this.props;
		const {
			loading,
			plan_grid_view,
			plan_assignments,
			isExtendedView,
			hasPrivileges,
			showMax,
			plan_no_results,
			no_contract,
			counterScrollSpacerHeight,
			needsCounterSpacerWidth,
			hoursNeedsMaxHeightPx,
			hoursNeedsRevealed,
		} = this.state;

		// solo la primera vez
		if (loading) {
			return <Loading />;
		}

		if (no_contract) {
			return (
				<div className="empty-container w100">
					<FiCalendar />
					Su usuario no tiene contrato. Debe tener uno asignado para poder ver
					la planificación.
				</div>
			);
		} else if (error) {
			return (
				<div className="empty-container w100">
					<FiCalendar />
					Se ha producido un error al cargar la planificación: {error}
				</div>
			);
		} else if (!plan_assignments) {
			return (
				<div className="empty-container w100">
					<FiCalendar />
					{this.props.t("plans.loadError")}
				</div>
			);
		}

		if (plan_assignments.length < 1 && plan_no_results) {
			return (
				<div className="empty-container w100">
					<FiCalendar />
					Sin resultados
				</div>
			);
		}

		if (
			PLAN_GRID_VIEWS.vertical === plan_grid_view ||
			PLAN_GRID_VIEWS.shifts === plan_grid_view
		) {
			return (
				<div className="plan-panel-with-toolbar">
					<div
						ref={this.refScrollPlan}
						id="planContainer"
						className="plan-container"
					>
						{this.getBloquePlan()}
					</div>
				</div>
			);
		}

		const panelsWidth =
			isExtendedView || !hasPrivileges ? "100%" : "calc(100% - 140px)";

		const horizontalPanels = (
			<ResizablePanels
				key={`plan-grid-${plan_grid_view}`}
				ref={this.refResizablePanels}
				displayDirection="row"
				width={PLAN_GRID_VIEWS.hours === plan_grid_view ? "100%" : panelsWidth}
				panelsSize={[70, 30]}
				isMax={showMax}
				sizeUnitMeasure="%"
				className="resizable-wrapper"
				toggleMode={true}
				viewId={this.state.plan_view_id}
				onPanelsLayoutChange={this._schedulePlanRowHeightSync}
			>
				<div className="plan-panel-with-toolbar">
					<div
						ref={this.refScrollPlan}
						id="planContainer"
						className="plan-container"
					>
						{this.getBloquePlan()}
						{/* Paginación: no pintar necesidades debajo hasta loadComplete.
						    Si no, tras el último chunk aparece el empty de 7 días y parece
						    tabla truncada (bug María/Malgorzata). */}
						{showsStaffingUnderPlan(plan_grid_view) &&
							!this._shouldDeferStaffingUnderPlan() &&
							this.getBloqueStaffingLevel()}
					</div>
				</div>
				{PLAN_GRID_VIEWS.vertical !== plan_grid_view &&
					PLAN_GRID_VIEWS.ubication_grouped !== plan_grid_view &&
					PLAN_GRID_VIEWS.shifts !== plan_grid_view && (
						<div
							ref={this.refScrollCounter}
							className="counter-container"
						>
							{this.getBloqueCounter()}
							{counterScrollSpacerHeight > 0 && (
								<div
									className="counter-scroll-spacer"
									style={{ height: `${counterScrollSpacerHeight}px` }}
								/>
							)}
						</div>
					)}
			</ResizablePanels>
		);

		// Vista Horas: split vertical — arriba plan+contador, abajo cobertura.
		// Hasta revelar (staffing listo + altura medida) no hay resizer ni needs
		// visibles: el plan usa todo el alto. La tabla se monta oculta para medir.
		if (PLAN_GRID_VIEWS.hours === plan_grid_view) {
			if (!hoursNeedsRevealed) {
				const staffingHourlyLoading = this.state.staffing_hourly_loading;
				const hoursPlanMounted = this.state.hoursPlanMounted;
				const canMeasureNeeds =
					hoursPlanMounted &&
					!this.state.loading &&
					!staffingHourlyLoading &&
					this.state.hoursLayoutReady;
				return (
					<div className="hours-layout-vertical hours-layout-vertical--needs-pending relative">
						<div
							className="loading-overlay hours-staffing-loading-overlay"
							aria-busy="true"
							aria-live="polite"
						>
							<Loading />
						</div>
						{hoursPlanMounted ? (
							horizontalPanels
						) : (
							<div
								className="hours-layout-vertical-shell"
								aria-hidden="true"
							/>
						)}
						{canMeasureNeeds && (
							<div
								ref={this.refScrollNeeds}
								className="hourly-needs-panel hourly-needs-panel--measure"
								aria-hidden="true"
							>
								<div className="hourly-needs-panel-content">
									{this.getBloqueHourlyCounter()}
								</div>
							</div>
						)}
					</div>
				);
			}

			return (
				<ResizablePanels
					ref={this.refHoursVerticalPanels}
					displayDirection="column"
					width={panelsWidth}
					height="100%"
					panelsSize={[68, 32]}
					minPanelsSize={[0, 0]}
					minPanelsSizePx={[120, 80]}
					maxPanelsSizePx={
						hoursNeedsMaxHeightPx > 0
							? [0, hoursNeedsMaxHeightPx]
							: undefined
					}
					sizeUnitMeasure="%"
					className="resizable-wrapper hours-layout-vertical"
					toggleMode={false}
					storageKey={HOURS_NEEDS_VERTICAL_STORAGE_KEY}
					resizerSize={`${HOURS_NEEDS_RESIZER_PX}px`}
				>
					{horizontalPanels}
					<div
						ref={this.refScrollNeeds}
						className="hourly-needs-panel"
					>
						<div className="hourly-needs-panel-content">
							{this.getBloqueHourlyCounter()}
							{needsCounterSpacerWidth > 0 && (
								<div
									className="hourly-needs-counter-spacer"
									style={{ width: `${needsCounterSpacerWidth}px` }}
									aria-hidden="true"
								/>
							)}
						</div>
					</div>
				</ResizablePanels>
			);
		}

		return horizontalPanels;
	};
	// anterior
	// renderLoadingOverlay(loadingState) {
	// 	if (!loadingState) {
	// 		return null;
	// 	}

	// 	return (
	// 		<div className="loading-overlay">
	// 			<Loading />
	// 		</div>
	// 	);
	// }

	renderLoadingOverlay(loadingState) {
		return (
			<DelayedMount
				active={!!loadingState}
				delay={3000} /* minVisibleMs={500} opcional */
			>
				<div className="loading-overlay">
					<Loading />
				</div>
			</DelayedMount>
		);
	}

	// plan render
	renderCreateMenu = () => {
		const {
			canEditShifts,
			canEditEmployees,
			canCreateFunctions,
			canCreateUbications,
			canCreateShiftPatterns,
			canCreateStaffingLevels,
		} = this.state;

		if (
			!canEditShifts &&
			!canEditEmployees &&
			!canCreateFunctions &&
			!canCreateUbications &&
			!canCreateShiftPatterns &&
			!canCreateStaffingLevels
		) {
			return null;
		}

		return (
			<Dropdown className="dropdown-create" align="end">
				<Dropdown.Toggle
					variant="new"
					id="plan-create-menu"
					title={this.props.t("plan.createMenu.title")}
				>
					<HiOutlinePlus size={22} />
				</Dropdown.Toggle>
				<Dropdown.Menu>
					{canEditShifts && (
						<Dropdown.Item as="button" onClick={() => this.openNewShiftModal()}>
							{this.props.t("plan.createMenu.shift")}
						</Dropdown.Item>
					)}
					{canEditEmployees && (
						<Dropdown.Item as="button" onClick={() => this.openNewEmployeeModal()}>
							{this.props.t("plan.createMenu.employee")}
						</Dropdown.Item>
					)}
					{canCreateFunctions && (
						<Dropdown.Item as="button" onClick={() => this.openNewFunctionModal()}>
							{this.props.t("plan.createMenu.function")}
						</Dropdown.Item>
					)}
					{canCreateUbications && (
						<Dropdown.Item as="button" onClick={() => this.openNewUbicationModal()}>
							{this.props.t("plan.createMenu.ubication")}
						</Dropdown.Item>
					)}
					{canCreateShiftPatterns && (
						<Dropdown.Item as="button" onClick={() => this.openNewShiftPatternModal()}>
							{this.props.t("plan.createMenu.shiftPattern")}
						</Dropdown.Item>
					)}
					{canCreateStaffingLevels && (
						<Dropdown.Item as="button" onClick={() => this.openNewStaffingLevelCatalogModal()}>
							{this.props.t("plan.createMenu.staffingLevel")}
						</Dropdown.Item>
					)}
				</Dropdown.Menu>
			</Dropdown>
		);
	};

	getBloquePlan = () => {
		const { plan_days, default_shift, working_hours } = this.props;
		const {
			plan_assignments,
			day_selection,
			day_selection_copy,
			day_selection_dashed,
			current_month,
			plan_grid_view,
			hasPrivileges,
			working_hours_list,
			ubication_list,
			plan_no_results,
			plan_loading,
			plan_pending_skeleton_count,
		} = this.state;

		const isUbicationListSelected = this._hasSelection(ubication_list);

		return (
			<div className="relative">
				{this.renderLoadingOverlay(plan_loading)}
				{plan_pending_skeleton_count > 0 && (
					<div className="plan-load-more-chip" aria-live="polite">
						Cargando más empleados…
					</div>
				)}
				<PlanTable
					hasPrivileges={this.state.planBtnState ? false : hasPrivileges}
					isUbicationListSelected={isUbicationListSelected}
					group_id={this.state.group_id}
					start={this.state.start}
					end={this.state.end}
					plan_days={plan_days}
					plan_assignments={plan_assignments}
					multigroupSections={this._getMultigroupGrouping()?.sections}
					onToggleMultigroupSection={this.toggleMultigroupSection}
					plan_pending_skeleton_count={plan_pending_skeleton_count}
					day_selection={day_selection}
					day_selection_copy={day_selection_copy}
					day_selection_dashed={day_selection_dashed}
					default_shift={default_shift}
					current_month={current_month}
					plan_grid_view={plan_grid_view}
					working_hours={working_hours}
					working_hours_list={working_hours_list}
					changeMonthHeader={this.changeMonthHeader}
					handleDaySelection={this.handleDaySelection}
					handleColumnSelection={this.handleColumnSelection}
					handleRowSelection={this.handleRowSelection}
					selectSingleDay={this.selectSingleDay}
					handleDayMenuClick={this.handleDayMenuClick}
					handleShiftMenuClick={this.handleShiftMenuClick}
					handleEditShift={this.handleEditShift}
					handleResizeHourlyShift={this.handleResizeHourlyShift}
					handleCopyShift={this.handleCopyShift}
					handleMoveShift={this.handleMoveShift}
					handleCopyPasteShift={this.handleCopyPasteShift}
					handleReassignShiftInShiftsView={this.handleReassignShiftInShiftsView}
					handleRemoveShift={this.handleRemoveShift}
					onShiftAssigned={this._handleShiftAssigned}
					onEmployeeDrawerClose={this.handleEmployeeDrawerClose}
					updateEmployeeIdsAndGetAllAssignments={
						this.updateEmployeeIdsAndGetAllAssignments
					}
				/>
			</div>
		);
	};

	changeMonthHeader = (inView, entry, new_day) => {
		const { current_month } = this.state;
		const month = moment(current_month).format("MM");
		var day = moment(new_day).format("MM");

		if (inView && month !== day) {
			this.setState({
				current_month: new_day,
			});
		}
	};

	openNewStaffingLevelModal(data) {
		const { staffing_levels } = this.props;
		const { group_id } = this.state;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.newAssignmentNeeds"),
				style: { width: "400px" },
				content: (
					<GroupStaffingLevelsEdit
						handleClose={this.closeModal}
						triggerStaffingLevelAssignments={this.getStaffingLevelAssignments}
						start_day={data.day}
						end_day={data.day}
						staffing_levels={staffing_levels}
						group_id={group_id}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	//counter render
	getBloqueCounter = () => {
		const { error, account_assignments, plan_views } = this.props;
		const {
			start,
			end,
			plan_grid_view,
			accounts_loading,
			plan_view_id,
			selected_employee_ids,
		} = this.state;

		if (error) {
			return this.props.t("plan.errorLoadingCounters");
		}

		const optionViewList =
			plan_views &&
			plan_views.length > 0 &&
			plan_views.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{translatePlanViewName(item)}
					</option>
				);
			}, this);

		const { selected_function_ids, ubication_id, plan_assignments } =
			this.state;
		const activeFunctionIds = this._getActiveFunctionFilterIds();

		let filteredAccountAssignments = account_assignments;

		if (
			Array.isArray(selected_employee_ids) &&
			selected_employee_ids.length > 0
		) {
			filteredAccountAssignments = filteredAccountAssignments.filter(
				(assignment) =>
					selected_employee_ids.includes(String(assignment?.employee?.id))
			);
		}

		if (activeFunctionIds.length > 1) {
			filteredAccountAssignments = filteredAccountAssignments.filter(
				(assignment) => {
					const planAssignment = (plan_assignments || []).find(
						(pa) => pa.employee?.id === assignment.employee?.id
					);
					if (planAssignment) {
						return this._planAssignmentRowMatchesFilters(
							planAssignment,
							selected_function_ids,
							ubication_id
						);
					}
					const profileFunctionId = this._getEmployeeProfileFunctionId(
						assignment.employee
					);
					return (
						profileFunctionId !== null &&
						activeFunctionIds.includes(profileFunctionId)
					);
				}
			);
		}

		filteredAccountAssignments = alignAccountAssignmentsToPlan(
			filteredAccountAssignments,
			plan_assignments
		);

		const headerToolbar = (
				<div className="counter-header-toolbar">
				
					{plan_views && plan_views.length > 0 ? (
						<FormGroup
							className="form-group mb-0"
							controlId="plan_view_id"
							style={{ width: "auto", display: "flex", alignItems: "center" }}
						>
							<FormControl
								type="text"
								value={plan_view_id}
								onChange={this.handleChangeSearch}
								as="select"
								style={{ width: "auto", maxWidth: "150px" }}
							>
								{optionViewList}
							</FormControl>
							<OverlayTrigger
								placement="auto"
								overlay={
									<Tooltip id="help-plan-tooltip" className="plan-help-tooltip">
										<div>
											<div className="mb-2">
												<strong>
													{this.props.t("plan.tooltip.targetHoursTitle")}
												</strong>
												<span>
													{this.props.t("plan.tooltip.targetHoursDesc")}
												</span>
											</div>
											<div className="mb-2">
												<strong>
													{this.props.t("plan.tooltip.workedHoursTitle")}
												</strong>
												<span>
													{this.props.t("plan.tooltip.workedHoursDesc")}
												</span>
											</div>
											<div className="mb-2">
												<strong>
													{this.props.t("plan.tooltip.clockedHoursTitle")}
												</strong>
												<span>
													{this.props.t("plan.tooltip.clockedHoursDesc")}
												</span>
											</div>
											<div className="mb-2">
												<strong>
													{this.props.t("plan.tooltip.balanceTitle")}
												</strong>
												<span>{this.props.t("plan.tooltip.balanceDesc")}</span>
											</div>
											<div className="mb-0">
												<strong>
													{this.props.t("plan.tooltip.plannedHoursTitle")}
												</strong>
												<span>
													{this.props.t("plan.tooltip.plannedHoursDesc")}
												</span>
											</div>
										</div>
									</Tooltip>
								}
							>
								<span className="d-inline-flex ml-1">
									<HiOutlineInformationCircle
										size={18}
										className="counter-info-icon"
									/>
								</span>
							</OverlayTrigger>
						</FormGroup>
					) : (
						<div></div>
					)}
					<Dropdown style={{ display: "flex", alignItems: "center" }}>
						<Dropdown.Toggle
							variant="action"
							style={{
								border: "none",
								background: "transparent",
								padding: 0,
								marginRight: "10px",
								boxShadow: "none",
							}}
						>
							<HiOutlineEllipsisHorizontal size={20} />
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item
								as="button"
								onClick={() => this.props.history.push("/plan-views")}
							>
								<FiSettings /> {this.props.t("planViews.configureViews")}
							</Dropdown.Item>
							<Dropdown.Item as="button" onClick={this.openNewPlanviewModal}>
								<HiOutlinePlus /> {this.props.t("planViews.newView")}
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</div>
		);

		return (
			<div className="relative">
				{this.renderLoadingOverlay(accounts_loading)}
				<PlanCounters
					start={start}
					end={end}
					account_assignments={filteredAccountAssignments}
					plan_grid_view={plan_grid_view}
					multigroupSections={this._getMultigroupGrouping()?.sections}
					uniqueTotals={this._getMultigroupGrouping()?.uniqueTotals}
					headerToolbar={headerToolbar}
				/>
			</div>
		);
	};

	openGroupSettingsDrawer = (tab = "info", { openCreateNeed = false } = {}) => {
		this.setState({
			groupDrawerOpen: true,
			groupDrawerTab: tab,
			groupDrawerOpenCreateNeed: Boolean(openCreateNeed),
		});
	};

	closeGroupSettingsDrawer = (hasDataChanges = false, updatedGroup) => {
		const nextState = {
			groupDrawerOpen: false,
			groupDrawerOpenCreateNeed: false,
		};
		if (updatedGroup && updatedGroup.id) {
			nextState.group = { ...this.state.group, ...updatedGroup };
		}
		this.setState(nextState, () => {
			this.props.getGroupStaffingLevels(this.state.group_id);
			if (hasDataChanges) {
				this.getStaffingLevelAssignments();
			}
		});
	};

	hasGroupStaffingNeeds = () => {
		const groupNeeds = this._normalizeStaffingAssignmentsPayload(
			this.props.group_staffing_levels
		);
		return groupNeeds.length > 0;
	};

	// necesidades de personal
	getBloqueStaffingLevel = () => {
		const { plan_days, needs_selection } = this.props;
		const {
			needs_suggestions,
			search_staffing_shift,
			name,
			plan_grid_view,
			staffing_loading,
			ubication_staffing_id,
			function_staffing_id,
			staffing_level_assignments,
			staffing_level_current_assignments,
			plan_assignments,
			isLongPeriod,
		} = this.state;
		const { filteredFunctions, filteredUbications } =
			this.filterSelectOptions();

		const optionFunctionList =
			filteredFunctions.length > 0 &&
			filteredFunctions.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		const optionUbicationList =
			filteredUbications.length > 0 &&
			filteredUbications.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		// Todo con etiquetas mostrar icono etiqueta o icono necesidad al lado
		const renderSuggestion = (suggestion) => (
			<>
				<span className="suggestion-main">{suggestion.name}</span>
				{/* <span className="suggestion-info">{suggestion. email}</span> */}
			</>
		);

		return (
			<div className="relative staffing-container">
				{this.renderLoadingOverlay(staffing_loading)}
				<div className="heading gray">
					<div className="heading-left">
						{filteredUbications.length > 0 && (
							<FormGroup
								className="form-group"
								controlId="ubication_staffing_id"
							>
								<FormControl
									type="text"
									value={ubication_staffing_id}
									onChange={this.handleChangeSearch}
									as="select"
								>
									<option value="-1">
										{this.props.t("plan.allUbications")}
									</option>
									{optionUbicationList}
								</FormControl>
							</FormGroup>
						)}
						{filteredFunctions.length > 0 && (
							<FormGroup
								className="form-group"
								controlId="function_staffing_id"
							>
								<FormControl
									type="text"
									value={function_staffing_id}
									onChange={this.handleChangeSearch}
									as="select"
								>
									<option value="-1">
										{this.props.t("plan.allFunctions")}
									</option>
									{optionFunctionList}
								</FormControl>
							</FormGroup>
						)}

						<div className="form-search-staffing">
							<FormControl
								id="search_staffing_shift"
								type="text"
								placeholder={this.props.t("plan.filterByShift")}
								value={search_staffing_shift}
								onChange={this.handleChangeSearch}
							/>
							{search_staffing_shift && (
								<button
									className="btn-autosuggest-clear btn-transparent"
									onClick={this.onClearStaffingShiftSearch}
									type="button"
								>
									<FiX />
								</button>
							)}
						</div>

						<div className="react-autosuggest">
							<Autosuggest
								suggestions={needs_suggestions}
								onSuggestionsFetchRequested={
									this.onNeedsSuggestionsFetchRequested
								}
								onSuggestionsClearRequested={
									this.onNeedsSuggestionsClearRequested
								}
								onSuggestionSelected={this.onNeedsSuggestionSelected}
								getSuggestionValue={(suggestion) => suggestion.name}
								renderSuggestion={renderSuggestion}
								alwaysRenderSuggestions={true}
								inputProps={{
									placeholder: this.props.t("plan.filterByNeed"),
									value: name,
									onChange: this.onChangeNeedsAutosugest,
									className: "form-control",
								}}
							/>
							{name && (
								<button
									className="btn-autosuggest-clear btn-transparent"
									onClick={this.onClearNeedsAutosugest}
									type="button"
								>
									<FiX />
								</button>
							)}
						</div>
					</div>
					{this.state.hasPrivileges && (
						<div className="heading-right">
							<button
								type="button"
								className="btn btn-outline-primary plan-staffing-edit-btn"
								onClick={() =>
									this.openGroupSettingsDrawer("necesidades", {
										openCreateNeed: !this.hasGroupStaffingNeeds(),
									})
								}
							>
								<FiEdit2 />{" "}
								{this.hasGroupStaffingNeeds()
									? this.props.t("common.edit")
									: this.props.t("plan.createStaffingNeed")}
							</button>
						</div>
					)}
				</div>
			{/* Necesidades de turno (con shift largo) y fraccionadas.
			 * Una fila con time_interval y sin turno es siempre fraccionada.
			 * La vista por horas llega ya partida en /assignments/fractioned. */}
			{(() => {
				const assignments = staffing_level_assignments || [];
				const currentAssignments =
					staffing_level_current_assignments || [];

				const shiftAssignments = assignments.filter(
					(a) => !isFractionalStaffingAssignment(a)
				);
				const fractionalAssignments = assignments.filter((a) =>
					isFractionalStaffingAssignment(a)
				);
				const shiftCurrentAssignments = currentAssignments.filter(
					(a) => !isFractionalStaffingAssignment(a)
				);
				const fractionalCurrentAssignments = currentAssignments.filter(
					(a) => isFractionalStaffingAssignment(a)
				);

				const hasAny =
					assignments.length > 0 || currentAssignments.length > 0;

				if (!hasAny) {
					return (
						<div className="plan-error">
							<FiUsers className="icono-plan" />
							<p>Sin resultados de necesidades</p>
						</div>
					);
				}

				const hasFractional =
					fractionalAssignments.length > 0 ||
					fractionalCurrentAssignments.length > 0;

				return (
					<>
						{/* Tabla de necesidades de turno (duración > 60 min) */}
						<PlanStaffingLevels
							plan_days={plan_days}
							staffing_level_assignments={shiftAssignments}
							staffing_level_current_assignments={shiftCurrentAssignments}
							handleStaffingMenuClick={this.handleStaffingMenuClick}
							needs_selection={needs_selection}
							handleNeedSelection={this.handleNeedSelection}
							plan_grid_view={plan_grid_view}
							openNewStaffingLevelModal={this.openNewStaffingLevelModal}
							handleEditStaffingLevel={this.handleEditStaffingLevel}
							handleBringEmployeesTemporarily={this.openTemporaryEmployeesModal}
						/>

						{/* Tabla de necesidades fraccionadas (cobertura current/needed).
						 *  Limitada a periodos ≤ 7 días; si no, se muestra el cartel. */}
						{hasFractional &&
							(isLongPeriod ? (
								<FractionalNeedsLimitCard
									onSelectFirstWeek={this.selectFirstWeekOfMonth}
								/>
							) : (
								<PlanStaffingLevelsFractional
									plan_days={plan_days}
									plan_grid_view={plan_grid_view}
									plan_assignments={plan_assignments}
									staffing_level_assignments={fractionalAssignments}
									staffing_level_current_assignments={
										fractionalCurrentAssignments
									}
									openNewStaffingLevelModal={this.openNewStaffingLevelModal}
									handleNeedSelection={this.handleNeedSelection}
									handleEditStaffingLevel={this.handleEditStaffingLevel}
									handleBringEmployeesTemporarily={
										this.openTemporaryEmployeesModal
									}
									getAssignmentRowIndex={(assignment) =>
										assignments.indexOf(assignment)
									}
								/>
							))}
					</>
				);
			})()}
			</div>
		);
	};

	// tabla contador de horas trabajadas por día
	getBloqueHourlyCounter = () => {
		// TODO revisar porque no va bien el loading
		const {
			plan_assignments,
			working_hours_list,
			staffing_hourly_loading,
			plan_loading,
			first_hour,
			last_hour,
		} = this.state;
		const { plan_days, staffing_level_hourly_assignments } = this.props;

		return (
			<>
				{/* <div className="relative">
					{this.renderLoadingOverlay(plan_loading)}
					<PlanHourlyCounter
						plan_assignments={plan_assignments}
						plan_days={plan_days}
						working_hours_list={working_hours_list}
					/>
				</div> */}

				{staffing_level_hourly_assignments.length > 0 ? (
					<PlanStaffingHourlyImproved
						plan_assignments={plan_assignments}
						plan_days={plan_days}
						staffing_level_hourly_assignments={
							staffing_level_hourly_assignments
						}
						working_hours_list={working_hours_list}
						first_hour={first_hour}
						last_hour={last_hour}
					/>
				) : (
					<PlanStaffingHourlyPlanned
						plan_assignments={plan_assignments}
						plan_days={plan_days}
						working_hours_list={working_hours_list}
						first_hour={first_hour}
						last_hour={last_hour}
					/>
				)}
			</>
		);
	};

	// EXPORT valores de cuentas
	openExportValoresCuentasModal(token) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.exportAccounts"),
				style: { width: "400px" },
				confirmText: "Descargar",
				loadingText: "Descargando...",
				message: this.props.t("plan.modal.exportAccountsMsg"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, "valores_cuentas.xlsx");
				},
			},
			"confirm"
		);
	}

	async handleExportValoresCuentas() {
		const { group_id, start, end, plan_view_id } = this.state;
		const token = await accountsService.exportList({
			group_id,
			start,
			end,
			plan_view_id,
			...this._getFunctionFilterForApi(),
		});

		if (token.ok) {
			this.openExportValoresCuentasModal(token.access_token);
		} else {
			this.openAlertModal(
				this.props.t("plan.error.exportError"),
				this.props.t("plan.error.exportTitle")
			);
		}
	}

	// EXPORT planificación
	openExportPlanificacionModal(token, filename = "planificacion.xlsx") {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.exportPlan"),
				style: { width: "400px" },
				confirmText: "Descargar",
				loadingText: "Descargando...",
				message: this.props.t("plan.modal.exportPlanMsg"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, filename);
				},
			},
			"confirm"
		);
	}

	async handleExportPlanificacion(special) {
		if (!this._isPlanLoadComplete()) {
			return;
		}

		const { group_id, start, end } = this.state;

		const token = await plansService.exportPlan({
			group_id,
			start,
			end,
			special,
		});

		if (token.ok) {
			let filename = "planificacion.xlsx";
			if (special === "shifts") {
				filename = "exportacion_turnos.xlsx";
			} else if (special === "weekly") {
				filename = "planificacion_semanas.xlsx";
			} else if (special === "detailed") {
				filename = "planificacion_detallada.xlsx";
			}
			this.openExportPlanificacionModal(token.access_token, filename);
		} else {
			this.openAlertModal(
				this.props.t("plan.error.exportError"),
				this.props.t("plan.error.exportTitle")
			);
		}
	}

	// async handleExportNeedsPDF() {
	// 	// const tablePlan = document.getElementById('planContainer');
	// 	const tablePlan = document.getElementById("tableNeeds");

	// 	html2canvas(tablePlan).then(function (canvas) {
	// 		// document.body.appendChild(canvas);
	// 		const imgData = canvas.toDataURL("image/png");
	// 		// window.open(imgData, '_blank');
	// 		const pdf = new jsPDF({
	// 			orientation: "l", // landscape
	// 			unit: "pt", // points, pixels won't work properly
	// 			format: [canvas.width, canvas.height], // set needed dimensions for any element
	// 		});
	// 		pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
	// 		pdf.save("needs.pdf");
	// 	});
	// }

	async handleExportNeedsPDF() {
		const elId = "tableNeeds";
		const tablePlan = document.getElementById(elId);

		const canvas = await html2canvas(tablePlan, {
			scale: 2, // más nitidez
			useCORS: true,
			backgroundColor: null,
			windowWidth: tablePlan.scrollWidth,
			windowHeight: tablePlan.scrollHeight,
			onclone: (doc) => {
				const root = doc.getElementById(elId);
				if (root) {
					root.style.overflow = "visible";
					root.style.maxWidth = "none";
					root.style.maxHeight = "none";
				}

				// ocultar checkbox en el clon
				const style = doc.createElement("style");
				style.textContent = `
					#${elId} input[type="checkbox"]{
					visibility: hidden !important;
					pointer-events: none !important;
					appearance: none !important;
					background: none !important;
					background-image: none !important;
					box-shadow: none !important;
					border: 0 !important;
					}
				`;
				doc.head.appendChild(style);

				// pinta fondos
				const sels = ["td", "th"];
				const targets = root.querySelectorAll(sels.join(","));
				targets.forEach((el) => {
					const cs = window.getComputedStyle(el);
					const bg = cs.backgroundColor;
					// si hay color de fondo, aplícalo inline
					if (bg && bg !== "transparent" && bg !== "rgba(0, 0, 0, 0)") {
						el.style.backgroundColor = bg;
					}
					// quitar sombras
					el.style.boxShadow = "none";
				});
			},
		});

		const imgData = canvas.toDataURL("image/png");

		// px -> pt (jsPDF usa puntos)
		const pxToPt = (px) => (px * 72) / 96;
		const pdfW = pxToPt(canvas.width);
		const pdfH = pxToPt(canvas.height);

		const pdf = new jsPDF({
			orientation: "l",
			unit: "pt",
			format: [pdfW, pdfH],
		});

		pdf.addImage(imgData, "PNG", 0, 0, pdfW, pdfH);
		pdf.save("needs.pdf");
	}

	// EXPORT turnos
	openExportShiftsModal(token) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.exportShifts"),
				style: { width: "400px" },
				confirmText: "Descargar",
				loadingText: "Descargando...",
				message: this.props.t("plan.modal.exportShiftsMsg"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, "turnos_planificados.xlsx");
				},
			},
			"confirm"
		);
	}

	async handleExportShifts() {
		const { group_id, start, end } = this.state;
		const token = await plansService.exportShifts({
			group_id,
			start,
			end,
		});

		if (token.ok) {
			this.openExportShiftsModal(token.access_token);
		} else {
			this.openAlertModal(
				this.props.t("plan.error.exportError"),
				this.props.t("plan.error.exportTitle")
			);
		}
	}

	async downloadExport(token, filename) {
		const response = await appService.getExported(token);

		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = filename;
		a.click();

		this.props.updateModalLoading(false); // Cambiar a no cargando
		this.closeModal(); // cerrar modal de confirmación
	}

	// Confirmar asignar funciones a planificación
	handleSetFunciones() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.assignFunctions"),
				style: { width: "450px" },
				confirmText: this.props.t("plan.modal.assignFunctionsBtn"),
				loadingText: this.props.t("plan.modal.assigning"),
				message: this.props.t("plan.modal.assignFunctionsMsg"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true); // Cambiar a cargando
					this.confirmSetFunciones();
				},
			},
			"confirm"
		);
	}

	async confirmSetFunciones() {
		const { group_id, start, end, plan_assignments } = this.state;
		const assignmentSnapshots = collectAssignmentFieldSnapshots(plan_assignments);
		let response;

		try {
			response = await plansService.setFunctions({
				group_id,
				start,
				end,
			});

			if (response.ok) {
				// Refresca todo el periodo antes de cerrar para que los modales de turno
				// reciban las funciones recién asignadas desde el estado local.
				await this.getAllAssignments([]);
			}
		} catch (error) {
			this.props.updateModalLoading(false);
			this.closeModal();
			this.openAlertModal(
				error?.message || this.props.t("common.errorUnknown"),
				this.props.t("plan.error.assignFunctionsTitle")
			);
			return;
		}

		this.props.updateModalLoading(false);
		this.closeModal();

		if (response.ok) {
			const functionsInverse = buildPlanSetFunctionsInverse(assignmentSnapshots);

			this._notifyPlanMutation({
				type: "BULK_UPDATE",
				messageKey: "undo.plan.functionsAssigned",
				inverse: functionsInverse || undefined,
				employeeIds: [
					...new Set(
						assignmentSnapshots
							.map((snapshot) => snapshot.employeeId)
							.filter(Boolean)
					),
				],
			});
		} else {
			// show error
			let textError = response.errors[0].description;

			this.openAlertModal(
				textError,
				this.props.t("plan.error.assignFunctionsTitle")
			);
		}
	}

	// Confirmar asignar ubicaciones a planificación
	handleSetUbications() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.assignUbications"),
				style: { width: "450px" },
				confirmText: this.props.t("plan.modal.assignUbicationsBtn"),
				loadingText: this.props.t("plan.modal.assigning"),
				message: this.props.t("plan.modal.assignUbicationsMsg"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.confirmSetUbications();
				},
			},
			"confirm"
		);
	}

	async confirmSetUbications() {
		const { group_id, start, end, plan_assignments } = this.state;
		const assignmentSnapshots = collectAssignmentFieldSnapshots(plan_assignments);
		let response;

		try {
			response = await plansService.setUbications({
				group_id,
				start,
				end,
			});

			if (response.ok) {
				// Refresca todo el periodo antes de cerrar para que los modales de turno
				// reciban las ubicaciones recién asignadas desde el estado local.
				await this.getAllAssignments([]);
			}
		} catch (error) {
			this.props.updateModalLoading(false);
			this.closeModal();
			this.openAlertModal(
				error?.message || this.props.t("common.errorUnknown"),
				this.props.t("plan.error.assignUbicationsTitle")
			);
			return;
		}

		this.props.updateModalLoading(false);
		this.closeModal();

		if (response.ok) {
			const ubicationsInverse = buildPlanSetUbicationsInverse(assignmentSnapshots);

			this._notifyPlanMutation({
				type: "BULK_UPDATE",
				messageKey: "undo.plan.ubicationsAssigned",
				inverse: ubicationsInverse || undefined,
				employeeIds: [
					...new Set(
						assignmentSnapshots
							.map((snapshot) => snapshot.employeeId)
							.filter(Boolean)
					),
				],
			});
		} else {
			const textError = response.errors[0].description;

			this.openAlertModal(
				textError,
				this.props.t("plan.error.assignUbicationsTitle")
			);
		}
	}

	// Confirmar eliminar necesidades de personal del forecast
	handleDeleteStaffingOverwrites() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.deleteStaffingNeeds"),
				style: { width: "450px" },
				confirmText: "Eliminar",
				loadingText: this.props.t("plan.deleting"),
				message: this.props.t("plan.modal.deleteStaffingNeedsMsg"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true); // Cambiar a cargando
					this.confirmDeleteStaffingOverwrites();
				},
			},
			"confirm"
		);
	}

	async confirmDeleteStaffingOverwrites() {
		const { group_id, start, end } = this.state;

		try {
			const response = await staffingLevelsService.deleteOverwrites({
				group_id,
				start,
				end,
			});

			// Después de recibir la respuesta:
			this.props.updateModalLoading(false); // Cambiar a no cargando
			this.closeModal(); // cerrar modal de confirmación

			if (response.ok) {
				toastr.success("¡Bien!", this.props.t("plan.staffingNeedsDeletedOk"));
				// Recargar los datos del plan
				await this.reloadPlan({});
			} else {
				// show error
				let textError =
					response.errors && response.errors[0]
						? response.errors[0].description
						: this.props.t("common.errorUnknown");
				this.openAlertModal(
					textError,
					this.props.t("plan.error.deleteStaffingNeedsTitle")
				);
			}
		} catch (error) {
			this.props.updateModalLoading(false);
			this.closeModal();
			this.openAlertModal(
				this.props.t("plan.error.deleteStaffingNeedsTitle"),
				this.props.t("common.error")
			);
		}
	}

	// unlock todos los turnos
	openUnlockModal(props) {
		const { presence_shifts_only } = props;
		const type = presence_shifts_only
			? this.props.t("plan.unlockModalWorkType")
			: "";

		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.unlockModalTitle"),
				message: this.props.t("plan.unlockModalMessage", { type }),
				confirmAction: () => this.unlockPlan(presence_shifts_only),
				closeModal: this.closeModal,
				style: { width: "420px" },
			},
			"confirm"
		);
	}
	// lock unlock seleccionados
	openLockSelectedModal(lock) {
		if (this.state.day_selection.length <= 1) {
			this.lockSelected(lock);
			return;
		}

		this.props.showModal(
			{
				open: true,
				title: lock
					? this.props.t("plan.lockModalTitle")
					: this.props.t("plan.unlockSelectedModalTitle"),
				message: lock
					? this.props.t("plan.lockModalMessage")
					: this.props.t("plan.unlockSelectedModalMessage"),
				confirmAction: () => this.lockSelected(lock),
				closeModal: this.closeModal,
				style: { width: "420px" },
			},
			"confirm"
		);
	}

	_isPresenceShiftType = (type) => {
		const normalized = normalizeShiftType(type);
		return normalized === shiftType.work || normalized === shiftType.automatic;
	};

	setUnlockPlanList = (presence_shifts_only) => {
		const { plan_assignments } = this.state;
		var hasChanged = false;

		var updated_plan_assignments = plan_assignments;
		if (plan_assignments && plan_assignments.length > 0) {
			updated_plan_assignments = plan_assignments.map((plan_assignment) => {
				var rowHasChanged = false;
				if (plan_assignment.plans && plan_assignment.plans.length > 0) {
					plan_assignment.plans.forEach((plan) => {
						if (plan.assignments && plan.assignments.length > 0) {
							plan.assignments.forEach((assignment) => {
								if (assignment.locked) {
									if (
										(presence_shifts_only &&
											this._isPresenceShiftType(assignment.shift?.type)) ||
										!presence_shifts_only
									) {
										assignment.locked = false;
										hasChanged = true;
										rowHasChanged = true;
									}
								}
							});
						}
					});
				}

				return rowHasChanged ? { ...plan_assignment } : plan_assignment;
			});
		}

		if (hasChanged) {
			this.setState({ plan_assignments: updated_plan_assignments });
		}
	};

	async unlockPlan(presence_shifts_only) {
		const { group_id, start, end } = this.state;
		const response = await plansService.unlock({
			group_id,
			start,
			end,
			presence_shifts_only,
		});

		this.closeModal();

		if (response.ok) {
			this.setUnlockPlanList(presence_shifts_only);
		} else {
			this.openAlertModal(
				this.props.t("plan.error.unlockError"),
				this.props.t("plan.error.unlockTitle")
			);
		}
	}

	// bloqueo múltiple
	lockSelected = async (locked) => {
		const { plan_assignments, day_selection } = this.state;

		if (day_selection.length === 0) {
			return; // No hay días seleccionados
		}

		const plans_to_update = [];

		// Iterar sobre la selección de días y modificar las asignaciones correspondientes
		day_selection.forEach(({ row, index }) => {
			const assignments = plan_assignments[row].plans[index].assignments;
			assignments.forEach((assignment) => {
				if (assignment.id > 0 && assignment.locked !== locked) {
					assignment.locked = locked;
					plans_to_update.push({
						id: assignment.id,
						locked: locked,
					});
				}
			});
		});

		if (plans_to_update.length === 0) {
			this.closeModal();
			this.unselectAllDays();
			return;
		}

		// Llamada al servicio para actualizar las asignaciones en el backend
		const response = await plansService.updateMultiplePart(plans_to_update);

		this.closeModal();

		if (response.ok) {
			this.setState({ plan_assignments }, () => {
				this.unselectAllDays();
			});
		} else {
			this.openAlertModal(
				this.props.t("plan.error.updateLocksError"),
				this.props.t("common.error")
			);
		}
	};

	// open new planification
	openPlanOpener() {
		const { group_id, start, end, isLongPeriod } = this.state;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.newPlan"),
				style: { width: "460px" },
				content: (
					<PlanOpenerModal
						group_id={group_id}
						updateStateAndReload={this.updateStateAndReload}
						start={start}
						end={end}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	hasAvailabilityShift() {
		const plan_assignments = this.state.plan_assignments || [];

		for (const assignment of plan_assignments) {
			for (const plan of assignment.plans || []) {
				const allAssignments = [
					...(plan.assignments || []),
					...(plan.plan_assignments_with_overnight || []),
				];

				for (const shiftAssignment of allAssignments) {
					const type = normalizeShiftType(
						shiftAssignment?.shift?.type || shiftAssignment?.type
					);
					if (type === shiftType.automatic) {
						return true;
					}

					const intervals = getPlanAssignmentIntervals(shiftAssignment);
					if (intervals.some(isMagicAvailabilityInterval)) {
						return true;
					}
				}
			}
		}

		return false;
	}

	hasEmployeesWithoutFunction() {
		return this.getPlanEmployeesWithoutFunction().length > 0;
	}

	getPlanEmployeesWithoutFunction() {
		const assignments = this.state.plan_assignments || [];
		const selectedIds = (this.state.selected_employee_ids || [])
			.map((id) => parseInt(id, 10))
			.filter((id) => !Number.isNaN(id));
		const visibleAssignments =
			selectedIds.length > 0
				? assignments.filter((item) =>
						selectedIds.includes(parseInt(item?.employee?.id, 10))
					)
				: assignments;
		const source =
			visibleAssignments.length > 0 ? visibleAssignments : assignments;

		const seen = new Set();
		const employees = [];
		source.forEach((item) => {
			const employee = item?.employee;
			if (!employee?.id || seen.has(employee.id)) return;
			if (employee.employee_with_function?.function?.id) return;
			seen.add(employee.id);
			employees.push(employee);
		});
		return employees;
	}

	getFirstPlanEmployeeWithoutFunction() {
		return this.getPlanEmployeesWithoutFunction()[0] || null;
	}

	getMagicPlanMissingRequirements() {
		const missing = [];
		if (this.hasEmployeesWithoutFunction()) missing.push("functions");
		if (!this.hasAvailabilityShift()) missing.push("availability");
		if (!this.hasStaffingNeedsForMagicPlan()) missing.push("staffing");
		return missing;
	}

	hasStaffingNeedsForMagicPlan() {
		if (this.hasGroupStaffingNeeds()) return true;
		const periodNeeds = this._normalizeStaffingAssignmentsPayload(
			this.state.staffing_level_assignments
		);
		return periodNeeds.length > 0;
	}

	getMagicPlanUnresolvedFunctionIds() {
		return this.getPlanEmployeesWithoutFunction().map((employee) => employee.id);
	}

	closeMagicPrerequisites = () => {
		this.setState({
			magicPrerequisitesMissing: [],
			magicPlanFlowActive: false,
			magicPlanFunctionsSnapshot: [],
			magicPlanUnresolvedFunctionIds: [],
			magicEmployeeDrawer: null,
		});
	};

	advanceToMagicPlan = () => {
		if (this._advancingToMagicPlan) return;
		this._advancingToMagicPlan = true;
		this.setState(
			{
				magicPrerequisitesMissing: [],
				magicPlanFlowActive: false,
				magicPlanFunctionsSnapshot: [],
				magicPlanUnresolvedFunctionIds: [],
				magicEmployeeDrawer: null,
				groupDrawerOpen: false,
				groupDrawerOpenCreateNeed: false,
			},
			() => {
				this.props.hideModal();
				this.openMagicModalWithGraphics();
				this._advancingToMagicPlan = false;
			}
		);
	};

	syncMagicPlanPrerequisites = () => {
		if (!this.state.magicPlanFlowActive) return;

		const missing = this.getMagicPlanMissingRequirements();
		if (missing.length === 0) {
			this.advanceToMagicPlan();
			return;
		}

		const unresolvedIds = this.getMagicPlanUnresolvedFunctionIds();
		const unresolvedKey = unresolvedIds.join(",");
		const missingKey = missing.join(",");
		if (
			missingKey === (this.state.magicPrerequisitesMissing || []).join(",") &&
			unresolvedKey ===
				(this.state.magicPlanUnresolvedFunctionIds || []).join(",")
		) {
			return;
		}

		const snapshot = missing.includes("functions")
			? this.state.magicPlanFunctionsSnapshot.length > 0
				? this.state.magicPlanFunctionsSnapshot
				: this.getPlanEmployeesWithoutFunction()
			: [];

		this.setState({
			magicPrerequisitesMissing: missing,
			magicPlanUnresolvedFunctionIds: unresolvedIds,
			magicPlanFunctionsSnapshot: snapshot,
		});
	};

	openMagicPlanFunctionsFix = (employee) => {
		const target = employee || this.getFirstPlanEmployeeWithoutFunction();
		if (!target?.id) {
			this.openGroupSettingsDrawer("empleados");
			return;
		}
		if (typeof this.props.getSelectableFunctions === "function") {
			this.props.getSelectableFunctions();
		}
		this.props.showModal(
			{
				open: true,
				title: this.props.t("functions.assignment.assignFunction"),
				style: { width: "350px" },
				content: (
					<EmployeeFunctionEdit
						handleClose={this.closeModal}
						employee={target}
						showEmployeeName
						onDataChanged={this.handleMagicEmployeeDataChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	};

	handleMagicEmployeeDataChanged = () => {
		clearTimeout(this._magicEmployeeRefreshTimer);
		this._magicEmployeeRefreshTimer = setTimeout(async () => {
			await this.getAllAssignments();
			this.syncMagicPlanPrerequisites();
		}, 300);
	};

	openMagicPlanAvailabilityFix = () => {
		const automaticType =
			(this.props.shift_types || []).find(
				(item) => normalizeShiftType(item.name) === shiftType.automatic
			)?.name || shiftType.automatic;

		this.setState(
			{
				magicPrerequisitesMissing: [],
				magicPlanFlowActive: false,
				magicPlanFunctionsSnapshot: [],
				magicPlanUnresolvedFunctionIds: [],
				planViewMode: "grid",
				showMax: false,
				search_shift_type_id: automaticType,
				highlightAvailabilityPalette: true,
			},
			() => {
				this.getShifts();
				requestAnimationFrame(() => {
					document
						.querySelector(".pattern-filter")
						?.scrollIntoView({ behavior: "smooth", block: "nearest" });
				});
				toastr.info(
					this.props.t("magicPlan.prerequisites.availabilityTitle"),
					this.props.t("magicPlan.prerequisites.availabilityHint")
				);
				clearTimeout(this._availabilityHighlightTimer);
				this._availabilityHighlightTimer = setTimeout(() => {
					this.setState({ highlightAvailabilityPalette: false });
				}, 5000);
			}
		);
	};

	openMagicPlanStaffingFix = () => {
		const { group, group_id, start, end } = this.state;
		if (typeof this.props.getSelectableStaffingLevels === "function") {
			this.props.getSelectableStaffingLevels();
		}
		this.props.showModal(
			{
				open: true,
				title: this.props.t("groups.staffing.newAssignment"),
				style: { width: "400px" },
				content: (
					<GroupStaffingLevelsEdit
						handleClose={this.closeModal}
						triggerStaffingLevelAssignments={
							this.getStaffingLevelAssignments
						}
						start_day={start}
						end_day={end}
						group_id={group_id}
						groupName={group?.name}
						onDataChanged={this.handleMagicStaffingDataChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	};

	handleMagicStaffingDataChanged = () => {
		clearTimeout(this._magicStaffingRefreshTimer);
		this._magicStaffingRefreshTimer = setTimeout(async () => {
			if (typeof this.props.getGroupStaffingLevels === "function") {
				await this.props.getGroupStaffingLevels(this.state.group_id);
			}
			this.syncMagicPlanPrerequisites();
		}, 300);
	};

	// Automagic planification
	openNewMagicPlan() {
		const missing = this.getMagicPlanMissingRequirements();
		if (missing.length > 0) {
			const functionEmployees = missing.includes("functions")
				? this.getPlanEmployeesWithoutFunction()
				: [];
			this.setState({
				magicPrerequisitesMissing: missing,
				magicPlanFlowActive: true,
				magicPlanFunctionsSnapshot: functionEmployees,
				magicPlanUnresolvedFunctionIds: functionEmployees.map(
					(employee) => employee.id
				),
			});
			return;
		}
		this.openMagicModalWithGraphics();
	}

	// open copy planification
	openPlanCopy() {
		if (!this._isPlanLoadComplete()) {
			return;
		}

		const { group, start, end } = this.state;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.copyPlan"),
				style: { width: "480px" },
				content: (
					<PlanCopyModal
						group={group}
						employees={this.props.select_employees}
						functions={this.state.plan_option_functions}
						updateStateAndReload={this.updateStateAndReload}
						start={start}
						end={end}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// open exportar a PDF
	openPlanExport2PDF() {
		if (!this._isPlanLoadComplete()) {
			return;
		}

		this.props.showModal(
			{
				open: true,
				title: this.props.t("plan.modal.exportPDF"),
				style: { width: "460px" },
				content: (
					<PlanExport2PDFModal
						handleClose={this.closeModal}
						planGridView={this.state.plan_grid_view}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// EMPLOYEE MULTI-SELECT FILTER

	handleEmployeesFilterChange = (ids) => {
		const normalized = Array.isArray(ids)
			? ids.map((id) => String(id)).filter((id) => id && id !== "-1")
			: [];
		this.setState({ selected_employee_ids: normalized }, async () => {
			this.getAllAssignments();
		});
	};

	handleFunctionsFilterChange = (ids) => {
		const normalized = Array.isArray(ids)
			? ids.map((id) => String(id)).filter((id) => id && id !== "-1")
			: [];
		this.setState(
			{
				selected_function_ids: normalized,
				function_staffing_id: -1,
			},
			() => {
				this.getAllAssignments();
			}
		);
	};

	// STAFFING NEEDS AUTOCOMPLETE SUGGESTIONS

	// TODO añadir búsqueda por tags
	getNeedsSuggestions = (value) => {
		const inputValue = value.trim().toLowerCase();
		const inputLength = inputValue.length;
		const { staffing_level_assignments } = this.state;

		if (inputLength === 0) return [];

		const uniqueNames = [];
		return staffing_level_assignments.filter((o) => {
			const lowerCaseName = o.name.toLowerCase();
			if (
				lowerCaseName.includes(inputValue) &&
				!uniqueNames.includes(lowerCaseName)
			) {
				uniqueNames.push(lowerCaseName);
				return true;
			}
			return false;
		});
	};

	onChangeNeedsAutosugest = (event, { newValue, method }) => {
		this.setState(
			{
				name: newValue,
			},
			async () => {
				this.getFilteredStaffingLevelAssignments();
			}
		);
	};

	onClearNeedsAutosugest = () => {
		this.setState(
			{
				name: "",
			},
			async () => {
				this.getFilteredStaffingLevelAssignments();
			}
		);
	};
	// Autosuggest will call this function every time you need to update suggestions
	onNeedsSuggestionsFetchRequested = ({ value }) => {
		this.setState({
			needs_suggestions: this.getNeedsSuggestions(value),
		});
	};

	// Autosuggest will call this function every time you need to clear suggestions
	onNeedsSuggestionsClearRequested = () => {
		this.setState({
			needs_suggestions: [],
		});
	};

	onNeedsSuggestionSelected = (event, { suggestion }) => {
		this.setState(
			{
				name: suggestion.name,
			},
			() => {
				this.setState(
					{
						needs_suggestions: [],
					},
					() => {
						this.onNeedsSuggestionsClearRequested();
						this.getFilteredStaffingLevelAssignments();
					}
				);
			}
		);
	};

	// ************* HELPERS *********************
	// filtra ubicaciones y funciones existentes en la lista de plan

	_addFunctionToFilterMap = (uniqueFunctions, fn) => {
		if (
			fn?.id &&
			this._isActiveFilterId(fn.id) &&
			!uniqueFunctions.has(fn.id)
		) {
			uniqueFunctions.set(fn.id, fn);
		}
	};

	_addUbicationToFilterMap = (uniqueUbications, ub) => {
		if (
			ub?.id &&
			this._isActiveFilterId(ub.id) &&
			!uniqueUbications.has(ub.id)
		) {
			uniqueUbications.set(ub.id, ub);
		}
	};

	filterSelectPlanOptions = (initial_plan_assignments) => {
		const uniqueFunctions = new Map();
		const uniqueUbications = new Map();

		(initial_plan_assignments || []).forEach((pa) => {
			// Función/ubicación del perfil del empleado (lo que se muestra bajo el nombre)
			const employee = pa.employee;
			if (employee) {
				this._addFunctionToFilterMap(
					uniqueFunctions,
					employee.employee_with_function?.function
				);
				this._addUbicationToFilterMap(
					uniqueUbications,
					employee.employee_with_ubication?.ubication
				);
			}

			(pa.plans || []).forEach((plan) => {
				(plan.assignments || []).forEach((ass) => {
					this._addFunctionToFilterMap(uniqueFunctions, ass?.function);

					(ass?.ubications || []).forEach((ub) => {
						this._addUbicationToFilterMap(uniqueUbications, ub);
					});
				});
			});
		});

		// Convertir Map a array, luego ordenar por nombre ascendente
		const plan_option_functions = Array.from(uniqueFunctions.values()).sort(
			(a, b) => a.name.localeCompare(b.name)
		);

		const plan_option_ubications = Array.from(uniqueUbications.values()).sort(
			(a, b) => a.name.localeCompare(b.name)
		);

		return {
			plan_option_functions,
			plan_option_ubications,
		};
	};
	// filtra ubicaciones y funciones existentes en la lista de necesidades de personal

	filterSelectOptions = () => {
		const { staffing_level_assignments, staffing_level_current_assignments } =
			this.props;

		// Usar staffing_level_assignments si no está vacío, de lo contrario usar staffing_level_current_assignments
		const assignments =
			staffing_level_assignments.length > 0
				? staffing_level_assignments
				: staffing_level_current_assignments;

		const uniqueFunctions = new Map();
		const uniqueUbications = new Map();

		assignments.forEach((assignment) => {
			if (
				assignment.function &&
				this._isActiveFilterId(assignment.function.id) &&
				!uniqueFunctions.has(assignment.function.id)
			) {
				uniqueFunctions.set(assignment.function.id, assignment.function);
			}
			if (
				assignment.ubication &&
				this._isActiveFilterId(assignment.ubication.id) &&
				!uniqueUbications.has(assignment.ubication.id)
			) {
				uniqueUbications.set(assignment.ubication.id, assignment.ubication);
			}
		});

		// Convertir Map a array, luego ordenar por nombre ascendente
		const filteredFunctions = Array.from(uniqueFunctions.values()).sort(
			(a, b) => a.name.localeCompare(b.name)
		);

		const filteredUbications = Array.from(uniqueUbications.values()).sort(
			(a, b) => a.name.localeCompare(b.name)
		);

		return {
			filteredFunctions,
			filteredUbications,
		};
	};

	patchPlanShiftAfterEdit = (plan, patch) => {
		if (!plan?.employee?.id || !plan?.day || !plan?.shift_plan?.id || !patch) {
			return;
		}

		// La vista agrupada por ubicación recalcula filas desde cero; el patch
		// optimista puede pisar la respuesta del API si llega después.
		if (this.state.plan_grid_view === PLAN_GRID_VIEWS.ubication_grouped) {
			return;
		}

		const employeeId = plan.employee.id;
		const displayDay = plan.day;
		const shiftPlanId = plan.shift_plan.id;

		this.setState((prevState) => {
			const plan_assignments = (prevState.plan_assignments || []).map(
				(assignment) => {
					if (assignment.employee.id !== employeeId) {
						return assignment;
					}

					const plans = assignment.plans.map((dayPlan) => {
						if (dayPlan.day !== displayDay) {
							return dayPlan;
						}

						const assignments = dayPlan.assignments.map((item) => {
							if (item.id !== shiftPlanId) {
								return item;
							}

							return {
								...item,
								...patch,
								time_intervals_from_manual: true,
							};
						});

						return { ...dayPlan, assignments };
					});

					return { ...assignment, plans };
				}
			);

			return { plan_assignments };
		});
	};

	/**
	 * Actualiza time_intervals del assignment in-place (sin setState).
	 * Usado tras resize optimista: la geometría la mantiene el preview sticky.
	 */
	_patchAssignmentIntervalsInPlace = (
		employeeId,
		day,
		assignmentId,
		nextIntervals
	) => {
		const row = (this.state.plan_assignments || []).find(
			(assignment) => assignment.employee?.id === employeeId
		);
		if (!row) return;

		const dayPlan = (row.plans || []).find((plan) => plan.day === day);
		if (!dayPlan) return;

		const applyTo = (item) => {
			if (!item || item.id !== assignmentId) return;
			item.time_intervals = nextIntervals;
			item.time_intervals_from_manual = true;
			item.time_intervals_from_shift = false;
		};

		(dayPlan.assignments || []).forEach(applyTo);
		(dayPlan.plan_assignments_with_overnight || []).forEach(applyTo);
		(dayPlan.hours || []).forEach((hour) => {
			(hour.hour_assignments || []).forEach((ha) => {
				applyTo(ha.assignment);
			});
		});
	};

	updateEmployeeIdsAndGetAllAssignments = async (update_employee_ids) => {
		if (
			!update_employee_ids?.length ||
			this._usesFullPlanAssignmentsRefresh()
		) {
			await this.getAllAssignments();
			this.unselectAllDays();
			return { assignments: this.state.plan_assignments };
		}

		await new Promise((resolve) => {
			this.setState({ update_employee_ids }, resolve);
		});

		try {
			const planResult = await this.getPlanAssignments(update_employee_ids);

			const postLoadPromises = [
				this.getAccountAssignments(),
				this.getStaffingLevelAssignments(),
			];

			if (this.state.plan_grid_view === PLAN_GRID_VIEWS.hours) {
				postLoadPromises.push(this.getStaffingLevelHourlyAssignments());
			}

			await Promise.all(postLoadPromises);

			return planResult;
		} finally {
			this.unselectAllDays();
		}
	};

	updateURL = ({
		group_id = this.state.group_id,
		start = this.state.start,
		end = this.state.end,
	} = {}) => {
		const newURL = `/plans/${group_id}/${start}@${end}`;
		window.history.pushState(null, "", newURL);
	};

	updatePeriod = (direction) => {
		const { start, end } = this.state;
		const startDate = moment(start, "YYYY-MM-DD");
		const endDate = moment(end, "YYYY-MM-DD");

		const periodDays = endDate.diff(startDate, "days") + 1;
		let newStart, newEnd;

		// Verifica si el período es de "meses completos" (inicio al día 1 y final en último día del mes)
		const isWholeMonths =
			startDate.date() === 1 &&
			endDate.isSame(endDate.clone().endOf("month"), "day");

		if (periodDays === 1) {
			// Avanza o retrocede por un día
			newStart = startDate.clone().add(direction, "days");
			newEnd = endDate.clone().add(direction, "days");
		} else if (periodDays === 7) {
			// Avanza o retrocede por una semana
			newStart = startDate.clone().add(direction, "weeks");
			newEnd = endDate.clone().add(direction, "weeks");
		} else if (isWholeMonths) {
			// Avanza o retrocede en bloques de meses completos
			const periodMonths =
				endDate.month() -
				startDate.month() +
				1 +
				(endDate.year() - startDate.year()) * 12;
			newStart = startDate.clone().add(direction * periodMonths, "months");
			newEnd = newStart
				.clone()
				.add(periodMonths - 1, "months")
				.endOf("month");
		} else if (periodDays >= 28 && periodDays <= 31) {
			// Avanza o retrocede un mes ajustando al último día del mes
			newStart = startDate.clone().add(direction, "months");
			newEnd = newStart.clone().endOf("month");
		} else {
			// Avanza o retrocede por el número de días personalizado
			newStart = startDate.clone().add(periodDays * direction, "days");
			newEnd = endDate.clone().add(periodDays * direction, "days");
		}

		const formatedStart = newStart.format("YYYY-MM-DD");
		const formatedEnd = newEnd.format("YYYY-MM-DD");

		this.resetPlanHorizontalScroll();

		this.setState(
			{
				start: formatedStart,
				end: formatedEnd,
				current_month: formatedStart,
				isLongPeriod: this._getIsLongPeriod(formatedStart, formatedEnd),
				new_plan: true,
			},
			() => {
				this.updateURL({ start: formatedStart, end: formatedEnd });
				this.reloadPlan();
				this.loadGraphicsData();
			}
		);
	};

	// Reduce el rango a los primeros 7 días del mes en curso. Lo usa el cartel
	// de necesidades fraccionadas cuando el periodo supera los 7 días.
	selectFirstWeekOfMonth = () => {
		const base = moment(this.state.current_month || this.state.start);
		const start = base.clone().startOf("month");
		const end = start.clone().add(6, "days");

		this.updateStateAndReload({
			start: start.format("YYYY-MM-DD"),
			end: end.format("YYYY-MM-DD"),
		});
	};

	updateStateAndReload = async ({ group_id, start, end } = {}) => {
		// Crear el nuevo estado con los valores definidos
		const newState = {};

		if (group_id !== undefined) {
			// Verificar si el nuevo `group_id` es distinto al actual
			if (group_id !== this.state.group_id) {
				// Obtener el nuevo grupo si el `group_id` cambió
				const group = await groupsService.getByIdForPlanning(group_id);
				newState.group_id = group_id;
				newState.group = group; // Actualizar `group` en el state
				newState.collapsedGroupIds = {};
				newState.childGroupMemberships = {};
			}
		} else {
			newState.group_id = this.state.group_id;
		}

		if (start !== undefined) {
			newState.start = start;
			newState.current_month = start;
		}
		if (end !== undefined) {
			newState.end = end;
		}

		// Actualizar isLongPeriod cuando cambien las fechas
		if (start !== undefined || end !== undefined) {
			const newStart = start !== undefined ? start : this.state.start;
			const newEnd = end !== undefined ? end : this.state.end;
			newState.isLongPeriod = this._getIsLongPeriod(newStart, newEnd);

			const periodChanged =
				newStart !== this.state.start || newEnd !== this.state.end;
			if (periodChanged) {
				this.resetPlanHorizontalScroll();
			}
		}

		newState.new_plan = true;

		// Actualizar el estado y llamar a las funciones
		this.setState(newState, () => {
			// Llamar a updateURL y reloadPlan con los valores actualizados en el state
			this.updateURL({
				group_id: this.state.group_id,
				start: this.state.start,
				end: this.state.end,
			});
			this.reloadPlan({
				group_id: this.state.group_id,
				start: this.state.start,
				end: this.state.end,
			});
			this.loadGraphicsData();
		});
	};

	loadGraphicsData = async ({ force = false } = {}) => {
		if (this.state.planViewMode === "chart" || force) {
			// Calcular el número de días entre start y end
			const startDate = moment(this.state.start);
			const endDate = moment(this.state.end);
			const daysDiff = endDate.diff(startDate, "days") + 1; // +1 para incluir el día final
			const showChartLoading = this.state.planViewMode === "chart";

			if (showChartLoading) {
				this.setState({ graphicsLoading: true });
			}

			try {
				const data = await plansService.getAssignmentsGraphics(
					this.state.start,
					this.state.end,
					this.state.group_id,
					daysDiff
				);
				this.setState({
					assigmentsData: Array.isArray(data) ? data : [],
					graphicsLoading: false,
				});
			} catch (error) {
				this.setState({
					assigmentsData: [],
					graphicsLoading: false,
				});
				throw error;
			}
		}
	};

	openMagicModalWithGraphics = () => {
		trackIntercomEvent("ai_schedule_planning_popup_viewed", {
			group_id: this.state.group_id,
		});
		this.setState({ magicModalOpen: true });
	};

	handleTogglePlanViewMode = () => {
		const nextMode = this.state.planViewMode === "grid" ? "chart" : "grid";
		this.setState(
			{
				planViewMode: nextMode,
			},
			() => {
				if (nextMode === "chart") {
					this.unselectAllDays();
				}
				this.loadGraphicsData();
				if (nextMode === "grid") {
					// Al volver desde gráficos el DOM se monta de nuevo; sincronizar tras el layout.
					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							this.syncRowHeights();
						});
					});
				}
			}
		);
	};

	// ************* RENDER *********************

	render() {
		const { select_employees, plan_views } = this.props;
		const {
			start,
			end,
			day_selection,
			needs_selection,
			group,
			isExtendedView,
			selected_employee_ids,
			selected_function_ids,
			isLocked,
			isPlanKO,
			hasPrivileges,
			plan_grid_view,
			showMax,
			isSupervisorReadOnly,
			no_contract,
			isLongPeriod,
			plan_option_functions,
			plan_option_ubications,
		} = this.state;

		// var start_format = moment(start).format("D MMMM");
		const start_month = moment(start).format("MMM");
		const end_month = moment(end).format("MMM");

		var start_format = moment(start).format("D");
		const end_format = moment(end).format("D") + " " + end_month;

		const start_year = moment(start).format("YYYY");
		const end_year = moment(end).format("YYYY");

		// Si los meses son diferentes y los años son iguales, incluir el mes en start_format
		if (start_month !== end_month && start_year === end_year) {
			start_format = start_format + " " + start_month;
		}

		// Si los años son diferentes, incluir el mes y el año en start_format
		if (start_year !== end_year) {
			start_format = start_format + " " + start_month + " " + start_year;
		}

		const optionViewList =
			plan_views.length > 0 &&
			plan_views.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{translatePlanViewName(item)}
					</option>
				);
			}, this);

		const optionUbicationList =
			plan_option_ubications.length > 0 &&
			plan_option_ubications.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		const isNeedSelected = needs_selection.length > 0;
		const isPlanSelectionView = this.isPlanSelectionView();
		const selectedWorkflowAbsence = this.getSelectedWorkflowAbsence();
		const showReopenAbsence =
			isPlanSelectionView &&
			day_selection.length === 1 &&
			selectedWorkflowAbsence !== null;

		const published_text =
			group && group.published_until
				? this.props.t("plan.publishedUntilLabel", {
						date: moment(group.published_until).format("D MMMM YYYY"),
					})
				: this.props.t("plan.hidePlan");

		return (
			<>
				<FloatingBar
					selectedCount={isPlanSelectionView ? day_selection.length : 0}
					onClear={this.unselectAllDays}
					isSidebarDragging={this.state.isSidebarDragging}
					showActions={
						isPlanSelectionView && hasPrivileges && !this.state.planBtnState
					}
					onExchange={this.handleFloatingBarExchange}
					onLock={() => this.openLockSelectedModal(true)}
					onUnlock={() => this.openLockSelectedModal(false)}
					onRemove={this.handleRemoveShifts}
					showExchange={isPlanSelectionView && day_selection.length === 1}
					showReopenAbsence={showReopenAbsence}
					onReopenAbsence={this.handleFloatingBarReopenAbsence}
				/>
				<Layout
					context="plan"
					className={`page-plan ${
						this.state.planViewMode === "chart" ? "page-plan-chart" : ""
					}${isLocked || isPlanKO ? " plan-blocked" : ""}`}
				>
					<div className="full-height-wrapper">
						<div className="heading">
							<div className="heading-left">
								<h1 className="title">
									<span className="nombre-grupo">
										{group ? group.name : this.props.t("plans.title")}
									</span>
								</h1>

								{group && !group.is_multigroup && (
									<button
										onClick={this.openChangePublishedModal}
										type="button"
										className="published-until"
									>
										<HiClock className="icon icon-clock" />{" "}
										{published_text}
									</button>
								)}
							</div>
							<SwitchView
								viewMode={this.state.planViewMode}
								handleToggle={this.handleTogglePlanViewMode}
							/>

							{!no_contract && (hasPrivileges || isSupervisorReadOnly) && (
								<div className="heading-actions">
									{hasPrivileges && !this.state.planBtnState && (
										<>
											<button
												type="button"
												title={this.props.t("plan.planShiftRotations")}
												disabled={isLocked}
												onClick={this.autoPlan}
												className="btn btn-primary ml10"
											>
												<span className="btn-text-mobile">
													{this.props.t("plan.planShortBtn")}
												</span>
												<span className="btn-text-desktop">
													{this.props.t("plan.planShiftRotations")}
												</span>
											</button>

											{(() => {
												const hasAIPlanningSubscription =
													hasSubscriptionFeature("PLANNING_AI");
												const isSubscriptionBlocked =
													!hasAIPlanningSubscription;
												const isDisabled = isLocked || isSubscriptionBlocked;

												return (
													<button
														type="button"
														title={this.props.t("plan.intelligentPlan.title")}
														disabled={isLocked}
														onClick={(e) => {
															e.preventDefault();
															if (isLocked) {
																return;
															}
															if (hasAIPlanningSubscription) {
																this.openNewMagicPlan();
															} else {
																this.setState({
																	showUpgradeModal: true,
																	upgradeFeature: this.props.t(
																		"plan.intelligentPlan.title"
																	),
																});
															}
														}}
														className={`btn btn-outline-primary btn-wand btn-wand-icon ${
															isSubscriptionBlocked
																? "disabled-subscription"
																: ""
														}`}
														style={{
															opacity: isSubscriptionBlocked ? 0.5 : 1,
															cursor: isSubscriptionBlocked
																? "not-allowed"
																: isLocked
																	? "not-allowed"
																	: "pointer",
															position: "relative",
															pointerEvents: isSubscriptionBlocked
																? "auto"
																: "auto",
														}}
													>
														<FaMagic className="icon-wand mr-2" />
														{this.props.t("plan.planWithAI")}
														{isSubscriptionBlocked && (
															<FiLock
																style={{
																	fontSize: "0.7em",
																	marginLeft: "5px",
																	position: "absolute",
																	top: "2px",
																	right: "5px",
																}}
															/>
														)}
													</button>
												);
											})()}
										</>
									)}
									{this.state.planBtnState && (
										<button
											type="button"
											title={
												this.state.planBtnState === "FINISHED"
													? this.props.t("plan.intelligentPlan.viewPlan")
													: this.state.planBtnState === "PROCESSING"
														? this.props.t("plan.intelligentPlan.cancelBtn")
														: this.props.t("plan.intelligentPlan.inProgress")
											}
											disabled={isLocked}
											onClick={this.handleIntelligentPlanButtonClick}
											className={`btn btn-outline-primary btn-wand btn-wand-icon ${
												this.state.planBtnState === "PROCESSING"
													? "btn-cancel-intelligent"
													: ""
											}`}
											onMouseEnter={(e) => {
												if (this.state.planBtnState === "PROCESSING") {
													const planningTextElement =
														e.target.querySelector(".planning-text");
													if (planningTextElement) {
														planningTextElement.textContent =
															this.props.t("plan.intelligentPlan.cancelBtn") +
															" ";
													}
												}
											}}
											onMouseLeave={(e) => {
												if (this.state.planBtnState === "PROCESSING") {
													const planningTextElement =
														e.target.querySelector(".planning-text");
													if (planningTextElement) {
														planningTextElement.textContent =
															this.props.t("plan.intelligentPlan.processing") +
															" ";
													}
												}
											}}
										>
											<>
												<FaMagic className="icon-wand mr-2" />
												{this.state.planBtnState === "FINISHED" ? (
													this.props.t("plan.intelligentPlan.viewResult")
												) : (
													<>
														<span className="planning-text">
															{this.props.t(
																"plan.intelligentPlan.processing"
															)}{" "}
														</span>
														<ElapsedTimer
															startTime={this.state.planIntelligentTimerStart}
															isRunning={
																this.state.planIntelligentStatus?.state ===
																"PROCESSING"
															}
															// Sin maxTimeout para que el temporizador funcione indefinidamente
														/>
													</>
												)}
											</>
										</button>
									)}

									{hasPrivileges && (
										<>
											<button
												type="button"
												className={`btn btn-filter btn-maxmin ${
													showMax ? "active" : ""
												}`}
												title={`${
													!showMax ? "Maximizar plan" : "Minimizar plan"
												}`}
												onClick={() => this.toggleShowMax()}
											>
												{showMax ? (
													<HiOutlineArrowsPointingIn />
												) : (
													<HiOutlineArrowsPointingOut />
												)}
											</button>

											<button
												type="button"
												className="btn btn-filter btn-seleccionar"
												title={this.props.t("plan.selectAllShifts")}
												onClick={() => this.selectAllDays()}
												disabled={
													this.state.planBtnState || !this._isPlanLoadComplete()
												}
											>
												<HiOutlineCheck />
											</button>

											<button
												type="button"
												className="btn btn-action btn-copiar"
												title={this.props.t("plan.modal.copyPlan")}
												onClick={() => this.openPlanCopy()}
												disabled={
													this.state.planBtnState || !this._isPlanLoadComplete()
												}
											>
												<HiOutlineSquare2Stack />
											</button>

											<Dropdown
												className="dropdown-export"
												title={this.props.t("plan.lockUnlock")}
												disabled={!!this.state.planBtnState}
											>
												<Dropdown.Toggle
													variant="action"
													disabled={!!this.state.planBtnState}
												>
													<HiOutlineLockClosed />
												</Dropdown.Toggle>
												<Dropdown.Menu>
													<Dropdown.Item
														as="button"
														onClick={() =>
															this.openUnlockModal({
																presence_shifts_only: false,
															})
														}
													>
														<HiOutlineLockOpen />{" "}
														{this.props.t("plan.unlockAllShifts")}
													</Dropdown.Item>

													<Dropdown.Item
														as="button"
														onClick={() =>
															this.openUnlockModal({
																presence_shifts_only: true,
															})
														}
													>
														<HiOutlineLockOpen />{" "}
														{this.props.t("plan.unlockWorkShifts")}
													</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
										</>
									)}

									<Dropdown
										className="dropdown-export"
										title={this.props.t("common.export")}
										disabled={!this._isPlanLoadComplete()}
									>
										<Dropdown.Toggle
											variant="action"
											disabled={!this._isPlanLoadComplete()}
										>
											{/* <FiUpload className="dropdown-icon" /> */}
											<HiOutlineArrowUpOnSquare />
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item
												as="button"
												onClick={() => this.handleExportPlanificacion()}
											>
												<FaRegFileExcel className="dropdown-icon" />{" "}
												{this.props.t("plan.exportPlanShort")}
											</Dropdown.Item>

											<Dropdown.Item
												as="button"
												onClick={() => this.openPlanExport2PDF()}
											>
												<FaRegFilePdf className="dropdown-icon" />{" "}
												{this.props.t("plan.exportPlanPDF")}
											</Dropdown.Item>

											<Dropdown.Item
												as="button"
												onClick={() => this.handleExportPlanificacion("weekly")}
											>
												<FaRegFileExcel className="dropdown-icon" />{" "}
												{this.props.t("plan.exportPlanWeekly")}
											</Dropdown.Item>

											<Dropdown.Item
												as="button"
												onClick={() =>
													this.handleExportPlanificacion("detailed")
												}
											>
												<FaRegFileExcel className="dropdown-icon" />{" "}
												{this.props.t("plan.exportPlanDetailed")}
											</Dropdown.Item>

											<Dropdown.Item
												as="button"
												onClick={() => this.handleExportNeedsPDF()}
											>
												<FaRegFilePdf className="dropdown-icon" />{" "}
												{this.props.t("plan.exportNeedsPDF")}
											</Dropdown.Item>

											<Dropdown.Item
												as="button"
												onClick={() => this.handleExportShifts()}
											>
												<FaRegFileExcel className="dropdown-icon" />{" "}
												{this.props.t("plan.modal.exportShifts")}
											</Dropdown.Item>

											<Dropdown.Item
												as="button"
												onClick={() => this.handleExportPlanificacion("shifts")}
											>
												<FaRegFileExcel className="dropdown-icon" />{" "}
												{this.props.t("plan.exportShiftsImport")}
											</Dropdown.Item>

											<Dropdown.Item
												as="button"
												onClick={() => this.handleExportValoresCuentas()}
											>
												<FaRegFileExcel className="dropdown-icon" />{" "}
												{this.props.t("plan.exportAccounts")}
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>

									{this.renderCreateMenu()}

									<Dropdown title={this.props.t("plan.actions")}>
										<Dropdown.Toggle variant="action">
											<HiOutlineEllipsisHorizontal />
										</Dropdown.Toggle>
										<Dropdown.Menu>
											{hasPrivileges && (
												<>
													<Dropdown.Item
														as="button"
														onClick={() =>
															this.openGroupSettingsDrawer("info")
														}
													>
														<FiSettings className="dropdown-icon" />{" "}
														{this.props.t("plan.groupSettings")}
													</Dropdown.Item>
													{group && !group.is_multigroup && (
														<Dropdown.Item
															as="button"
															onClick={() =>
																this.openEmployeesOrderModal(group)
															}
														>
															<BiSortAlt2 />{" "}
															{this.props.t("plan.modal.sortEmployees")}
														</Dropdown.Item>
													)}
												</>
											)}
											<Dropdown.Item
												as="button"
												onClick={() => this.handleSetFunciones()}
											>
												<AiOutlineFunction className="dropdown-icon" />{" "}
												{this.props.t("plan.assignFunctionsDropdown")}
											</Dropdown.Item>
											<Dropdown.Item
												as="button"
												onClick={() => this.handleSetUbications()}
											>
												<FiMapPin className="dropdown-icon" />{" "}
												{this.props.t("plan.assignUbicationsDropdown")}
											</Dropdown.Item>
											<Dropdown.Item
												as="button"
												onClick={() => this.handleDeleteStaffingOverwrites()}
											>
												<FiTrash2 className="dropdown-icon" />{" "}
												{this.props.t("plan.deleteStaffingNeedsDropdown")}
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</div>
							)}
						</div>

						{isLocked && (
							<section className="bloque-plan">
								<div
									className="plan-pending"
									role="status"
									aria-live="polite"
									aria-busy="true"
								>
									<div
										className="plan-processing-spinner"
										aria-hidden="true"
									/>
									<h3 className="plan-processing-title">
										{this.props.t("plan.processingTitle")}
									</h3>
									<p className="plan-processing-message">
										{this.props.t("plan.processingMsg")}
									</p>
								</div>
							</section>
						)}

						{isPlanKO && (
							<section className="bloque-plan">
								<div className="plan-error">
									<PiSmileySadBold className="icono-plan" />
									<h3 className="title2">{this.props.t("common.error")}</h3>
									<p>{this.props.t("plan.errorCalculating")}</p>
									<p>{this.props.t("plan.errorCalculatingSupportMsg")}</p>
								</div>
							</section>
						)}

						{!isLocked && !isPlanKO && (
							<>
								{this.state.planViewMode === "grid" ? (
									<section className="bloque-plan">
										{!showMax && (
											<div className="heading gray">
												<div className="heading-left">
													{/* Select para pantallas pequeñas (tablet o menos) */}
													<FormControl
														as="select"
														className={`plan-view-select-mobile ${
															plan_option_ubications &&
															plan_option_ubications.length > 0
																? "plan-view-select-extended"
																: ""
														}`}
														value={plan_grid_view}
														onChange={(e) =>
															this.handleChangeView(Number(e.target.value))
														}
													>
														{this.getViewOptions().map((option) => (
															<option
																key={option.value}
																value={option.value}
																disabled={option.disabled}
															>
																{option.label}
																{option.disabled
																	? this.props.t("plan.view.onlyShortPeriod")
																	: ""}
															</option>
														))}
													</FormControl>

													{/* ButtonGroup para pantallas grandes */}
													<ButtonGroup
														className={`btn-group-view plan-view-buttons-desktop ${
															plan_option_ubications &&
															plan_option_ubications.length > 0
																? "plan-view-buttons-extended"
																: ""
														}`}
														aria-label="Plan view"
													>
														<Button
															variant={`${
																PLAN_GRID_VIEWS.default === plan_grid_view
																	? "primary"
																	: "default"
															}`}
															onClick={() =>
																this.handleChangeView(PLAN_GRID_VIEWS.default)
															}
														>
															{/* <PiGridFourFill className="icon" /> */}
															{this.props.t("plan.view.functions")}
														</Button>

														{/* <Button
															variant={`${PLAN_GRID_VIEWS.grid === plan_grid_view
																? "primary"
																: "default"
																}`}
															onClick={() =>
																this.handleChangeView(PLAN_GRID_VIEWS.grid)
															}
														>
															<FaTh className="icon" />
														</Button> */}

														{isLongPeriod ? (
															<OverlayTrigger
																placement="top"
																overlay={
																	<Tooltip id="tooltip-zoom">
																		Vista permitida solo para periodos menores a
																		7 días
																	</Tooltip>
																}
															>
																<span className="d-inline-block">
																	<Button
																		variant={
																			PLAN_GRID_VIEWS.hours === plan_grid_view
																				? "primary"
																				: "default"
																		}
																		disabled
																		style={{ pointerEvents: "none" }}
																	>
																		{/* <FaSearchPlus className="icon icon-zoom" /> */}
																		{this.props.t("plan.view.hours")}
																	</Button>
																</span>
															</OverlayTrigger>
														) : (
															<Button
																variant={
																	PLAN_GRID_VIEWS.hours === plan_grid_view
																		? "primary"
																		: "default"
																}
																onClick={() =>
																	this.handleChangeView(PLAN_GRID_VIEWS.hours)
																}
															>
																{/* <FaSearchPlus className="icon icon-zoom" /> */}
																{this.props.t("plan.view.hours")}
															</Button>
														)}

														<Button
															variant={`${
																PLAN_GRID_VIEWS.shifts === plan_grid_view
																	? "primary"
																	: "default"
															}`}
															onClick={() =>
																this.handleChangeView(PLAN_GRID_VIEWS.shifts)
															}
														>
															{this.props.t("plan.view.shifts")}
														</Button>

														{plan_option_ubications &&
															plan_option_ubications.length > 0 && (
																<>
																	<Button
																		variant={`${
																			PLAN_GRID_VIEWS.ubications ===
																			plan_grid_view
																				? "primary"
																				: "default"
																		}`}
																		onClick={() =>
																			this.handleChangeView(
																				PLAN_GRID_VIEWS.ubications
																			)
																		}
																	>
																		{/* <RiUserLocationFill className="icon" /> */}
																		{this.props.t("plan.view.ubications")}
																	</Button>

																	<Button
																		variant={`${
																			PLAN_GRID_VIEWS.ubication_grouped ===
																			plan_grid_view
																				? "primary"
																				: "default"
																		}`}
																		onClick={() =>
																			this.handleChangeView(
																				PLAN_GRID_VIEWS.ubication_grouped
																			)
																		}
																	>
																		{/* <FaMapMarkerAlt className="icon" /> */}
																		{this.props.t(
																			"plan.view.ubicationsGrouped"
																		)}
																	</Button>
																</>
															)}

														<Button
															variant={`${
																PLAN_GRID_VIEWS.grid === plan_grid_view
																	? "primary"
																	: "default"
															}`}
															onClick={() =>
																this.handleChangeView(PLAN_GRID_VIEWS.grid)
															}
														>
															{this.props.t("plan.view.simple")}
														</Button>

														{/* <Button
															variant={`${PLAN_GRID_VIEWS.vertical === plan_grid_view
																? "primary"
																: "default"
															}`}
															onClick={() =>
																this.handleChangeView(PLAN_GRID_VIEWS.vertical)
															}
														>
															<BiGridVertical className="icon icon-vertical" />
														</Button> */}
													</ButtonGroup>
												</div>
												<div className="heading-filters">
													<div className="plan-periodo-container">
														<button
															className="btn-transparent calendar-left"
															onClick={() => this.updatePeriod(-1)}
														>
															<HiOutlineChevronLeft />
														</button>

														<button
															type="button"
															className="plan-periodo"
															title={this.props.t("plan.openNewPlan")}
															onClick={() => this.openPlanOpener()}
														>
															{this.props.t("plan.periodRange", {
																start: start_format,
																end: end_format,
																year: end_year,
															})}
														</button>

														<button
															className="btn-transparent calendar-right"
															onClick={() => this.updatePeriod(1)}
														>
															<HiOutlineChevronRight />
														</button>
													</div>
													{hasPrivileges && !showMax && (
														<>
															{select_employees.length > 1 && (
																<PlanEmployeesMultiSelect
																	employees={select_employees}
																	value={selected_employee_ids}
																	onChange={this.handleEmployeesFilterChange}
																	placeholder={this.props.t(
																		"plan.filterByEmployee"
																	)}
																/>
															)}
															{plan_option_functions.length > 0 && (
																<PlanFunctionsMultiSelect
																	functions={plan_option_functions}
																	value={selected_function_ids}
																	onChange={this.handleFunctionsFilterChange}
																	placeholder={this.props.t(
																		"plan.filterByFunction"
																	)}
																	allLabel={this.props.t("plan.allFunctions")}
																	searchPlaceholder={this.props.t(
																		"plan.searchFunction"
																	)}
																	clearLabel={this.props.t(
																		"plan.clearSelection"
																	)}
																	noResultsLabel={this.props.t(
																		"plan.noFunctionsFound"
																	)}
																	selectedCountLabel={this.props.t(
																		"plan.selectedFunctionsCount"
																	)}
																	controlId="selected_function_ids"
																/>
															)}
															{plan_option_ubications.length > 0 && (
																<FormGroup
																	className="form-group"
																	controlId="ubication_id"
																>
																	<FormControl
																		type="text"
																		value={this.state.ubication_id}
																		onChange={this.handleChangeSearch}
																		as="select"
																	>
																		<option value="-1">
																			{this.props.t("plan.allUbications")}
																		</option>
																		{optionUbicationList}
																	</FormControl>
																</FormGroup>
															)}
														</>
													)}
												</div>
												<div className="heading-actions"></div>
											</div>
										)}

										<div
											className={`full-plan-container ${
												isExtendedView || !hasPrivileges
													? "extended-view"
													: "normal-view"
											} ${showMax ? "maximized" : ""}`}
										>
											{hasPrivileges &&
												(PLAN_GRID_VIEWS.default === plan_grid_view ||
													PLAN_GRID_VIEWS.grid === plan_grid_view ||
													PLAN_GRID_VIEWS.hours === plan_grid_view ||
													PLAN_GRID_VIEWS.vertical === plan_grid_view) &&
												this.getShiftFilter()}
											{hasPrivileges &&
												PLAN_GRID_VIEWS.ubications === plan_grid_view &&
												this.getComboFilter()}
											{this.getPlanContent()}
										</div>
									</section>
								) : this.state.graphicsLoading ? (
									<div className="plan-charts-loading">
										<div className="lds-spinner">
											<div></div>
											<div></div>
											<div></div>
											<div></div>
											<div></div>
											<div></div>
											<div></div>
											<div></div>
											<div></div>
											<div></div>
											<div></div>
											<div></div>
										</div>
									</div>
								) : this.state.assigmentsData.length > 0 ? (
									<ChartsFrame assigmentsData={this.state.assigmentsData} />
								) : (
									<ChartsEmptyState />
								)}
							</>
						)}

						{hasPrivileges &&
							!this.state.planBtnState &&
							this.state.planViewMode === "grid" && (
								<StaffingContextMenu isSelected={isNeedSelected} />
							)}
					</div>
				</Layout>

				<GroupEditDrawer
					isOpen={this.state.groupDrawerOpen}
					onClose={this.closeGroupSettingsDrawer}
					group={this.state.group}
					groupId={this.state.group_id}
					initialTab={this.state.groupDrawerTab}
					autoOpenCreateNeed={this.state.groupDrawerOpenCreateNeed}
				/>

				<Modal hideModal={this.props.hideModal} />

				<PlanMagicPrerequisitesModal
					isOpen={this.state.magicPrerequisitesMissing.length > 0}
					missing={this.state.magicPrerequisitesMissing}
					functionEmployees={this.state.magicPlanFunctionsSnapshot}
					unresolvedFunctionIds={this.state.magicPlanUnresolvedFunctionIds}
					onClose={this.closeMagicPrerequisites}
					onAssignFunctions={this.openMagicPlanFunctionsFix}
					onConfigureAvailability={this.openMagicPlanAvailabilityFix}
					onDefineStaffing={this.openMagicPlanStaffingFix}
				/>

				<PlanMissingContractModal
					isOpen={this.state.missingContractPromptEntries.length > 0}
					entries={this.state.missingContractPromptEntries}
					onClose={this.closePlanMissingContractPrompt}
					onAssignContract={this.handlePlanMissingContractAssign}
				/>

				<PlanUserMissingContractModal
					isOpen={this.state.userMissingContractModalOpen}
					onClose={this.closeUserMissingContractModal}
					onAssignContract={this.handleUserMissingContractAssign}
					canAssignContract={isAdmin()}
				/>

				{this.state.magicModalOpen && (
					<PlanMagicModalV2
						group_id={this.state.group_id}
						group={this.state.group}
						start={this.state.start}
						end={this.state.end}
						assigmentsData={this.state.assigmentsData}
						planAssignments={this.state.plan_assignments}
						loadAssignmentsGraphics={() => this.loadGraphicsData({ force: true })}
						handleClose={() => this.setState({ magicModalOpen: false })}
						onPlanProcessing={(response, timelimit, isIterative) => {
							// Tras FINISHED/ERROR el watcher para el polling; sin esto
							// sólo el estado local pasa a PROCESSING y el cliente queda
							// muerto hasta recargar si el WS falla.
							plansSocketService.reviveIntelligentWatchAfterQueuedJob(
								this.state.group_id,
								this.handleIntelligentPlanningMessage,
								Boolean(isIterative)
							);
							this.setState({
								planBtnState: "PROCESSING",
								planIntelligentStatus: {
									state: "PROCESSING",
									start: moment(),
								},
								planIntelligentTimerStart: moment(),
								magicModalOpen: false,
							});
							this.unselectAllDays();
						}}
					/>
				)}

				{/* Modal de upgrade para funcionalidades bloqueadas */}
				<UpgradeModal
					show={this.state.showUpgradeModal}
					onClose={() => this.setState({ showUpgradeModal: false })}
					feature={this.state.upgradeFeature}
					requiredPlan="Pro"
				/>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.functionsReducer,
		...reducers.employeesReducer,
		...reducers.shiftsReducer,
		...reducers.rulesReducer,
		...reducers.timesReducer,
		...reducers.plansReducer,
		...reducers.groupsReducer,
		...reducers.ubicationsReducer,
		...reducers.calendarsReducer,
		user: reducers.authReducer.user,
		loading: reducers.plansReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
	getDefaultShift: () => dispatch(shiftsActions.getDefaultShift()),
	getWorkingHours: () => dispatch(shiftsActions.getWorkingHours()),
	removeLoading: () => dispatch(plansActions.removeLoading()),
	setPlanAssignments: (options) =>
		dispatch(plansActions.setPlanAssignments(options)),
	getPlanViews: () => dispatch(plansActions.getPlanViews()),
	getPlanViewScopes: () => dispatch(plansActions.getPlanViewScopes()),
	getDefaultPlanView: () => dispatch(plansActions.getDefaultPlanView()),
	getAccountAssignments: (options) =>
		dispatch(rulesActions.getAccountAssignments(options)),
	getAccounts: () => dispatch(rulesActions.getAccounts()),
	getRules: () => dispatch(rulesActions.getCalculatedRules()),
	getStaffingLevelAssignments: (options) =>
		dispatch(groupsActions.getStaffingLevelAssignments(options)),
	getStaffingLevelCurrentAssignments: (options) =>
		dispatch(groupsActions.getStaffingLevelCurrentAssignments(options)),
	getStaffingLevelHourlyAssignments: (options) =>
		dispatch(groupsActions.getStaffingLevelHourlyAssignments(options)),
	getPlanDays: (group_id, start, end) =>
		dispatch(plansActions.getPlanDays(group_id, start, end)),
	getAllShifts: (options) => dispatch(shiftsActions.getAllShifts(options)), // necessitem tots, no selectable, per poder agafar tota la info
	getAbsenceShifts: () =>
		dispatch(
			shiftsActions.getAllShifts({
				shift_type: shiftTypeQuery.absence,
				contract_only: true,
			})
		),
	getAttendanceShifts: () => dispatch(shiftsActions.getAttendanceShifts()),
	getShiftTypes: () => dispatch(shiftsActions.getShiftTypes()),
	getSelectableFunctions: () =>
		dispatch(functionsActions.getSelectableFunctions()),
	getSelectableTimeTypes: () => dispatch(timesActions.getSelectableTimeTypes()),
	getSelectableUbications: (options) =>
		dispatch(ubicationsActions.getSelectableUbications(options)),
	getSelectableEmployees: (options) =>
		dispatch(employeesActions.getSelectableEmployees(options)), // autosuggest filter
	getContracts: (options) => dispatch(rulesActions.getContracts(options)),
	getEmployeeContracts: (employeeId) =>
		dispatch(employeesActions.getEmployeeContracts(employeeId)),
	getSelectableStaffingLevels: () =>
		dispatch(groupsActions.getSelectableStaffingLevels()),
	getGroupStaffingLevels: (groupId) =>
		dispatch(groupsActions.getGroupStaffingLevels(groupId)),
	getAllGroups: () => dispatch(groupsActions.getAllGroups()),
	getDefaultTimeType: () => dispatch(timesActions.getDefaultTimeType()),
	getSelectableDayTypes: () =>
		dispatch(calendarsActions.getSelectableDayTypes()),
	registerUndoAndShowToast: (payload) =>
		dispatch(registerUndoAndShowToast(payload)),
	clearUndoScope: (scope) => dispatch(clearUndoScope(scope)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(Plan));
